function set_view_page_num(page_num){

	httpObj = new XMLHttpRequest();
	httpObj.open("POST", "./json/?function=flight&action_code=fare_list&json=set_view_page_num", true);
	httpObj.setRequestHeader("Content-Type","application/x-www-form-urlencoded");
  	httpObj.send("page_num="+ page_num);

  	httpObj.onreadystatechange = function() {

        if (httpObj.readyState == 4) {

			ret_str											= JSON.parse(httpObj.responseText).fare_list;
			document.getElementById("fare_list").innerHTML 	= ret_str;
			window.location.reload(0);
		}
    }
}


function set_page_num(page_num){

	httpObj = new XMLHttpRequest();
	httpObj.open("POST", "./json/?function=flight&action_code=fare_list&json=set_page_num", true);
	httpObj.setRequestHeader("Content-Type","application/x-www-form-urlencoded");
  	httpObj.send("page_num="+ page_num);

  	httpObj.onreadystatechange = function() {

        if (httpObj.readyState == 4) {

			ret_str											= JSON.parse(httpObj.responseText).fare_list;
			document.getElementById("fare_list").innerHTML 	= "";
            document.getElementById("fare_list").innerHTML 	= ret_str;

			window.location.reload(0);
		}
    }
}

function set_fare_value(flt,fare_param_name,fare_value){


	if($('.flight-distance-info-inner').length) {
		var radioList = $(".flight-distance-info-inner");
		var num = 1;
		radioList.each(function() {
			var radioLabel = $(this).find("label");
			radioLabel.filter(".result-rdo-on").removeClass("result-rdo-on");
			if($("#slice_" + num).prop('checked')){

				radioLabel.find(":checked").closest(radioLabel).addClass("result-rdo-on");
			}else{

			}
			num++;

		});
	}
}

function ___submit_fare(obj){

	obj.action = "./?function=flight&action_code=flight_list_init";
	obj.submit();
}


function ___submit_fare_it(obj){

	obj.action = "./?function=flight&action_code=flight_list_it_waiting";
	obj.submit();
}

function reset_value_result(obj){

/*
	for(i = 0;i < obj.length;i++){

//alert(obj[i].checked);
		if(obj[i].checked != true){

			obj[i].checked = false;
		}
	}
*/
//	alert(obj.length);
//	for(){}
//	obj.value = "";
}

/*
$(function() {
	$(".datepicker").datepicker();
});
*/


var depairPort     = new Object();
var area1          = new Object();
var area2          = new Object();
var area3          = new Object();
var area4          = new Object();
var area5          = new Object();
var area6          = new Object();

var defAirLine = new Object();
area1['TC3_4'] = new Object();
area1['TC3_4'] = '韓国・台湾';
area1['TC3_1'] = new Object();
area1['TC3_1'] = '中国・香港・マカオ';
area1['TC3_2'] = new Object();
area1['TC3_2'] = 'アジア';
area1['TC1_2'] = new Object();
area1['TC1_2'] = 'ハワイ';
area1['TC1_1'] = new Object();
area1['TC1_1'] = '北米';
area1['TC2_1'] = new Object();
area1['TC2_1'] = 'ヨーロッパ';
area1['TC3_3'] = new Object();
area1['TC3_3'] = 'オセアニア';
area1['TC3_5'] = new Object();
area1['TC3_5'] = 'ミクロネシア';
area1['TC2_2'] = new Object();
area1['TC2_2'] = '中東・アフリカ';
area1['TC1_3'] = new Object();
area1['TC1_3'] = '中米・南米';
area2['T2_2'] = new Object();
area2['T2_2']['SDN'] = new Object();
area2['T2_2']['SDN'] = 'スーダン';
area2['TC1'] = new Object();
area2['TC1']['GRD'] = new Object();
area2['TC1']['GRD'] = 'グレナダ ';
area2['TC1_1'] = new Object();
area2['TC1_1']['USA'] = new Object();
area2['TC1_1']['USA'] = 'アメリカ合衆国';
area2['TC1_1']['CAN'] = new Object();
area2['TC1_1']['CAN'] = 'カナダ';
area2['TC1_2'] = new Object();
area2['TC1_2']['HWI'] = new Object();
area2['TC1_2']['HWI'] = 'ハワイ';
area2['TC1_3'] = new Object();
area2['TC1_3']['ARG'] = new Object();
area2['TC1_3']['ARG'] = 'アルゼンチン';
area2['TC1_3']['BRA'] = new Object();
area2['TC1_3']['BRA'] = 'ブラジル';
area2['TC1_3']['PER'] = new Object();
area2['TC1_3']['PER'] = 'ペルー';
area2['TC1_3']['MEX'] = new Object();
area2['TC1_3']['MEX'] = 'メキシコ';
area2['TC1_3']['BOL'] = new Object();
area2['TC1_3']['BOL'] = 'ボリビア';
area2['TC1_3']['CUB'] = new Object();
area2['TC1_3']['CUB'] = 'キューバ';
area2['TC1_3']['COL'] = new Object();
area2['TC1_3']['COL'] = 'コロンビア';
area2['TC1_3']['JAM'] = new Object();
area2['TC1_3']['JAM'] = 'ジャマイカ';
area2['TC1_3']['ECU'] = new Object();
area2['TC1_3']['ECU'] = 'エクアドル';
area2['TC1_3']['CHL'] = new Object();
area2['TC1_3']['CHL'] = 'チリ';
area2['TC1_3']['BLZ'] = new Object();
area2['TC1_3']['BLZ'] = 'ベリーズ';
area2['TC1_3']['PRI'] = new Object();
area2['TC1_3']['PRI'] = 'プエルトリコ';
area2['TC1_3']['VEN'] = new Object();
area2['TC1_3']['VEN'] = 'ベネスエラ';
area2['TC1_3']['HTI'] = new Object();
area2['TC1_3']['HTI'] = 'ハイチ';
area2['TC1_3']['PAN'] = new Object();
area2['TC1_3']['PAN'] = 'パナマ';
area2['TC1_3']['PRY'] = new Object();
area2['TC1_3']['PRY'] = 'パラグアイ';
area2['TC1_3']['SLV'] = new Object();
area2['TC1_3']['SLV'] = 'エルサルバドル';
area2['TC1_3']['TTO'] = new Object();
area2['TC1_3']['TTO'] = 'トリニダートトバコ';
area2['TC1_3']['URY'] = new Object();
area2['TC1_3']['URY'] = 'ウルグアイ';
area2['TC1_3']['HND'] = new Object();
area2['TC1_3']['HND'] = 'ホンジュラス';
area2['TC1_3']['DMA'] = new Object();
area2['TC1_3']['DMA'] = 'ドミニカ共和国';
area2['TC1_3']['CRI'] = new Object();
area2['TC1_3']['CRI'] = 'コスタリカ';
area2['TC1_3']['BHS'] = new Object();
area2['TC1_3']['BHS'] = 'バハマ';
area2['TC1_3']['ATG'] = new Object();
area2['TC1_3']['ATG'] = 'アンティグアバーブーダ';
area2['TC1_3']['CUW'] = new Object();
area2['TC1_3']['CUW'] = 'キュラソー島';
area2['TC1_3']['NIC'] = new Object();
area2['TC1_3']['NIC'] = 'ニカラグア';
area2['TC1_3']['SUR'] = new Object();
area2['TC1_3']['SUR'] = 'スリナム';
area2['TC1_3']['GUY'] = new Object();
area2['TC1_3']['GUY'] = 'ガイアナ';
area2['TC1_3']['BRB'] = new Object();
area2['TC1_3']['BRB'] = 'バルバドス';
area2['TC2_1'] = new Object();
area2['TC2_1']['GBR'] = new Object();
area2['TC2_1']['GBR'] = 'イギリス';
area2['TC2_1']['FRA'] = new Object();
area2['TC2_1']['FRA'] = 'フランス';
area2['TC2_1']['DEU'] = new Object();
area2['TC2_1']['DEU'] = 'ドイツ';
area2['TC2_1']['ITA'] = new Object();
area2['TC2_1']['ITA'] = 'イタリア';
area2['TC2_1']['ESP'] = new Object();
area2['TC2_1']['ESP'] = 'スペイン';
area2['TC2_1']['RUS'] = new Object();
area2['TC2_1']['RUS'] = 'ロシア';
area2['TC2_1']['PRT'] = new Object();
area2['TC2_1']['PRT'] = 'ポルトガル';
area2['TC2_1']['CZE'] = new Object();
area2['TC2_1']['CZE'] = 'チェコ';
area2['TC2_1']['POL'] = new Object();
area2['TC2_1']['POL'] = 'ポーランド';
area2['TC2_1']['NLD'] = new Object();
area2['TC2_1']['NLD'] = 'オランダ';
area2['TC2_1']['BEL'] = new Object();
area2['TC2_1']['BEL'] = 'ベルギー';
area2['TC2_1']['SVK'] = new Object();
area2['TC2_1']['SVK'] = 'スロバキア';
area2['TC2_1']['GRC'] = new Object();
area2['TC2_1']['GRC'] = 'ギリシャ';
area2['TC2_1']['MLT'] = new Object();
area2['TC2_1']['MLT'] = 'マルタ';
area2['TC2_1']['BGR'] = new Object();
area2['TC2_1']['BGR'] = 'ブルガリア';
area2['TC2_1']['HUN'] = new Object();
area2['TC2_1']['HUN'] = 'ハンガリー';
area2['TC2_1']['AUT'] = new Object();
area2['TC2_1']['AUT'] = 'オーストリア';
area2['TC2_1']['CHE'] = new Object();
area2['TC2_1']['CHE'] = 'スイス';
area2['TC2_1']['FIN'] = new Object();
area2['TC2_1']['FIN'] = 'フィンランド';
area2['TC2_1']['SWE'] = new Object();
area2['TC2_1']['SWE'] = 'スウェーデン';
area2['TC2_1']['NOR'] = new Object();
area2['TC2_1']['NOR'] = 'ノルウェー';
area2['TC2_1']['HRV'] = new Object();
area2['TC2_1']['HRV'] = 'クロアチア';
area2['TC2_1']['DNK'] = new Object();
area2['TC2_1']['DNK'] = 'デンマーク';
area2['TC2_1']['IRL'] = new Object();
area2['TC2_1']['IRL'] = 'アイルランド';
area2['TC2_1']['ROU'] = new Object();
area2['TC2_1']['ROU'] = 'ルーマニア';
area2['TC2_1']['SVN'] = new Object();
area2['TC2_1']['SVN'] = 'スロベニア';
area2['TC2_1']['UKR'] = new Object();
area2['TC2_1']['UKR'] = 'ウクライナ';
area2['TC2_1']['LTU'] = new Object();
area2['TC2_1']['LTU'] = 'リトアニア';
area2['TC2_1']['BLR'] = new Object();
area2['TC2_1']['BLR'] = 'ベラルーシ';
area2['TC2_1']['EST'] = new Object();
area2['TC2_1']['EST'] = 'エストニア';
area2['TC2_1']['ALB'] = new Object();
area2['TC2_1']['ALB'] = 'アルバニア';
area2['TC2_1']['SRB'] = new Object();
area2['TC2_1']['SRB'] = 'セルビア共和国';
area2['TC2_1']['XUS'] = new Object();
area2['TC2_1']['XUS'] = 'ロシア ( 極東 )';
area2['TC2_1']['MNE'] = new Object();
area2['TC2_1']['MNE'] = 'モンテネグロ';
area2['TC2_1']['AZE'] = new Object();
area2['TC2_1']['AZE'] = 'アゼルバイジャン';
area2['TC2_1']['ARM'] = new Object();
area2['TC2_1']['ARM'] = 'アルメニア';
area2['TC2_1']['MDA'] = new Object();
area2['TC2_1']['MDA'] = 'モルドバ';
area2['TC2_1']['ISL'] = new Object();
area2['TC2_1']['ISL'] = 'アイスランド共和国';
area2['TC2_1']['LVA'] = new Object();
area2['TC2_1']['LVA'] = 'ラトビア';
area2['TC2_1']['MKD'] = new Object();
area2['TC2_1']['MKD'] = '北マケドニア ';
area2['TC2_1']['BIH'] = new Object();
area2['TC2_1']['BIH'] = 'ボスニア・ヘルツェゴヴィナ';
area2['TC2_1']['GEO'] = new Object();
area2['TC2_1']['GEO'] = 'ジョージア';
area2['TC2_1']['CYP'] = new Object();
area2['TC2_1']['CYP'] = 'キプロス';
area2['TC2_1']['LUX'] = new Object();
area2['TC2_1']['LUX'] = 'ルクセンブルク';
area2['TC2_2'] = new Object();
area2['TC2_2']['ARE'] = new Object();
area2['TC2_2']['ARE'] = 'アラブ首長国連邦';
area2['TC2_2']['EGY'] = new Object();
area2['TC2_2']['EGY'] = 'エジプト';
area2['TC2_2']['ETH'] = new Object();
area2['TC2_2']['ETH'] = 'エチオピア';
area2['TC2_2']['RWA'] = new Object();
area2['TC2_2']['RWA'] = 'ルワンダ';
area2['TC2_2']['TUR'] = new Object();
area2['TC2_2']['TUR'] = 'トルコ';
area2['TC2_2']['UGA'] = new Object();
area2['TC2_2']['UGA'] = 'ウガンダ';
area2['TC2_2']['TUN'] = new Object();
area2['TC2_2']['TUN'] = 'チュニジア';
area2['TC2_2']['ISR'] = new Object();
area2['TC2_2']['ISR'] = 'イスラエル';
area2['TC2_2']['JOR'] = new Object();
area2['TC2_2']['JOR'] = 'ヨルダン';
area2['TC2_2']['SAU'] = new Object();
area2['TC2_2']['SAU'] = 'サウジアラビア';
area2['TC2_2']['MAR'] = new Object();
area2['TC2_2']['MAR'] = 'モロッコ';
area2['TC2_2']['MDG'] = new Object();
area2['TC2_2']['MDG'] = 'マダガスカル';
area2['TC2_2']['ZAF'] = new Object();
area2['TC2_2']['ZAF'] = '南アフリカ';
area2['TC2_2']['ZWE'] = new Object();
area2['TC2_2']['ZWE'] = 'ジンバブエ';
area2['TC2_2']['TZA'] = new Object();
area2['TC2_2']['TZA'] = 'タンザニア';
area2['TC2_2']['GHA'] = new Object();
area2['TC2_2']['GHA'] = 'ガーナ';
area2['TC2_2']['CIV'] = new Object();
area2['TC2_2']['CIV'] = 'コートジボワール';
area2['TC2_2']['MWI'] = new Object();
area2['TC2_2']['MWI'] = 'マラウイ';
area2['TC2_2']['COD'] = new Object();
area2['TC2_2']['COD'] = 'コンゴ民主共和国';
area2['TC2_2']['LBN'] = new Object();
area2['TC2_2']['LBN'] = 'レバノン';
area2['TC2_2']['GNQ'] = new Object();
area2['TC2_2']['GNQ'] = '赤道ギニア';
area2['TC2_2']['QAT'] = new Object();
area2['TC2_2']['QAT'] = 'カタール';
area2['TC2_2']['CMR'] = new Object();
area2['TC2_2']['CMR'] = 'カメルーン';
area2['TC2_2']['LBR'] = new Object();
area2['TC2_2']['LBR'] = 'リベリア';
area2['TC2_2']['GAB'] = new Object();
area2['TC2_2']['GAB'] = 'ガボン';
area2['TC2_2']['COG'] = new Object();
area2['TC2_2']['COG'] = 'コンゴ共和国';
area2['TC2_2']['SEN'] = new Object();
area2['TC2_2']['SEN'] = 'セネガル';
area2['TC2_2']['MLI'] = new Object();
area2['TC2_2']['MLI'] = 'マリ';
area2['TC2_2']['KEN'] = new Object();
area2['TC2_2']['KEN'] = 'ケニア';
area2['TC2_2']['BHR'] = new Object();
area2['TC2_2']['BHR'] = 'バーレーン';
area2['TC2_2']['DZA'] = new Object();
area2['TC2_2']['DZA'] = 'アルジェリア';
area2['TC2_2']['MUS'] = new Object();
area2['TC2_2']['MUS'] = 'モーリシャス';
area2['TC2_2']['OMN'] = new Object();
area2['TC2_2']['OMN'] = 'オマーン';
area2['TC2_2']['SYC'] = new Object();
area2['TC2_2']['SYC'] = 'セーシェル';
area2['TC2_2']['BWA'] = new Object();
area2['TC2_2']['BWA'] = 'ボツワナ';
area2['TC2_2']['IRN'] = new Object();
area2['TC2_2']['IRN'] = 'イラン';
area2['TC2_2']['MOZ'] = new Object();
area2['TC2_2']['MOZ'] = 'モザンビーク';
area2['TC2_2']['ERI'] = new Object();
area2['TC2_2']['ERI'] = 'エリトリア';
area2['TC2_2']['DJI'] = new Object();
area2['TC2_2']['DJI'] = 'ジブチ';
area2['TC2_2']['BEN'] = new Object();
area2['TC2_2']['BEN'] = 'ベナン';
area2['TC2_2']['SYR'] = new Object();
area2['TC2_2']['SYR'] = 'シリア';
area2['TC2_2']['ZMB'] = new Object();
area2['TC2_2']['ZMB'] = 'ザンビア';
area2['TC2_2']['BFA'] = new Object();
area2['TC2_2']['BFA'] = 'ブルキナファソ';
area2['TC2_2']['SLE'] = new Object();
area2['TC2_2']['SLE'] = 'シエラレオネ';
area2['TC2_2']['GIN'] = new Object();
area2['TC2_2']['GIN'] = 'ギニア';
area2['TC2_2']['GNB'] = new Object();
area2['TC2_2']['GNB'] = 'ギニアビサウ';
area2['TC2_2']['GMB'] = new Object();
area2['TC2_2']['GMB'] = 'ガンビア';
area2['TC2_2']['NER'] = new Object();
area2['TC2_2']['NER'] = 'ニジェール';
area2['TC2_2']['MRT'] = new Object();
area2['TC2_2']['MRT'] = 'モーリタニア';
area2['TC2_2']['TGO'] = new Object();
area2['TC2_2']['TGO'] = 'トーゴ';
area2['TC2_2']['SSD'] = new Object();
area2['TC2_2']['SSD'] = '南スーダン';
area2['TC2_2']['KWT'] = new Object();
area2['TC2_2']['KWT'] = 'クウェート';
area2['TC2_2']['IRQ'] = new Object();
area2['TC2_2']['IRQ'] = 'イラク';
area2['TC2_2']['BDI'] = new Object();
area2['TC2_2']['BDI'] = 'ブルンジ';
area2['TC2_2']['NAM'] = new Object();
area2['TC2_2']['NAM'] = 'ナミビア';
area2['TC2_2']['AGO'] = new Object();
area2['TC2_2']['AGO'] = 'アンゴラ';
area2['TC2_2']['CPV'] = new Object();
area2['TC2_2']['CPV'] = 'カーボベルデ';
area2['TC2_2']['CAF'] = new Object();
area2['TC2_2']['CAF'] = '中央アフリカ';
area2['TC2_2']['TCD'] = new Object();
area2['TC2_2']['TCD'] = 'チャド';
area2['TC2_2']['COM'] = new Object();
area2['TC2_2']['COM'] = 'コモロ';
area2['TC2_2']['LSO'] = new Object();
area2['TC2_2']['LSO'] = 'レソト';
area2['TC3_1'] = new Object();
area2['TC3_1']['CHN'] = new Object();
area2['TC3_1']['CHN'] = '中国';
area2['TC3_1']['HKG'] = new Object();
area2['TC3_1']['HKG'] = '香港';
area2['TC3_1']['MAC'] = new Object();
area2['TC3_1']['MAC'] = 'マカオ';
area2['TC3_2'] = new Object();
area2['TC3_2']['THA'] = new Object();
area2['TC3_2']['THA'] = 'タイ';
area2['TC3_2']['PHL'] = new Object();
area2['TC3_2']['PHL'] = 'フィリピン';
area2['TC3_2']['SGP'] = new Object();
area2['TC3_2']['SGP'] = 'シンガポール';
area2['TC3_2']['MYS'] = new Object();
area2['TC3_2']['MYS'] = 'マレーシア';
area2['TC3_2']['KHM'] = new Object();
area2['TC3_2']['KHM'] = 'カンボジア';
area2['TC3_2']['LAO'] = new Object();
area2['TC3_2']['LAO'] = 'ラオス';
area2['TC3_2']['NPL'] = new Object();
area2['TC3_2']['NPL'] = 'ネパール';
area2['TC3_2']['VNM'] = new Object();
area2['TC3_2']['VNM'] = 'ベトナム';
area2['TC3_2']['LKA'] = new Object();
area2['TC3_2']['LKA'] = 'スリランカ';
area2['TC3_2']['IND'] = new Object();
area2['TC3_2']['IND'] = 'インド';
area2['TC3_2']['IDN'] = new Object();
area2['TC3_2']['IDN'] = 'インドネシア';
area2['TC3_2']['BRN'] = new Object();
area2['TC3_2']['BRN'] = 'ブルネイ　';
area2['TC3_2']['AFG'] = new Object();
area2['TC3_2']['AFG'] = 'アフガニスタン';
area2['TC3_2']['MNG'] = new Object();
area2['TC3_2']['MNG'] = 'モンゴル';
area2['TC3_2']['PAK'] = new Object();
area2['TC3_2']['PAK'] = 'パキスタン';
area2['TC3_2']['UZB'] = new Object();
area2['TC3_2']['UZB'] = 'ウズベキスタン';
area2['TC3_2']['MMR'] = new Object();
area2['TC3_2']['MMR'] = 'ミャンマー';
area2['TC3_2']['KG'] = new Object();
area2['TC3_2']['KG'] = 'キルギス';
area2['TC3_2']['MDV'] = new Object();
area2['TC3_2']['MDV'] = 'モルディブ';
area2['TC3_2']['TJK'] = new Object();
area2['TC3_2']['TJK'] = 'タジキスタン';
area2['TC3_2']['TKM'] = new Object();
area2['TC3_2']['TKM'] = 'トルクメニスタン';
area2['TC3_2']['BTN'] = new Object();
area2['TC3_2']['BTN'] = 'ブータン';
area2['TC3_2']['BGD'] = new Object();
area2['TC3_2']['BGD'] = 'バングラデシュ';
area2['TC3_2']['KAZ'] = new Object();
area2['TC3_2']['KAZ'] = 'カザフスタン';
area2['TC3_3'] = new Object();
area2['TC3_3']['AUS'] = new Object();
area2['TC3_3']['AUS'] = 'オーストラリア';
area2['TC3_3']['NZL'] = new Object();
area2['TC3_3']['NZL'] = 'ニュージーランド';
area2['TC3_3']['PNG'] = new Object();
area2['TC3_3']['PNG'] = 'パプアニューギニア';
area2['TC3_3']['SLB'] = new Object();
area2['TC3_3']['SLB'] = 'ソロモン諸島';
area2['TC3_3']['TUV'] = new Object();
area2['TC3_3']['TUV'] = 'ツバル';
area2['TC3_3']['WSM'] = new Object();
area2['TC3_3']['WSM'] = 'サモア';
area2['TC3_3']['PYF'] = new Object();
area2['TC3_3']['PYF'] = 'タヒチ';
area2['TC3_3']['TON'] = new Object();
area2['TC3_3']['TON'] = 'トンガ';
area2['TC3_3']['NCL'] = new Object();
area2['TC3_3']['NCL'] = 'ニューカレドニア';
area2['TC3_3']['FJI'] = new Object();
area2['TC3_3']['FJI'] = 'フィジー';
area2['TC3_3']['VUT'] = new Object();
area2['TC3_3']['VUT'] = 'バヌアツ共和国';
area2['TC3_3']['NRU'] = new Object();
area2['TC3_3']['NRU'] = 'ナウル';
area2['TC3_4'] = new Object();
area2['TC3_4']['KOR'] = new Object();
area2['TC3_4']['KOR'] = '韓国';
area2['TC3_4']['TWN'] = new Object();
area2['TC3_4']['TWN'] = '台湾';
area2['TC3_5'] = new Object();
area2['TC3_5']['GUM'] = new Object();
area2['TC3_5']['GUM'] = 'グアム';
area2['TC3_5']['SPN'] = new Object();
area2['TC3_5']['SPN'] = 'サイパン';
area2['TC3_5']['KIR'] = new Object();
area2['TC3_5']['KIR'] = 'キリバス';
area2['TC3_5']['PLW'] = new Object();
area2['TC3_5']['PLW'] = 'パラオ';
area2['TC3_5']['MHL'] = new Object();
area2['TC3_5']['MHL'] = 'マーシャル諸島';
area2['TC3_5']['ROP'] = new Object();
area2['TC3_5']['ROP'] = 'ロタ';
area2['TC3_5']['FSM'] = new Object();
area2['TC3_5']['FSM'] = 'ミクロネシア連邦';
area3['AGO'] = new Object();
area3['AGO']['LAD'] = '';
area4['LAD'] = 'TC2_2';
area5['LAD'] = 'AGO';

area6['LAD'] = new Object();
area6['LAD'] = '';
area3['ALB'] = new Object();
area3['ALB']['TIA'] = '★ティラナ';
area4['TIA'] = 'TC2_1';
area5['TIA'] = 'ALB';

area6['TIA'] = new Object();
area6['TIA'] = '★ティラナ';
area3['ARE'] = new Object();
area3['ARE']['AUH'] = '★アブダビ';
area4['AUH'] = 'TC2_2';
area5['AUH'] = 'ARE';

area6['AUH'] = new Object();
area6['AUH'] = '★アブダビ';
area3['ARE']['DXB'] = '★ドバイ国際空港';
area4['DXB'] = 'TC2_2';
area5['DXB'] = 'ARE';

area6['DXB'] = new Object();
area6['DXB'] = '★ドバイ国際空港';
area3['ARE']['SHJ'] = 'シャールジャ';
area4['SHJ'] = 'TC2_2';
area5['SHJ'] = 'ARE';

area6['SHJ'] = new Object();
area6['SHJ'] = 'シャールジャ';
area3['ARE']['DWC'] = 'ドバイ（アール・マクトゥーム国際空港）';
area4['DWC'] = 'TC2_2';
area5['DWC'] = 'ARE';

area6['DWC'] = new Object();
area6['DWC'] = 'ドバイ（アール・マクトゥーム国際空港）';
area3['ARE']['XNB'] = 'ドバイ（マザヤ・センターＢＳ）';
area4['XNB'] = 'TC2_2';
area5['XNB'] = 'ARE';

area6['XNB'] = new Object();
area6['XNB'] = 'ドバイ（マザヤ・センターＢＳ）';
area3['ARG'] = new Object();
area3['ARG']['BUE'] = 'ブエノスアイレス';
area4['BUE'] = 'TC1_3';
area5['BUE'] = 'ARG';

area6['BUE'] = new Object();
area6['BUE'] = 'ブエノスアイレス';
area3['ARG']['COR'] = 'コルドバ';
area4['COR'] = 'TC1_3';
area5['COR'] = 'ARG';

area6['COR'] = new Object();
area6['COR'] = 'コルドバ';
area3['ARG']['USH'] = 'ウシュアイア';
area4['USH'] = 'TC1_3';
area5['USH'] = 'ARG';

area6['USH'] = new Object();
area6['USH'] = 'ウシュアイア';
area3['ARG']['AEP'] = 'ブエノスアイレス（ホルヘ・ニューベリー）';
area4['AEP'] = 'TC1_3';
area5['AEP'] = 'ARG';

area6['AEP'] = new Object();
area6['AEP'] = 'ブエノスアイレス（ホルヘ・ニューベリー）';
area3['ARG']['EZE'] = 'ブエノスアイレス（エセイサ国際空港）';
area4['EZE'] = 'TC1_3';
area5['EZE'] = 'ARG';

area6['EZE'] = new Object();
area6['EZE'] = 'ブエノスアイレス（エセイサ国際空港）';
area3['ARM'] = new Object();
area3['ARM']['EVN'] = '★エレバン';
area4['EVN'] = 'TC2_1';
area5['EVN'] = 'ARM';

area6['EVN'] = new Object();
area6['EVN'] = '★エレバン';
area3['ATG'] = new Object();
area3['ATG']['ANU'] = 'セントジョンズ';
area4['ANU'] = 'TC1_3';
area5['ANU'] = 'ATG';

area6['ANU'] = new Object();
area6['ANU'] = 'セントジョンズ';
area3['AUS'] = new Object();
area3['AUS']['SYD'] = '★シドニー';
area4['SYD'] = 'TC3_3';
area5['SYD'] = 'AUS';

area6['SYD'] = new Object();
area6['SYD'] = '★シドニー';
area3['AUS']['MEL'] = '★メルボルン';
area4['MEL'] = 'TC3_3';
area5['MEL'] = 'AUS';

area6['MEL'] = new Object();
area6['MEL'] = '★メルボルン';
area3['AUS']['AVV'] = 'アバロン';
area4['AVV'] = 'TC3_3';
area5['AVV'] = 'AUS';

area6['AVV'] = new Object();
area6['AVV'] = 'アバロン';
area3['AUS']['BNE'] = '★ブリスベン';
area4['BNE'] = 'TC3_3';
area5['BNE'] = 'AUS';

area6['BNE'] = new Object();
area6['BNE'] = '★ブリスベン';
area3['AUS']['CNS'] = '★ケアンズ';
area4['CNS'] = 'TC3_3';
area5['CNS'] = 'AUS';

area6['CNS'] = new Object();
area6['CNS'] = '★ケアンズ';
area3['AUS']['ADL'] = '★アデレード';
area4['ADL'] = 'TC3_3';
area5['ADL'] = 'AUS';

area6['ADL'] = new Object();
area6['ADL'] = '★アデレード';
area3['AUS']['OOL'] = 'ゴールドコースト';
area4['OOL'] = 'TC3_3';
area5['OOL'] = 'AUS';

area6['OOL'] = new Object();
area6['OOL'] = 'ゴールドコースト';
area3['AUS']['PER'] = '★パース';
area4['PER'] = 'TC3_3';
area5['PER'] = 'AUS';

area6['PER'] = new Object();
area6['PER'] = '★パース';
area3['AUS']['ASP'] = 'アリススプリングス';
area4['ASP'] = 'TC3_3';
area5['ASP'] = 'AUS';

area6['ASP'] = new Object();
area6['ASP'] = 'アリススプリングス';
area3['AUS']['AYQ'] = 'エアーズロック';
area4['AYQ'] = 'TC3_3';
area5['AYQ'] = 'AUS';

area6['AYQ'] = new Object();
area6['AYQ'] = 'エアーズロック';
area3['AUS']['CBR'] = 'キャンベラ';
area4['CBR'] = 'TC3_3';
area5['CBR'] = 'AUS';

area6['CBR'] = new Object();
area6['CBR'] = 'キャンベラ';
area3['AUS']['DPO'] = 'デボンポート（タスマニア島）';
area4['DPO'] = 'TC3_3';
area5['DPO'] = 'AUS';

area6['DPO'] = new Object();
area6['DPO'] = 'デボンポート（タスマニア島）';
area3['AUS']['CFS'] = 'コフスハーバー';
area4['CFS'] = 'TC3_3';
area5['CFS'] = 'AUS';

area6['CFS'] = new Object();
area6['CFS'] = 'コフスハーバー';
area3['AUS']['DRW'] = 'ダーウィン';
area4['DRW'] = 'TC3_3';
area5['DRW'] = 'AUS';

area6['DRW'] = new Object();
area6['DRW'] = 'ダーウィン';
area3['AUS']['HBA'] = 'ホバート（タスマニア島）';
area4['HBA'] = 'TC3_3';
area5['HBA'] = 'AUS';

area6['HBA'] = new Object();
area6['HBA'] = 'ホバート（タスマニア島）';
area3['AUS']['LST'] = 'ローンセストン（タスマニア島）';
area4['LST'] = 'TC3_3';
area5['LST'] = 'AUS';

area6['LST'] = new Object();
area6['LST'] = 'ローンセストン（タスマニア島）';
area3['AUS']['MKY'] = 'マッカイ';
area4['MKY'] = 'TC3_3';
area5['MKY'] = 'AUS';

area6['MKY'] = new Object();
area6['MKY'] = 'マッカイ';
area3['AUS']['PQQ'] = 'ポートマクォーリー';
area4['PQQ'] = 'TC3_3';
area5['PQQ'] = 'AUS';

area6['PQQ'] = new Object();
area6['PQQ'] = 'ポートマクォーリー';
area3['AUT'] = new Object();
area3['AUT']['VIE'] = '★ウィーン';
area4['VIE'] = 'TC2_1';
area5['VIE'] = 'AUT';

area6['VIE'] = new Object();
area6['VIE'] = '★ウィーン';
area3['AUT']['SZG'] = 'ザルツブルク';
area4['SZG'] = 'TC2_1';
area5['SZG'] = 'AUT';

area6['SZG'] = new Object();
area6['SZG'] = 'ザルツブルク';
area3['AUT']['LNZ'] = 'リンツ';
area4['LNZ'] = 'TC2_1';
area5['LNZ'] = 'AUT';

area6['LNZ'] = new Object();
area6['LNZ'] = 'リンツ';
area3['AUT']['KLU'] = 'クラーゲンフルト';
area4['KLU'] = 'TC2_1';
area5['KLU'] = 'AUT';

area6['KLU'] = new Object();
area6['KLU'] = 'クラーゲンフルト';
area3['AUT']['INN'] = 'インスブルック';
area4['INN'] = 'TC2_1';
area5['INN'] = 'AUT';

area6['INN'] = new Object();
area6['INN'] = 'インスブルック';
area3['AUT']['GRZ'] = 'グラーツ';
area4['GRZ'] = 'TC2_1';
area5['GRZ'] = 'AUT';

area6['GRZ'] = new Object();
area6['GRZ'] = 'グラーツ';
area3['AZE'] = new Object();
area3['AZE']['BAK'] = '★バクー';
area4['BAK'] = 'TC2_1';
area5['BAK'] = 'AZE';

area6['BAK'] = new Object();
area6['BAK'] = '★バクー';
area3['AZE']['GYD'] = 'バクー';
area4['GYD'] = 'TC2_1';
area5['GYD'] = 'AZE';

area6['GYD'] = new Object();
area6['GYD'] = 'バクー';
area3['BDI'] = new Object();
area3['BDI']['BJM'] = '';
area4['BJM'] = 'TC2_2';
area5['BJM'] = 'BDI';

area6['BJM'] = new Object();
area6['BJM'] = '';
area3['BEL'] = new Object();
area3['BEL']['BRU'] = '★ブリュッセル';
area4['BRU'] = 'TC2_1';
area5['BRU'] = 'BEL';

area6['BRU'] = new Object();
area6['BRU'] = '★ブリュッセル';
area3['BEL']['ANR'] = 'アントワープ';
area4['ANR'] = 'TC2_1';
area5['ANR'] = 'BEL';

area6['ANR'] = new Object();
area6['ANR'] = 'アントワープ';
area3['BEN'] = new Object();
area3['BEN']['COO'] = '★コトヌー';
area4['COO'] = 'TC2_2';
area5['COO'] = 'BEN';

area6['COO'] = new Object();
area6['COO'] = '★コトヌー';
area3['BFA'] = new Object();
area3['BFA']['OUA'] = 'ワガドゥグ';
area4['OUA'] = 'TC2_2';
area5['OUA'] = 'BFA';

area6['OUA'] = new Object();
area6['OUA'] = 'ワガドゥグ';
area3['BGD'] = new Object();
area3['BGD']['DAC'] = '★ダッカ';
area4['DAC'] = 'TC3_2';
area5['DAC'] = 'BGD';

area6['DAC'] = new Object();
area6['DAC'] = '★ダッカ';
area3['BGR'] = new Object();
area3['BGR']['SOF'] = '★ソフィア';
area4['SOF'] = 'TC2_1';
area5['SOF'] = 'BGR';

area6['SOF'] = new Object();
area6['SOF'] = '★ソフィア';
area3['BGR']['VAR'] = 'ヴァルナ';
area4['VAR'] = 'TC2_1';
area5['VAR'] = 'BGR';

area6['VAR'] = new Object();
area6['VAR'] = 'ヴァルナ';
area3['BHR'] = new Object();
area3['BHR']['BAH'] = '★バーレーン（マナーマ）';
area4['BAH'] = 'TC2_2';
area5['BAH'] = 'BHR';

area6['BAH'] = new Object();
area6['BAH'] = '★バーレーン（マナーマ）';
area3['BHS'] = new Object();
area3['BHS']['FPO'] = 'バハマ';
area4['FPO'] = 'TC1_3';
area5['FPO'] = 'BHS';

area6['FPO'] = new Object();
area6['FPO'] = 'バハマ';
area3['BHS']['NAS'] = 'ナッソー';
area4['NAS'] = 'TC1_3';
area5['NAS'] = 'BHS';

area6['NAS'] = new Object();
area6['NAS'] = 'ナッソー';
area3['BIH'] = new Object();
area3['BIH']['SJJ'] = 'サラエボ　';
area4['SJJ'] = 'TC2_1';
area5['SJJ'] = 'BIH';

area6['SJJ'] = new Object();
area6['SJJ'] = 'サラエボ　';
area3['BLR'] = new Object();
area3['BLR']['MSQ'] = '★ミンスク';
area4['MSQ'] = 'TC2_1';
area5['MSQ'] = 'BLR';

area6['MSQ'] = new Object();
area6['MSQ'] = '★ミンスク';
area3['BLZ'] = new Object();
area3['BLZ']['BZE'] = 'ベリーズシティ';
area4['BZE'] = 'TC1_3';
area5['BZE'] = 'BLZ';

area6['BZE'] = new Object();
area6['BZE'] = 'ベリーズシティ';
area3['BOL'] = new Object();
area3['BOL']['LPB'] = 'ラパス';
area4['LPB'] = 'TC1_3';
area5['LPB'] = 'BOL';

area6['LPB'] = new Object();
area6['LPB'] = 'ラパス';
area3['BRA'] = new Object();
area3['BRA']['RIO'] = 'リオデジャネイロ';
area4['RIO'] = 'TC1_3';
area5['RIO'] = 'BRA';

area6['RIO'] = new Object();
area6['RIO'] = 'リオデジャネイロ';
area3['BRA']['GIG'] = 'リオデジャネイロ国際空港';
area4['GIG'] = 'TC1_3';
area5['GIG'] = 'BRA';

area6['GIG'] = new Object();
area6['GIG'] = 'リオデジャネイロ国際空港';
area3['BRA']['SAO'] = 'サンパウロ';
area4['SAO'] = 'TC1_3';
area5['SAO'] = 'BRA';

area6['SAO'] = new Object();
area6['SAO'] = 'サンパウロ';
area3['BRA']['GRU'] = 'サンパウロ（グアルーリョス）';
area4['GRU'] = 'TC1_3';
area5['GRU'] = 'BRA';

area6['GRU'] = new Object();
area6['GRU'] = 'サンパウロ（グアルーリョス）';
area3['BRA']['MCP'] = 'マカバ';
area4['MCP'] = 'TC1_3';
area5['MCP'] = 'BRA';

area6['MCP'] = new Object();
area6['MCP'] = 'マカバ';
area3['BRA']['CNF'] = 'ベロオリゾンテ';
area4['CNF'] = 'TC1_3';
area5['CNF'] = 'BRA';

area6['CNF'] = new Object();
area6['CNF'] = 'ベロオリゾンテ';
area3['BRA']['POA'] = 'ポルトアレグレ';
area4['POA'] = 'TC1_3';
area5['POA'] = 'BRA';

area6['POA'] = new Object();
area6['POA'] = 'ポルトアレグレ';
area3['BRA']['REC'] = 'レシフェ';
area4['REC'] = 'TC1_3';
area5['REC'] = 'BRA';

area6['REC'] = new Object();
area6['REC'] = 'レシフェ';
area3['BRA']['CWB'] = 'クリチバ';
area4['CWB'] = 'TC1_3';
area5['CWB'] = 'BRA';

area6['CWB'] = new Object();
area6['CWB'] = 'クリチバ';
area3['BRA']['MAO'] = 'マナウス';
area4['MAO'] = 'TC1_3';
area5['MAO'] = 'BRA';

area6['MAO'] = new Object();
area6['MAO'] = 'マナウス';
area3['BRA']['BSB'] = 'ブラジリア';
area4['BSB'] = 'TC1_3';
area5['BSB'] = 'BRA';

area6['BSB'] = new Object();
area6['BSB'] = 'ブラジリア';
area3['BRA']['CGR'] = 'カンポグランデ';
area4['CGR'] = 'TC1_3';
area5['CGR'] = 'BRA';

area6['CGR'] = new Object();
area6['CGR'] = 'カンポグランデ';
area3['BRA']['CGB'] = 'クイアバ';
area4['CGB'] = 'TC1_3';
area5['CGB'] = 'BRA';

area6['CGB'] = new Object();
area6['CGB'] = 'クイアバ';
area3['BRA']['SSA'] = 'サルバドル';
area4['SSA'] = 'TC1_3';
area5['SSA'] = 'BRA';

area6['SSA'] = new Object();
area6['SSA'] = 'サルバドル';
area3['BRA']['SJP'] = 'サンジョゼードリオプレト';
area4['SJP'] = 'TC1_3';
area5['SJP'] = 'BRA';

area6['SJP'] = new Object();
area6['SJP'] = 'サンジョゼードリオプレト';
area3['BRA']['IGU'] = 'イグアス フォールズ';
area4['IGU'] = 'TC1_3';
area5['IGU'] = 'BRA';

area6['IGU'] = new Object();
area6['IGU'] = 'イグアス フォールズ';
area3['BRA']['FOR'] = 'フォルタレザ';
area4['FOR'] = 'TC1_3';
area5['FOR'] = 'BRA';

area6['FOR'] = new Object();
area6['FOR'] = 'フォルタレザ';
area3['BRA']['SDU'] = 'リオデジャネイロ（サントス・ドゥモン）';
area4['SDU'] = 'TC1_3';
area5['SDU'] = 'BRA';

area6['SDU'] = new Object();
area6['SDU'] = 'リオデジャネイロ（サントス・ドゥモン）';
area3['BRA']['CGH'] = 'サンパウロ（コンゴーニャス）';
area4['CGH'] = 'TC1_3';
area5['CGH'] = 'BRA';

area6['CGH'] = new Object();
area6['CGH'] = 'サンパウロ（コンゴーニャス）';
area3['BRN'] = new Object();
area3['BRN']['BWN'] = '★バンダルスリブガワン';
area4['BWN'] = 'TC3_2';
area5['BWN'] = 'BRN';

area6['BWN'] = new Object();
area6['BWN'] = '★バンダルスリブガワン';
area3['BWA'] = new Object();
area3['BWA']['GBE'] = 'ハボローネ';
area4['GBE'] = 'TC2_2';
area5['GBE'] = 'BWA';

area6['GBE'] = new Object();
area6['GBE'] = 'ハボローネ';
area3['CAN'] = new Object();
area3['CAN']['YVR'] = '★バンクーバー';
area4['YVR'] = 'TC1_1';
area5['YVR'] = 'CAN';

area6['YVR'] = new Object();
area6['YVR'] = '★バンクーバー';
area3['CAN']['YTO'] = '★トロント';
area4['YTO'] = 'TC1_1';
area5['YTO'] = 'CAN';

area6['YTO'] = new Object();
area6['YTO'] = '★トロント';
area3['CAN']['YMQ'] = '★モントリオール';
area4['YMQ'] = 'TC1_1';
area5['YMQ'] = 'CAN';

area6['YMQ'] = new Object();
area6['YMQ'] = '★モントリオール';
area3['CAN']['YYC'] = '★カルガリー';
area4['YYC'] = 'TC1_1';
area5['YYC'] = 'CAN';

area6['YYC'] = new Object();
area6['YYC'] = '★カルガリー';
area3['CAN']['YYJ'] = 'ビクトリア';
area4['YYJ'] = 'TC1_1';
area5['YYJ'] = 'CAN';

area6['YYJ'] = new Object();
area6['YYJ'] = 'ビクトリア';
area3['CAN']['YQB'] = 'ケベック';
area4['YQB'] = 'TC1_1';
area5['YQB'] = 'CAN';

area6['YQB'] = new Object();
area6['YQB'] = 'ケベック';
area3['CAN']['YYG'] = 'シャーロットタウン';
area4['YYG'] = 'TC1_1';
area5['YYG'] = 'CAN';

area6['YYG'] = new Object();
area6['YYG'] = 'シャーロットタウン';
area3['CAN']['YWG'] = 'ウィニペグ';
area4['YWG'] = 'TC1_1';
area5['YWG'] = 'CAN';

area6['YWG'] = new Object();
area6['YWG'] = 'ウィニペグ';
area3['CAN']['YZF'] = 'イエローナイフ';
area4['YZF'] = 'TC1_1';
area5['YZF'] = 'CAN';

area6['YZF'] = new Object();
area6['YZF'] = 'イエローナイフ';
area3['CAN']['YHZ'] = 'ハリファックス';
area4['YHZ'] = 'TC1_1';
area5['YHZ'] = 'CAN';

area6['YHZ'] = new Object();
area6['YHZ'] = 'ハリファックス';
area3['CAN']['YEG'] = 'エドモントン';
area4['YEG'] = 'TC1_1';
area5['YEG'] = 'CAN';

area6['YEG'] = new Object();
area6['YEG'] = 'エドモントン';
area3['CAN']['YOW'] = 'オタワ';
area4['YOW'] = 'TC1_1';
area5['YOW'] = 'CAN';

area6['YOW'] = new Object();
area6['YOW'] = 'オタワ';
area3['CAN']['YXS'] = 'プリンス・ジョージ';
area4['YXS'] = 'TC1_1';
area5['YXS'] = 'CAN';

area6['YXS'] = new Object();
area6['YXS'] = 'プリンス・ジョージ';
area3['CAN']['YQM'] = 'モンクトン';
area4['YQM'] = 'TC1_1';
area5['YQM'] = 'CAN';

area6['YQM'] = new Object();
area6['YQM'] = 'モンクトン';
area3['CAN']['YLW'] = 'ケロウナ';
area4['YLW'] = 'TC1_1';
area5['YLW'] = 'CAN';

area6['YLW'] = new Object();
area6['YLW'] = 'ケロウナ';
area3['CAN']['YCD'] = 'ナナイモ';
area4['YCD'] = 'TC1_1';
area5['YCD'] = 'CAN';

area6['YCD'] = new Object();
area6['YCD'] = 'ナナイモ';
area3['CAN']['YYZ'] = 'トロント（ピアソン）';
area4['YYZ'] = 'TC1_1';
area5['YYZ'] = 'CAN';

area6['YYZ'] = new Object();
area6['YYZ'] = 'トロント（ピアソン）';
area3['CAN']['YTZ'] = 'トロント（シティセンター）';
area4['YTZ'] = 'TC1_1';
area5['YTZ'] = 'CAN';

area6['YTZ'] = new Object();
area6['YTZ'] = 'トロント（シティセンター）';
area3['CAN']['YUL'] = 'モントリオール（トルドー）';
area4['YUL'] = 'TC1_1';
area5['YUL'] = 'CAN';

area6['YUL'] = new Object();
area6['YUL'] = 'モントリオール（トルドー）';
area3['CAN']['YMX'] = 'モントリオール（ミラベル）';
area4['YMX'] = 'TC1_1';
area5['YMX'] = 'CAN';

area6['YMX'] = new Object();
area6['YMX'] = 'モントリオール（ミラベル）';
area3['CAN']['YXE'] = 'サスカトゥーン';
area4['YXE'] = 'TC1_1';
area5['YXE'] = 'CAN';

area6['YXE'] = new Object();
area6['YXE'] = 'サスカトゥーン';
area3['CAN']['YXJ'] = 'ノースピース';
area4['YXJ'] = 'TC1_1';
area5['YXJ'] = 'CAN';

area6['YXJ'] = new Object();
area6['YXJ'] = 'ノースピース';
area3['CAN']['YXT'] = 'テラス';
area4['YXT'] = 'TC1_1';
area5['YXT'] = 'CAN';

area6['YXT'] = new Object();
area6['YXT'] = 'テラス';
area3['CAN']['YXU'] = 'ロンドン（カナダ）';
area4['YXU'] = 'TC1_1';
area5['YXU'] = 'CAN';

area6['YXU'] = new Object();
area6['YXU'] = 'ロンドン（カナダ）';
area3['CAN']['YXY'] = 'ホワイトホース';
area4['YXY'] = 'TC1_1';
area5['YXY'] = 'CAN';

area6['YXY'] = new Object();
area6['YXY'] = 'ホワイトホース';
area3['CAN']['YYB'] = 'ノースベイ';
area4['YYB'] = 'TC1_1';
area5['YYB'] = 'CAN';

area6['YYB'] = new Object();
area6['YYB'] = 'ノースベイ';
area3['CAN']['YYF'] = 'ペンティクトン';
area4['YYF'] = 'TC1_1';
area5['YYF'] = 'CAN';

area6['YYF'] = new Object();
area6['YYF'] = 'ペンティクトン';
area3['CAN']['YYT'] = 'セントジョンズ';
area4['YYT'] = 'TC1_1';
area5['YYT'] = 'CAN';

area6['YYT'] = new Object();
area6['YYT'] = 'セントジョンズ';
area3['CAN']['YZR'] = 'クリス・ハドフィールド';
area4['YZR'] = 'TC1_1';
area5['YZR'] = 'CAN';

area6['YZR'] = new Object();
area6['YZR'] = 'クリス・ハドフィールド';
area3['CAN']['YXC'] = 'クランブルック';
area4['YXC'] = 'TC1_1';
area5['YXC'] = 'CAN';

area6['YXC'] = new Object();
area6['YXC'] = 'クランブルック';
area3['CAN']['YTS'] = 'ティミンズ';
area4['YTS'] = 'TC1_1';
area5['YTS'] = 'CAN';

area6['YTS'] = new Object();
area6['YTS'] = 'ティミンズ';
area3['CAN']['YSB'] = 'サドバリー';
area4['YSB'] = 'TC1_1';
area5['YSB'] = 'CAN';

area6['YSB'] = new Object();
area6['YSB'] = 'サドバリー';
area3['CAN']['YQY'] = 'シドニー（ノバスコシア）';
area4['YQY'] = 'TC1_1';
area5['YQY'] = 'CAN';

area6['YQY'] = new Object();
area6['YQY'] = 'シドニー（ノバスコシア）';
area3['CAN']['YQX'] = 'ガンダー';
area4['YQX'] = 'TC1_1';
area5['YQX'] = 'CAN';

area6['YQX'] = new Object();
area6['YQX'] = 'ガンダー';
area3['CAN']['YQT'] = 'サンダーベイ';
area4['YQT'] = 'TC1_1';
area5['YQT'] = 'CAN';

area6['YQT'] = new Object();
area6['YQT'] = 'サンダーベイ';
area3['CAN']['YQR'] = 'レジャイナ';
area4['YQR'] = 'TC1_1';
area5['YQR'] = 'CAN';

area6['YQR'] = new Object();
area6['YQR'] = 'レジャイナ';
area3['CAN']['YQQ'] = 'コーモックス';
area4['YQQ'] = 'TC1_1';
area5['YQQ'] = 'CAN';

area6['YQQ'] = new Object();
area6['YQQ'] = 'コーモックス';
area3['CAN']['YQL'] = 'レスブリッジ';
area4['YQL'] = 'TC1_1';
area5['YQL'] = 'CAN';

area6['YQL'] = new Object();
area6['YQL'] = 'レスブリッジ';
area3['CAN']['YQG'] = 'ウィンザー';
area4['YQG'] = 'TC1_1';
area5['YQG'] = 'CAN';

area6['YQG'] = new Object();
area6['YQG'] = 'ウィンザー';
area3['CAN']['YQF'] = 'レッドディア';
area4['YQF'] = 'TC1_1';
area5['YQF'] = 'CAN';

area6['YQF'] = new Object();
area6['YQF'] = 'レッドディア';
area3['CAN']['YPR'] = 'プリンス・ルパート';
area4['YPR'] = 'TC1_1';
area5['YPR'] = 'CAN';

area6['YPR'] = new Object();
area6['YPR'] = 'プリンス・ルパート';
area3['CAN']['YMM'] = 'フォートマクマレー';
area4['YMM'] = 'TC1_1';
area5['YMM'] = 'CAN';

area6['YMM'] = new Object();
area6['YMM'] = 'フォートマクマレー';
area3['CAN']['YKA'] = 'カムループス';
area4['YKA'] = 'TC1_1';
area5['YKA'] = 'CAN';

area6['YKA'] = new Object();
area6['YKA'] = 'カムループス';
area3['CAN']['YGK'] = 'キングストン';
area4['YGK'] = 'TC1_1';
area5['YGK'] = 'CAN';

area6['YGK'] = new Object();
area6['YGK'] = 'キングストン';
area3['CAN']['YFC'] = 'フレデリクトン';
area4['YFC'] = 'TC1_1';
area5['YFC'] = 'CAN';

area6['YFC'] = new Object();
area6['YFC'] = 'フレデリクトン';
area3['CAN']['YCG'] = 'キャッスルガー';
area4['YCG'] = 'TC1_1';
area5['YCG'] = 'CAN';

area6['YCG'] = new Object();
area6['YCG'] = 'キャッスルガー';
area3['CAN']['YBL'] = 'キャンベルリバー';
area4['YBL'] = 'TC1_1';
area5['YBL'] = 'CAN';

area6['YBL'] = new Object();
area6['YBL'] = 'キャンベルリバー';
area3['CAN']['YAM'] = 'スーセントマリー';
area4['YAM'] = 'TC1_1';
area5['YAM'] = 'CAN';

area6['YAM'] = new Object();
area6['YAM'] = 'スーセントマリー';
area3['CHE'] = new Object();
area3['CHE']['ZRH'] = '★チューリッヒ';
area4['ZRH'] = 'TC2_1';
area5['ZRH'] = 'CHE';

area6['ZRH'] = new Object();
area6['ZRH'] = '★チューリッヒ';
area3['CHE']['GVA'] = 'ジュネーブ';
area4['GVA'] = 'TC2_1';
area5['GVA'] = 'CHE';

area6['GVA'] = new Object();
area6['GVA'] = 'ジュネーブ';
area3['CHE']['BRN'] = 'ベルン';
area4['BRN'] = 'TC2_1';
area5['BRN'] = 'CHE';

area6['BRN'] = new Object();
area6['BRN'] = 'ベルン';
area3['CHE']['ACH'] = 'アルテンルハイン';
area4['ACH'] = 'TC2_1';
area5['ACH'] = 'CHE';

area6['ACH'] = new Object();
area6['ACH'] = 'アルテンルハイン';
area3['CHE']['LUG'] = 'ルガーノ';
area4['LUG'] = 'TC2_1';
area5['LUG'] = 'CHE';

area6['LUG'] = new Object();
area6['LUG'] = 'ルガーノ';
area3['CHL'] = new Object();
area3['CHL']['SCL'] = 'サンティアゴ（チリ）';
area4['SCL'] = 'TC1_3';
area5['SCL'] = 'CHL';

area6['SCL'] = new Object();
area6['SCL'] = 'サンティアゴ（チリ）';
area3['CHL']['IPC'] = 'イースター島';
area4['IPC'] = 'TC1_3';
area5['IPC'] = 'CHL';

area6['IPC'] = new Object();
area6['IPC'] = 'イースター島';
area3['CHN'] = new Object();
area3['CHN']['BJS'] = '★北京（首都・大興）';
area4['BJS'] = 'TC3_1';
area5['BJS'] = 'CHN';

area6['BJS'] = new Object();
area6['BJS'] = '★北京（首都・大興）';
area3['CHN']['PEK'] = '★北京（首都）';
area4['PEK'] = 'TC3_1';
area5['PEK'] = 'CHN';

area6['PEK'] = new Object();
area6['PEK'] = '★北京（首都）';
area3['CHN']['PKX'] = '★北京（大興）';
area4['PKX'] = 'TC3_1';
area5['PKX'] = 'CHN';

area6['PKX'] = new Object();
area6['PKX'] = '★北京（大興）';
area3['CHN']['SHA'] = '★上海（虹橋）';
area4['SHA'] = 'TC3_1';
area5['SHA'] = 'CHN';

area6['SHA'] = new Object();
area6['SHA'] = '★上海（虹橋）';
area3['CHN']['PVG'] = '★上海（浦東）';
area4['PVG'] = 'TC3_1';
area5['PVG'] = 'CHN';

area6['PVG'] = new Object();
area6['PVG'] = '★上海（浦東）';
area3['CHN']['DLC'] = '大連';
area4['DLC'] = 'TC3_1';
area5['DLC'] = 'CHN';

area6['DLC'] = new Object();
area6['DLC'] = '大連';
area3['CHN']['TSN'] = '天津';
area4['TSN'] = 'TC3_1';
area5['TSN'] = 'CHN';

area6['TSN'] = new Object();
area6['TSN'] = '天津';
area3['CHN']['TAO'] = '青島';
area4['TAO'] = 'TC3_1';
area5['TAO'] = 'CHN';

area6['TAO'] = new Object();
area6['TAO'] = '青島';
area3['CHN']['XIY'] = '西安';
area4['XIY'] = 'TC3_1';
area5['XIY'] = 'CHN';

area6['XIY'] = new Object();
area6['XIY'] = '西安';
area3['CHN']['CAN'] = '広州';
area4['CAN'] = 'TC3_1';
area5['CAN'] = 'CHN';

area6['CAN'] = new Object();
area6['CAN'] = '広州';
area3['CHN']['HGH'] = '杭州';
area4['HGH'] = 'TC3_1';
area5['HGH'] = 'CHN';

area6['HGH'] = new Object();
area6['HGH'] = '杭州';
area3['CHN']['XMN'] = '厦門';
area4['XMN'] = 'TC3_1';
area5['XMN'] = 'CHN';

area6['XMN'] = new Object();
area6['XMN'] = '厦門';
area3['CHN']['KMG'] = '昆明';
area4['KMG'] = 'TC3_1';
area5['KMG'] = 'CHN';

area6['KMG'] = new Object();
area6['KMG'] = '昆明';
area3['CHN']['WUH'] = '武漢';
area4['WUH'] = 'TC3_1';
area5['WUH'] = 'CHN';

area6['WUH'] = new Object();
area6['WUH'] = '武漢';
area3['CHN']['CKG'] = '重慶';
area4['CKG'] = 'TC3_1';
area5['CKG'] = 'CHN';

area6['CKG'] = new Object();
area6['CKG'] = '重慶';
area3['CHN']['HAK'] = '海南島';
area4['HAK'] = 'TC3_1';
area5['HAK'] = 'CHN';

area6['HAK'] = new Object();
area6['HAK'] = '海南島';
area3['CHN']['SYX'] = '海南島三亜';
area4['SYX'] = 'TC3_1';
area5['SYX'] = 'CHN';

area6['SYX'] = new Object();
area6['SYX'] = '海南島三亜';
area3['CHN']['SHE'] = '瀋陽';
area4['SHE'] = 'TC3_1';
area5['SHE'] = 'CHN';

area6['SHE'] = new Object();
area6['SHE'] = '瀋陽';
area3['CHN']['CGQ'] = '長春';
area4['CGQ'] = 'TC3_1';
area5['CGQ'] = 'CHN';

area6['CGQ'] = new Object();
area6['CGQ'] = '長春';
area3['CHN']['CTU'] = '成都';
area4['CTU'] = 'TC3_1';
area5['CTU'] = 'CHN';

area6['CTU'] = new Object();
area6['CTU'] = '成都';
area3['CHN']['SZX'] = '深セン';
area4['SZX'] = 'TC3_1';
area5['SZX'] = 'CHN';

area6['SZX'] = new Object();
area6['SZX'] = '深セン';
area3['CHN']['KWL'] = '桂林';
area4['KWL'] = 'TC3_1';
area5['KWL'] = 'CHN';

area6['KWL'] = new Object();
area6['KWL'] = '桂林';
area3['CHN']['FOC'] = '福州';
area4['FOC'] = 'TC3_1';
area5['FOC'] = 'CHN';

area6['FOC'] = new Object();
area6['FOC'] = '福州';
area3['CHN']['HRB'] = '哈爾濱（ハルピン）';
area4['HRB'] = 'TC3_1';
area5['HRB'] = 'CHN';

area6['HRB'] = new Object();
area6['HRB'] = '哈爾濱（ハルピン）';
area3['CHN']['YNJ'] = '延吉';
area4['YNJ'] = 'TC3_1';
area5['YNJ'] = 'CHN';

area6['YNJ'] = new Object();
area6['YNJ'] = '延吉';
area3['CHN']['INC'] = '銀川';
area4['INC'] = 'TC3_1';
area5['INC'] = 'CHN';

area6['INC'] = new Object();
area6['INC'] = '銀川';
area3['CHN']['LHW'] = '蘭州';
area4['LHW'] = 'TC3_1';
area5['LHW'] = 'CHN';

area6['LHW'] = new Object();
area6['LHW'] = '蘭州';
area3['CHN']['XNN'] = '西寧';
area4['XNN'] = 'TC3_1';
area5['XNN'] = 'CHN';

area6['XNN'] = new Object();
area6['XNN'] = '西寧';
area3['CHN']['YNT'] = '煙台';
area4['YNT'] = 'TC3_1';
area5['YNT'] = 'CHN';

area6['YNT'] = new Object();
area6['YNT'] = '煙台';
area3['CHN']['KHN'] = '南昌';
area4['KHN'] = 'TC3_1';
area5['KHN'] = 'CHN';

area6['KHN'] = new Object();
area6['KHN'] = '南昌';
area3['CHN']['CSX'] = '長沙';
area4['CSX'] = 'TC3_1';
area5['CSX'] = 'CHN';

area6['CSX'] = new Object();
area6['CSX'] = '長沙';
area3['CHN']['DYG'] = '張家界';
area4['DYG'] = 'TC3_1';
area5['DYG'] = 'CHN';

area6['DYG'] = new Object();
area6['DYG'] = '張家界';
area3['CHN']['DLU'] = '大理';
area4['DLU'] = 'TC3_1';
area5['DLU'] = 'CHN';

area6['DLU'] = new Object();
area6['DLU'] = '大理';
area3['CHN']['JDZ'] = '景徳鎮';
area4['JDZ'] = 'TC3_1';
area5['JDZ'] = 'CHN';

area6['JDZ'] = new Object();
area6['JDZ'] = '景徳鎮';
area3['CHN']['NGB'] = '寧波';
area4['NGB'] = 'TC3_1';
area5['NGB'] = 'CHN';

area6['NGB'] = new Object();
area6['NGB'] = '寧波';
area3['CHN']['TNA'] = '済南';
area4['TNA'] = 'TC3_1';
area5['TNA'] = 'CHN';

area6['TNA'] = new Object();
area6['TNA'] = '済南';
area3['CHN']['NKG'] = '南京';
area4['NKG'] = 'TC3_1';
area5['NKG'] = 'CHN';

area6['NKG'] = new Object();
area6['NKG'] = '南京';
area3['CHN']['URC'] = 'ウルムチ';
area4['URC'] = 'TC3_1';
area5['URC'] = 'CHN';

area6['URC'] = new Object();
area6['URC'] = 'ウルムチ';
area3['CHN']['KWE'] = '貴陽';
area4['KWE'] = 'TC3_1';
area5['KWE'] = 'CHN';

area6['KWE'] = new Object();
area6['KWE'] = '貴陽';
area3['CHN']['HFE'] = '合肥';
area4['HFE'] = 'TC3_1';
area5['HFE'] = 'CHN';

area6['HFE'] = new Object();
area6['HFE'] = '合肥';
area3['CHN']['ZIY'] = '広州（蓮花山ＦＴ）';
area4['ZIY'] = 'TC3_1';
area5['ZIY'] = 'CHN';

area6['ZIY'] = new Object();
area6['ZIY'] = '広州（蓮花山ＦＴ）';
area3['CHN']['NSZ'] = '広州（南沙ＦＴ）';
area4['NSZ'] = 'TC3_1';
area5['NSZ'] = 'CHN';

area6['NSZ'] = new Object();
area6['NSZ'] = '広州（南沙ＦＴ）';
area3['CHN']['HET'] = 'フフホト';
area4['HET'] = 'TC3_1';
area5['HET'] = 'CHN';

area6['HET'] = new Object();
area6['HET'] = 'フフホト';
area3['CHN']['GOQ'] = 'ゴルムド';
area4['GOQ'] = 'TC3_1';
area5['GOQ'] = 'CHN';

area6['GOQ'] = new Object();
area6['GOQ'] = 'ゴルムド';
area3['CHN']['DNH'] = '敦煌';
area4['DNH'] = 'TC3_1';
area5['DNH'] = 'CHN';

area6['DNH'] = new Object();
area6['DNH'] = '敦煌';
area3['CHN']['ZUI'] = '珠海（九州ＦＴ）';
area4['ZUI'] = 'TC3_1';
area5['ZUI'] = 'CHN';

area6['ZUI'] = new Object();
area6['ZUI'] = '珠海（九州ＦＴ）';
area3['CHN']['ZUH'] = '珠海';
area4['ZUH'] = 'TC3_1';
area5['ZUH'] = 'CHN';

area6['ZUH'] = new Object();
area6['ZUH'] = '珠海';
area3['CHN']['FYG'] = '深セン（福永ＦＴ）';
area4['FYG'] = 'TC3_1';
area5['FYG'] = 'CHN';

area6['FYG'] = new Object();
area6['FYG'] = '深セン（福永ＦＴ）';
area3['CHN']['ZYK'] = '深セン（蛇口ＦＴ）';
area4['ZYK'] = 'TC3_1';
area5['ZYK'] = 'CHN';

area6['ZYK'] = new Object();
area6['ZYK'] = '深セン（蛇口ＦＴ）';
area3['CHN']['CGO'] = '鄭州';
area4['CGO'] = 'TC3_1';
area5['CGO'] = 'CHN';

area6['CGO'] = new Object();
area6['CGO'] = '鄭州';
area3['CHN']['BAV'] = '包頭';
area4['BAV'] = 'TC3_1';
area5['BAV'] = 'CHN';

area6['BAV'] = new Object();
area6['BAV'] = '包頭';
area3['CHN']['JHG'] = '景洪（西双版納）';
area4['JHG'] = 'TC3_1';
area5['JHG'] = 'CHN';

area6['JHG'] = new Object();
area6['JHG'] = '景洪（西双版納）';
area3['CHN']['JMU'] = '佳木斯';
area4['JMU'] = 'TC3_1';
area5['JMU'] = 'CHN';

area6['JMU'] = new Object();
area6['JMU'] = '佳木斯';
area3['CHN']['KHG'] = 'カシュガル';
area4['KHG'] = 'TC3_1';
area5['KHG'] = 'CHN';

area6['KHG'] = new Object();
area6['KHG'] = 'カシュガル';
area3['CHN']['LJG'] = '麗江';
area4['LJG'] = 'TC3_1';
area5['LJG'] = 'CHN';

area6['LJG'] = new Object();
area6['LJG'] = '麗江';
area3['CHN']['LXA'] = '拉薩（ラサ）';
area4['LXA'] = 'TC3_1';
area5['LXA'] = 'CHN';

area6['LXA'] = new Object();
area6['LXA'] = '拉薩（ラサ）';
area3['CHN']['LYA'] = '洛陽';
area4['LYA'] = 'TC3_1';
area5['LYA'] = 'CHN';

area6['LYA'] = new Object();
area6['LYA'] = '洛陽';
area3['CHN']['LYG'] = '連雲港';
area4['LYG'] = 'TC3_1';
area5['LYG'] = 'CHN';

area6['LYG'] = new Object();
area6['LYG'] = '連雲港';
area3['CHN']['LZO'] = '瀘州';
area4['LZO'] = 'TC3_1';
area5['LZO'] = 'CHN';

area6['LZO'] = new Object();
area6['LZO'] = '瀘州';
area3['CHN']['MDG'] = '牡丹江';
area4['MDG'] = 'TC3_1';
area5['MDG'] = 'CHN';

area6['MDG'] = new Object();
area6['MDG'] = '牡丹江';
area3['CHN']['NNG'] = '南寧';
area4['NNG'] = 'TC3_1';
area5['NNG'] = 'CHN';

area6['NNG'] = new Object();
area6['NNG'] = '南寧';
area3['CHN']['NTG'] = '南通';
area4['NTG'] = 'TC3_1';
area5['NTG'] = 'CHN';

area6['NTG'] = new Object();
area6['NTG'] = '南通';
area3['CHN']['SWA'] = '汕頭';
area4['SWA'] = 'TC3_1';
area5['SWA'] = 'CHN';

area6['SWA'] = new Object();
area6['SWA'] = '汕頭';
area3['CHN']['TGO'] = '通遼';
area4['TGO'] = 'TC3_1';
area5['TGO'] = 'CHN';

area6['TGO'] = new Object();
area6['TGO'] = '通遼';
area3['CHN']['TYN'] = '太原';
area4['TYN'] = 'TC3_1';
area5['TYN'] = 'CHN';

area6['TYN'] = new Object();
area6['TYN'] = '太原';
area3['CHN']['WEH'] = '威海';
area4['WEH'] = 'TC3_1';
area5['WEH'] = 'CHN';

area6['WEH'] = new Object();
area6['WEH'] = '威海';
area3['CHN']['WNZ'] = '温州';
area4['WNZ'] = 'TC3_1';
area5['WNZ'] = 'CHN';

area6['WNZ'] = new Object();
area6['WNZ'] = '温州';
area3['CHN']['YNZ'] = '塩城';
area4['YNZ'] = 'TC3_1';
area5['YNZ'] = 'CHN';

area6['YNZ'] = new Object();
area6['YNZ'] = '塩城';
area3['CIV'] = new Object();
area3['CIV']['ABJ'] = '★アビジャン';
area4['ABJ'] = 'TC2_2';
area5['ABJ'] = 'CIV';

area6['ABJ'] = new Object();
area6['ABJ'] = '★アビジャン';
area3['CMR'] = new Object();
area3['CMR']['NSI'] = '★ヤウンデ';
area4['NSI'] = 'TC2_2';
area5['NSI'] = 'CMR';

area6['NSI'] = new Object();
area6['NSI'] = '★ヤウンデ';
area3['CMR']['DLA'] = 'ドゥアラ';
area4['DLA'] = 'TC2_2';
area5['DLA'] = 'CMR';

area6['DLA'] = new Object();
area6['DLA'] = 'ドゥアラ';
area3['COD'] = new Object();
area3['COD']['FIH'] = '★キンシャサ';
area4['FIH'] = 'TC2_2';
area5['FIH'] = 'COD';

area6['FIH'] = new Object();
area6['FIH'] = '★キンシャサ';
area3['COD']['FBM'] = 'ルブンバシ';
area4['FBM'] = 'TC2_2';
area5['FBM'] = 'COD';

area6['FBM'] = new Object();
area6['FBM'] = 'ルブンバシ';
area3['COG'] = new Object();
area3['COG']['BZV'] = 'ブラザヴィル';
area4['BZV'] = 'TC2_2';
area5['BZV'] = 'COG';

area6['BZV'] = new Object();
area6['BZV'] = 'ブラザヴィル';
area3['COL'] = new Object();
area3['COL']['BOG'] = 'ボゴタ';
area4['BOG'] = 'TC1_3';
area5['BOG'] = 'COL';

area6['BOG'] = new Object();
area6['BOG'] = 'ボゴタ';
area3['COL']['CLO'] = 'カリ';
area4['CLO'] = 'TC1_3';
area5['CLO'] = 'COL';

area6['CLO'] = new Object();
area6['CLO'] = 'カリ';
area3['COL']['CTG'] = 'カルタヘナ';
area4['CTG'] = 'TC1_3';
area5['CTG'] = 'COL';

area6['CTG'] = new Object();
area6['CTG'] = 'カルタヘナ';
area3['COL']['BAQ'] = 'バランキヤ';
area4['BAQ'] = 'TC1_3';
area5['BAQ'] = 'COL';

area6['BAQ'] = new Object();
area6['BAQ'] = 'バランキヤ';
area3['COL']['MDE'] = 'メデリン';
area4['MDE'] = 'TC1_3';
area5['MDE'] = 'COL';

area6['MDE'] = new Object();
area6['MDE'] = 'メデリン';
area3['CRI'] = new Object();
area3['CRI']['SJO'] = 'サンホセ';
area4['SJO'] = 'TC1_3';
area5['SJO'] = 'CRI';

area6['SJO'] = new Object();
area6['SJO'] = 'サンホセ';
area3['CRI']['LIR'] = 'リベリア';
area4['LIR'] = 'TC1_3';
area5['LIR'] = 'CRI';

area6['LIR'] = new Object();
area6['LIR'] = 'リベリア';
area3['CUB'] = new Object();
area3['CUB']['HAV'] = 'ハバナ';
area4['HAV'] = 'TC1_3';
area5['HAV'] = 'CUB';

area6['HAV'] = new Object();
area6['HAV'] = 'ハバナ';
area3['CUW'] = new Object();
area3['CUW']['CUR'] = '★キュラソー島';
area4['CUR'] = 'TC1_3';
area5['CUR'] = 'CUW';

area6['CUR'] = new Object();
area6['CUR'] = '★キュラソー島';
area3['CYP'] = new Object();
area3['CYP']['LCA'] = 'ラルナカ';
area4['LCA'] = 'TC2_1';
area5['LCA'] = 'CYP';

area6['LCA'] = new Object();
area6['LCA'] = 'ラルナカ';
area3['CZE'] = new Object();
area3['CZE']['PRG'] = '★プラハ';
area4['PRG'] = 'TC2_1';
area5['PRG'] = 'CZE';

area6['PRG'] = new Object();
area6['PRG'] = '★プラハ';
area3['CZE']['OSR'] = 'オストラヴァ';
area4['OSR'] = 'TC2_1';
area5['OSR'] = 'CZE';

area6['OSR'] = new Object();
area6['OSR'] = 'オストラヴァ';
area3['CZE']['KLV'] = 'カルロヴィヴァリ';
area4['KLV'] = 'TC2_1';
area5['KLV'] = 'CZE';

area6['KLV'] = new Object();
area6['KLV'] = 'カルロヴィヴァリ';
area3['DEU'] = new Object();
area3['DEU']['BER'] = '★ベルリン';
area4['BER'] = 'TC2_1';
area5['BER'] = 'DEU';

area6['BER'] = new Object();
area6['BER'] = '★ベルリン';
area3['DEU']['MUC'] = '★ミュンヘン';
area4['MUC'] = 'TC2_1';
area5['MUC'] = 'DEU';

area6['MUC'] = new Object();
area6['MUC'] = '★ミュンヘン';
area3['DEU']['FRA'] = '★フランクフルト';
area4['FRA'] = 'TC2_1';
area5['FRA'] = 'DEU';

area6['FRA'] = new Object();
area6['FRA'] = '★フランクフルト';
area3['DEU']['NUE'] = 'ニュルンベルク';
area4['NUE'] = 'TC2_1';
area5['NUE'] = 'DEU';

area6['NUE'] = new Object();
area6['NUE'] = 'ニュルンベルク';
area3['DEU']['CGN'] = 'ケルン';
area4['CGN'] = 'TC2_1';
area5['CGN'] = 'DEU';

area6['CGN'] = new Object();
area6['CGN'] = 'ケルン';
area3['DEU']['DRS'] = 'ドレスデン';
area4['DRS'] = 'TC2_1';
area5['DRS'] = 'DEU';

area6['DRS'] = new Object();
area6['DRS'] = 'ドレスデン';
area3['DEU']['BRE'] = 'ブレーメン';
area4['BRE'] = 'TC2_1';
area5['BRE'] = 'DEU';

area6['BRE'] = new Object();
area6['BRE'] = 'ブレーメン';
area3['DEU']['DUS'] = 'デュッセルドルフ';
area4['DUS'] = 'TC2_1';
area5['DUS'] = 'DEU';

area6['DUS'] = new Object();
area6['DUS'] = 'デュッセルドルフ';
area3['DEU']['FMO'] = 'ミュンスター／オスナブリュック';
area4['FMO'] = 'TC2_1';
area5['FMO'] = 'DEU';

area6['FMO'] = new Object();
area6['FMO'] = 'ミュンスター／オスナブリュック';
area3['DEU']['HAM'] = 'ハンブルク';
area4['HAM'] = 'TC2_1';
area5['HAM'] = 'DEU';

area6['HAM'] = new Object();
area6['HAM'] = 'ハンブルク';
area3['DEU']['SXF'] = 'ベルリン（ベルリン・シェーネフェルト）';
area4['SXF'] = 'TC2_1';
area5['SXF'] = 'DEU';

area6['SXF'] = new Object();
area6['SXF'] = 'ベルリン（ベルリン・シェーネフェルト）';
area3['DEU']['TXL'] = 'ベルリン（テーゲル）';
area4['TXL'] = 'TC2_1';
area5['TXL'] = 'DEU';

area6['TXL'] = new Object();
area6['TXL'] = 'ベルリン（テーゲル）';
area3['DEU']['MHG'] = 'マンハイム';
area4['MHG'] = 'TC2_1';
area5['MHG'] = 'DEU';

area6['MHG'] = new Object();
area6['MHG'] = 'マンハイム';
area3['DEU']['QKL'] = 'ケルン中央駅';
area4['QKL'] = 'TC2_1';
area5['QKL'] = 'DEU';

area6['QKL'] = new Object();
area6['QKL'] = 'ケルン中央駅';
area3['DEU']['STR'] = 'シュトゥットガルト';
area4['STR'] = 'TC2_1';
area5['STR'] = 'DEU';

area6['STR'] = new Object();
area6['STR'] = 'シュトゥットガルト';
area3['DEU']['SCN'] = 'ザールブリュッケン';
area4['SCN'] = 'TC2_1';
area5['SCN'] = 'DEU';

area6['SCN'] = new Object();
area6['SCN'] = 'ザールブリュッケン';
area3['DEU']['PAD'] = 'パーダーボルン';
area4['PAD'] = 'TC2_1';
area5['PAD'] = 'DEU';

area6['PAD'] = new Object();
area6['PAD'] = 'パーダーボルン';
area3['DEU']['LEJ'] = 'ライプツィヒ';
area4['LEJ'] = 'TC2_1';
area5['LEJ'] = 'DEU';

area6['LEJ'] = new Object();
area6['LEJ'] = 'ライプツィヒ';
area3['DEU']['HOQ'] = 'ホーフ';
area4['HOQ'] = 'TC2_1';
area5['HOQ'] = 'DEU';

area6['HOQ'] = new Object();
area6['HOQ'] = 'ホーフ';
area3['DEU']['HAJ'] = 'ハノーファー';
area4['HAJ'] = 'TC2_1';
area5['HAJ'] = 'DEU';

area6['HAJ'] = new Object();
area6['HAJ'] = 'ハノーファー';
area3['DEU']['FDH'] = 'フリードリヒスハーフェン';
area4['FDH'] = 'TC2_1';
area5['FDH'] = 'DEU';

area6['FDH'] = new Object();
area6['FDH'] = 'フリードリヒスハーフェン';
area3['DEU']['ERF'] = 'エアフルト';
area4['ERF'] = 'TC2_1';
area5['ERF'] = 'DEU';

area6['ERF'] = new Object();
area6['ERF'] = 'エアフルト';
area3['DJI'] = new Object();
area3['DJI']['JIB'] = '★ジブチ';
area4['JIB'] = 'TC2_2';
area5['JIB'] = 'DJI';

area6['JIB'] = new Object();
area6['JIB'] = '★ジブチ';
area3['DMA'] = new Object();
area3['DMA']['POP'] = 'プエルトプラタ';
area4['POP'] = 'TC1_3';
area5['POP'] = 'DMA';

area6['POP'] = new Object();
area6['POP'] = 'プエルトプラタ';
area3['DMA']['SDQ'] = 'サントドミンゴ';
area4['SDQ'] = 'TC1_3';
area5['SDQ'] = 'DMA';

area6['SDQ'] = new Object();
area6['SDQ'] = 'サントドミンゴ';
area3['DNK'] = new Object();
area3['DNK']['CPH'] = '★コペンハーゲン';
area4['CPH'] = 'TC2_1';
area5['CPH'] = 'DNK';

area6['CPH'] = new Object();
area6['CPH'] = '★コペンハーゲン';
area3['DNK']['BLL'] = 'ビルン';
area4['BLL'] = 'TC2_1';
area5['BLL'] = 'DNK';

area6['BLL'] = new Object();
area6['BLL'] = 'ビルン';
area3['DNK']['AAL'] = 'オールボー';
area4['AAL'] = 'TC2_1';
area5['AAL'] = 'DNK';

area6['AAL'] = new Object();
area6['AAL'] = 'オールボー';
area3['DNK']['RNN'] = 'ボーンホルム';
area4['RNN'] = 'TC2_1';
area5['RNN'] = 'DNK';

area6['RNN'] = new Object();
area6['RNN'] = 'ボーンホルム';
area3['DNK']['AAR'] = 'オーフス';
area4['AAR'] = 'TC2_1';
area5['AAR'] = 'DNK';

area6['AAR'] = new Object();
area6['AAR'] = 'オーフス';
area3['DZA'] = new Object();
area3['DZA']['ALG'] = '★アルジェ';
area4['ALG'] = 'TC2_2';
area5['ALG'] = 'DZA';

area6['ALG'] = new Object();
area6['ALG'] = '★アルジェ';
area3['ECU'] = new Object();
area3['ECU']['UIO'] = 'キト';
area4['UIO'] = 'TC1_3';
area5['UIO'] = 'ECU';

area6['UIO'] = new Object();
area6['UIO'] = 'キト';
area3['ECU']['GYE'] = 'グアヤキル';
area4['GYE'] = 'TC1_3';
area5['GYE'] = 'ECU';

area6['GYE'] = new Object();
area6['GYE'] = 'グアヤキル';
area3['EGY'] = new Object();
area3['EGY']['CAI'] = '★カイロ';
area4['CAI'] = 'TC2_2';
area5['CAI'] = 'EGY';

area6['CAI'] = new Object();
area6['CAI'] = '★カイロ';
area3['EGY']['LXR'] = 'ルクソール';
area4['LXR'] = 'TC2_2';
area5['LXR'] = 'EGY';

area6['LXR'] = new Object();
area6['LXR'] = 'ルクソール';
area3['EGY']['SSH'] = 'シャルムエルシェイク';
area4['SSH'] = 'TC2_2';
area5['SSH'] = 'EGY';

area6['SSH'] = new Object();
area6['SSH'] = 'シャルムエルシェイク';
area3['EGY']['HRG'] = 'ハルガタ';
area4['HRG'] = 'TC2_2';
area5['HRG'] = 'EGY';

area6['HRG'] = new Object();
area6['HRG'] = 'ハルガタ';
area3['EGY']['ALY'] = 'アレキサンドリア';
area4['ALY'] = 'TC2_2';
area5['ALY'] = 'EGY';

area6['ALY'] = new Object();
area6['ALY'] = 'アレキサンドリア';
area3['ERI'] = new Object();
area3['ERI']['ASM'] = 'アスマラ';
area4['ASM'] = 'TC2_2';
area5['ASM'] = 'ERI';

area6['ASM'] = new Object();
area6['ASM'] = 'アスマラ';
area3['ESP'] = new Object();
area3['ESP']['BCN'] = '★バルセロナ';
area4['BCN'] = 'TC2_1';
area5['BCN'] = 'ESP';

area6['BCN'] = new Object();
area6['BCN'] = '★バルセロナ';
area3['ESP']['MAD'] = '★マドリード';
area4['MAD'] = 'TC2_1';
area5['MAD'] = 'ESP';

area6['MAD'] = new Object();
area6['MAD'] = '★マドリード';
area3['ESP']['AGP'] = '★マラガ';
area4['AGP'] = 'TC2_1';
area5['AGP'] = 'ESP';

area6['AGP'] = new Object();
area6['AGP'] = '★マラガ';
area3['ESP']['SCQ'] = 'サンティアゴ・デ・コンポステラ';
area4['SCQ'] = 'TC2_1';
area5['SCQ'] = 'ESP';

area6['SCQ'] = new Object();
area6['SCQ'] = 'サンティアゴ・デ・コンポステラ';
area3['ESP']['VLC'] = 'バレンシア';
area4['VLC'] = 'TC2_1';
area5['VLC'] = 'ESP';

area6['VLC'] = new Object();
area6['VLC'] = 'バレンシア';
area3['ESP']['BIO'] = 'ビルバオ';
area4['BIO'] = 'TC2_1';
area5['BIO'] = 'ESP';

area6['BIO'] = new Object();
area6['BIO'] = 'ビルバオ';
area3['ESP']['GRX'] = 'グラナダ';
area4['GRX'] = 'TC2_1';
area5['GRX'] = 'ESP';

area6['GRX'] = new Object();
area6['GRX'] = 'グラナダ';
area3['ESP']['IBZ'] = 'イビサ（島）';
area4['IBZ'] = 'TC2_1';
area5['IBZ'] = 'ESP';

area6['IBZ'] = new Object();
area6['IBZ'] = 'イビサ（島）';
area3['ESP']['LCG'] = 'ラコルーニャ';
area4['LCG'] = 'TC2_1';
area5['LCG'] = 'ESP';

area6['LCG'] = new Object();
area6['LCG'] = 'ラコルーニャ';
area3['ESP']['LPA'] = 'ラス・パルマス（カナリア諸島）';
area4['LPA'] = 'TC2_1';
area5['LPA'] = 'ESP';

area6['LPA'] = new Object();
area6['LPA'] = 'ラス・パルマス（カナリア諸島）';
area3['ESP']['OVD'] = 'オビエド';
area4['OVD'] = 'TC2_1';
area5['OVD'] = 'ESP';

area6['OVD'] = new Object();
area6['OVD'] = 'オビエド';
area3['ESP']['PMI'] = 'パルマ・デ・マリョルカ';
area4['PMI'] = 'TC2_1';
area5['PMI'] = 'ESP';

area6['PMI'] = new Object();
area6['PMI'] = 'パルマ・デ・マリョルカ';
area3['ESP']['SVQ'] = 'セビリア';
area4['SVQ'] = 'TC2_1';
area5['SVQ'] = 'ESP';

area6['SVQ'] = new Object();
area6['SVQ'] = 'セビリア';
area3['ESP']['XRY'] = 'ヘレス・デ・ラ・フロンテーラ';
area4['XRY'] = 'TC2_1';
area5['XRY'] = 'ESP';

area6['XRY'] = new Object();
area6['XRY'] = 'ヘレス・デ・ラ・フロンテーラ';
area3['ESP']['FUE'] = 'フエルテベントゥーラ';
area4['FUE'] = 'TC2_1';
area5['FUE'] = 'ESP';

area6['FUE'] = new Object();
area6['FUE'] = 'フエルテベントゥーラ';
area3['ESP']['ALC'] = 'アリカンテ';
area4['ALC'] = 'TC2_1';
area5['ALC'] = 'ESP';

area6['ALC'] = new Object();
area6['ALC'] = 'アリカンテ';
area3['EST'] = new Object();
area3['EST']['TLL'] = '★タリン';
area4['TLL'] = 'TC2_1';
area5['TLL'] = 'EST';

area6['TLL'] = new Object();
area6['TLL'] = '★タリン';
area3['EST']['TAY'] = 'タルトゥ';
area4['TAY'] = 'TC2_1';
area5['TAY'] = 'EST';

area6['TAY'] = new Object();
area6['TAY'] = 'タルトゥ';
area3['ETH'] = new Object();
area3['ETH']['ADD'] = '★アジスアベバ';
area4['ADD'] = 'TC2_2';
area5['ADD'] = 'ETH';

area6['ADD'] = new Object();
area6['ADD'] = '★アジスアベバ';
area3['FIN'] = new Object();
area3['FIN']['HEL'] = '★ヘルシンキ';
area4['HEL'] = 'TC2_1';
area5['HEL'] = 'FIN';

area6['HEL'] = new Object();
area6['HEL'] = '★ヘルシンキ';
area3['FIN']['KAJ'] = 'カヤーニ';
area4['KAJ'] = 'TC2_1';
area5['KAJ'] = 'FIN';

area6['KAJ'] = new Object();
area6['KAJ'] = 'カヤーニ';
area3['FIN']['KAO'] = 'クーサモ';
area4['KAO'] = 'TC2_1';
area5['KAO'] = 'FIN';

area6['KAO'] = new Object();
area6['KAO'] = 'クーサモ';
area3['FIN']['KEM'] = 'ケミ';
area4['KEM'] = 'TC2_1';
area5['KEM'] = 'FIN';

area6['KEM'] = new Object();
area6['KEM'] = 'ケミ';
area3['FIN']['KOK'] = 'コッコラ';
area4['KOK'] = 'TC2_1';
area5['KOK'] = 'FIN';

area6['KOK'] = new Object();
area6['KOK'] = 'コッコラ';
area3['FIN']['KTT'] = 'キッテラ';
area4['KTT'] = 'TC2_1';
area5['KTT'] = 'FIN';

area6['KTT'] = new Object();
area6['KTT'] = 'キッテラ';
area3['FIN']['RVN'] = 'ロバニエミ';
area4['RVN'] = 'TC2_1';
area5['RVN'] = 'FIN';

area6['RVN'] = new Object();
area6['RVN'] = 'ロバニエミ';
area3['FIN']['MHQ'] = 'マリエハムン(オーランド諸島)';
area4['MHQ'] = 'TC2_1';
area5['MHQ'] = 'FIN';

area6['MHQ'] = new Object();
area6['MHQ'] = 'マリエハムン(オーランド諸島)';
area3['FIN']['OUL'] = 'オウル';
area4['OUL'] = 'TC2_1';
area5['OUL'] = 'FIN';

area6['OUL'] = new Object();
area6['OUL'] = 'オウル';
area3['FIN']['POR'] = 'ポリ';
area4['POR'] = 'TC2_1';
area5['POR'] = 'FIN';

area6['POR'] = new Object();
area6['POR'] = 'ポリ';
area3['FIN']['KUO'] = 'クオピオ';
area4['KUO'] = 'TC2_1';
area5['KUO'] = 'FIN';

area6['KUO'] = new Object();
area6['KUO'] = 'クオピオ';
area3['FIN']['IVL'] = 'イヴァロ';
area4['IVL'] = 'TC2_1';
area5['IVL'] = 'FIN';

area6['IVL'] = new Object();
area6['IVL'] = 'イヴァロ';
area3['FIN']['JOE'] = 'ヨエンス';
area4['JOE'] = 'TC2_1';
area5['JOE'] = 'FIN';

area6['JOE'] = new Object();
area6['JOE'] = 'ヨエンス';
area3['FIN']['JYV'] = 'ユバスキュラ';
area4['JYV'] = 'TC2_1';
area5['JYV'] = 'FIN';

area6['JYV'] = new Object();
area6['JYV'] = 'ユバスキュラ';
area3['FIN']['TMP'] = 'タンペレ';
area4['TMP'] = 'TC2_1';
area5['TMP'] = 'FIN';

area6['TMP'] = new Object();
area6['TMP'] = 'タンペレ';
area3['FIN']['TKU'] = 'トゥルク';
area4['TKU'] = 'TC2_1';
area5['TKU'] = 'FIN';

area6['TKU'] = new Object();
area6['TKU'] = 'トゥルク';
area3['FIN']['SVL'] = 'サヴォンリンナ';
area4['SVL'] = 'TC2_1';
area5['SVL'] = 'FIN';

area6['SVL'] = new Object();
area6['SVL'] = 'サヴォンリンナ';
area3['FIN']['SJY'] = 'セイナヨキ';
area4['SJY'] = 'TC2_1';
area5['SJY'] = 'FIN';

area6['SJY'] = new Object();
area6['SJY'] = 'セイナヨキ';
area3['FIN']['VAA'] = 'バーサ';
area4['VAA'] = 'TC2_1';
area5['VAA'] = 'FIN';

area6['VAA'] = new Object();
area6['VAA'] = 'バーサ';
area3['FJI'] = new Object();
area3['FJI']['NAN'] = '★ナンディ';
area4['NAN'] = 'TC3_3';
area5['NAN'] = 'FJI';

area6['NAN'] = new Object();
area6['NAN'] = '★ナンディ';
area3['FRA'] = new Object();
area3['FRA']['PAR'] = '★パリ';
area4['PAR'] = 'TC2_1';
area5['PAR'] = 'FRA';

area6['PAR'] = new Object();
area6['PAR'] = '★パリ';
area3['FRA']['LYS'] = 'リヨン';
area4['LYS'] = 'TC2_1';
area5['LYS'] = 'FRA';

area6['LYS'] = new Object();
area6['LYS'] = 'リヨン';
area3['FRA']['NCE'] = 'ニース';
area4['NCE'] = 'TC2_1';
area5['NCE'] = 'FRA';

area6['NCE'] = new Object();
area6['NCE'] = 'ニース';
area3['FRA']['MRS'] = 'マルセイユ';
area4['MRS'] = 'TC2_1';
area5['MRS'] = 'FRA';

area6['MRS'] = new Object();
area6['MRS'] = 'マルセイユ';
area3['FRA']['BSL'] = 'バーゼル';
area4['BSL'] = 'TC2_1';
area5['BSL'] = 'FRA';

area6['BSL'] = new Object();
area6['BSL'] = 'バーゼル';
area3['FRA']['SXB'] = 'ストラスブール';
area4['SXB'] = 'TC2_1';
area5['SXB'] = 'FRA';

area6['SXB'] = new Object();
area6['SXB'] = 'ストラスブール';
area3['FRA']['TLS'] = 'トゥールーズ';
area4['TLS'] = 'TC2_1';
area5['TLS'] = 'FRA';

area6['TLS'] = new Object();
area6['TLS'] = 'トゥールーズ';
area3['FRA']['BOD'] = 'ボルドー';
area4['BOD'] = 'TC2_1';
area5['BOD'] = 'FRA';

area6['BOD'] = new Object();
area6['BOD'] = 'ボルドー';
area3['FRA']['MPL'] = 'モンペリエ';
area4['MPL'] = 'TC2_1';
area5['MPL'] = 'FRA';

area6['MPL'] = new Object();
area6['MPL'] = 'モンペリエ';
area3['FRA']['BIA'] = 'バスティア（コルシカ島）';
area4['BIA'] = 'TC2_1';
area5['BIA'] = 'FRA';

area6['BIA'] = new Object();
area6['BIA'] = 'バスティア（コルシカ島）';
area3['FRA']['LYN'] = 'リヨン（リヨン・ブロン）';
area4['LYN'] = 'TC2_1';
area5['LYN'] = 'FRA';

area6['LYN'] = new Object();
area6['LYN'] = 'リヨン（リヨン・ブロン）';
area3['FRA']['LIL'] = 'リール';
area4['LIL'] = 'TC2_1';
area5['LIL'] = 'FRA';

area6['LIL'] = new Object();
area6['LIL'] = 'リール';
area3['FRA']['FSC'] = 'フィガリ';
area4['FSC'] = 'TC2_1';
area5['FSC'] = 'FRA';

area6['FSC'] = new Object();
area6['FSC'] = 'フィガリ';
area3['FRA']['RUN'] = 'レユニオン';
area4['RUN'] = 'TC2_1';
area5['RUN'] = 'FRA';

area6['RUN'] = new Object();
area6['RUN'] = 'レユニオン';
area3['FRA']['CDG'] = 'パリ（シャルル・ド・ゴール）';
area4['CDG'] = 'TC2_1';
area5['CDG'] = 'FRA';

area6['CDG'] = new Object();
area6['CDG'] = 'パリ（シャルル・ド・ゴール）';
area3['FRA']['AJA'] = 'アジャクシオ';
area4['AJA'] = 'TC2_1';
area5['AJA'] = 'FRA';

area6['AJA'] = new Object();
area6['AJA'] = 'アジャクシオ';
area3['FRA']['TLN'] = 'トゥーロン';
area4['TLN'] = 'TC2_1';
area5['TLN'] = 'FRA';

area6['TLN'] = new Object();
area6['TLN'] = 'トゥーロン';
area3['FRA']['ORY'] = '★パリ(オルリー)';
area4['ORY'] = 'TC2_1';
area5['ORY'] = 'FRA';

area6['ORY'] = new Object();
area6['ORY'] = '★パリ(オルリー)';
area3['FRA']['NTE'] = 'ナント';
area4['NTE'] = 'TC2_1';
area5['NTE'] = 'FRA';

area6['NTE'] = new Object();
area6['NTE'] = 'ナント';
area3['FRA']['NCY'] = 'アヌシー';
area4['NCY'] = 'TC2_1';
area5['NCY'] = 'FRA';

area6['NCY'] = new Object();
area6['NCY'] = 'アヌシー';
area3['FSM'] = new Object();
area3['FSM']['PNI'] = '★バリキール（ポンペイ）';
area4['PNI'] = 'TC3_5';
area5['PNI'] = 'FSM';

area6['PNI'] = new Object();
area6['PNI'] = '★バリキール（ポンペイ）';
area3['FSM']['TKK'] = 'チューク諸島';
area4['TKK'] = 'TC3_5';
area5['TKK'] = 'FSM';

area6['TKK'] = new Object();
area6['TKK'] = 'チューク諸島';
area3['GAB'] = new Object();
area3['GAB']['LBV'] = '★リーブルヴィル';
area4['LBV'] = 'TC2_2';
area5['LBV'] = 'GAB';

area6['LBV'] = new Object();
area6['LBV'] = '★リーブルヴィル';
area3['GBR'] = new Object();
area3['GBR']['LON'] = '★ロンドン';
area4['LON'] = 'TC2_1';
area5['LON'] = 'GBR';

area6['LON'] = new Object();
area6['LON'] = '★ロンドン';
area3['GBR']['MAN'] = 'マンチェスター';
area4['MAN'] = 'TC2_1';
area5['MAN'] = 'GBR';

area6['MAN'] = new Object();
area6['MAN'] = 'マンチェスター';
area3['GBR']['LPL'] = 'リヴァプール';
area4['LPL'] = 'TC2_1';
area5['LPL'] = 'GBR';

area6['LPL'] = new Object();
area6['LPL'] = 'リヴァプール';
area3['GBR']['BFS'] = 'ベルファスト';
area4['BFS'] = 'TC2_1';
area5['BFS'] = 'GBR';

area6['BFS'] = new Object();
area6['BFS'] = 'ベルファスト';
area3['GBR']['BHX'] = 'バーミンガム';
area4['BHX'] = 'TC2_1';
area5['BHX'] = 'GBR';

area6['BHX'] = new Object();
area6['BHX'] = 'バーミンガム';
area3['GBR']['LHR'] = 'ロンドン（ヒースロー）';
area4['LHR'] = 'TC2_1';
area5['LHR'] = 'GBR';

area6['LHR'] = new Object();
area6['LHR'] = 'ロンドン（ヒースロー）';
area3['GBR']['LGW'] = 'ロンドン（ガトウィック）';
area4['LGW'] = 'TC2_1';
area5['LGW'] = 'GBR';

area6['LGW'] = new Object();
area6['LGW'] = 'ロンドン（ガトウィック）';
area3['GBR']['STN'] = 'ロンドン（ロンドン・スタンステッド）';
area4['STN'] = 'TC2_1';
area5['STN'] = 'GBR';

area6['STN'] = new Object();
area6['STN'] = 'ロンドン（ロンドン・スタンステッド）';
area3['GBR']['LTN'] = 'ロンドン（ロンドン・ルートン）';
area4['LTN'] = 'TC2_1';
area5['LTN'] = 'GBR';

area6['LTN'] = new Object();
area6['LTN'] = 'ロンドン（ロンドン・ルートン）';
area3['GBR']['LCY'] = 'ロンドン（ロンドン・シティ）';
area4['LCY'] = 'TC2_1';
area5['LCY'] = 'GBR';

area6['LCY'] = new Object();
area6['LCY'] = 'ロンドン（ロンドン・シティ）';
area3['GBR']['BRS'] = 'ブリストル';
area4['BRS'] = 'TC2_1';
area5['BRS'] = 'GBR';

area6['BRS'] = new Object();
area6['BRS'] = 'ブリストル';
area3['GBR']['NCL'] = 'ニューカッスル';
area4['NCL'] = 'TC2_1';
area5['NCL'] = 'GBR';

area6['NCL'] = new Object();
area6['NCL'] = 'ニューカッスル';
area3['GBR']['ABZ'] = 'アバディーン';
area4['ABZ'] = 'TC2_1';
area5['ABZ'] = 'GBR';

area6['ABZ'] = new Object();
area6['ABZ'] = 'アバディーン';
area3['GBR']['GLA'] = 'グラスゴー';
area4['GLA'] = 'TC2_1';
area5['GLA'] = 'GBR';

area6['GLA'] = new Object();
area6['GLA'] = 'グラスゴー';
area3['GBR']['GCI'] = 'ガーンジー島';
area4['GCI'] = 'TC2_1';
area5['GCI'] = 'GBR';

area6['GCI'] = new Object();
area6['GCI'] = 'ガーンジー島';
area3['GBR']['EDI'] = 'エジンバラ';
area4['EDI'] = 'TC2_1';
area5['EDI'] = 'GBR';

area6['EDI'] = new Object();
area6['EDI'] = 'エジンバラ';
area3['GEO'] = new Object();
area3['GEO']['TBS'] = 'トビリシ';
area4['TBS'] = 'TC2_1';
area5['TBS'] = 'GEO';

area6['TBS'] = new Object();
area6['TBS'] = 'トビリシ';
area3['GHA'] = new Object();
area3['GHA']['ACC'] = '★アクラ';
area4['ACC'] = 'TC2_2';
area5['ACC'] = 'GHA';

area6['ACC'] = new Object();
area6['ACC'] = '★アクラ';
area3['GIB'] = new Object();
area3['GIB']['GIB'] = 'ジブラルタル';
area4['GIB'] = '';
area5['GIB'] = 'GIB';

area6['GIB'] = new Object();
area6['GIB'] = 'ジブラルタル';
area3['GMB'] = new Object();
area3['GMB']['BJL'] = 'バンジュール';
area4['BJL'] = 'TC2_2';
area5['BJL'] = 'GMB';

area6['BJL'] = new Object();
area6['BJL'] = 'バンジュール';
area3['GNQ'] = new Object();
area3['GNQ']['SSG'] = '★マラボ';
area4['SSG'] = 'TC2_2';
area5['SSG'] = 'GNQ';

area6['SSG'] = new Object();
area6['SSG'] = '★マラボ';
area3['GRC'] = new Object();
area3['GRC']['ATH'] = '★アテネ';
area4['ATH'] = 'TC2_1';
area5['ATH'] = 'GRC';

area6['ATH'] = new Object();
area6['ATH'] = '★アテネ';
area3['GRC']['HER'] = 'イラクリオ（クレタ島）';
area4['HER'] = 'TC2_1';
area5['HER'] = 'GRC';

area6['HER'] = new Object();
area6['HER'] = 'イラクリオ（クレタ島）';
area3['GRC']['SKG'] = 'テッサロニキ';
area4['SKG'] = 'TC2_1';
area5['SKG'] = 'GRC';

area6['SKG'] = new Object();
area6['SKG'] = 'テッサロニキ';
area3['GRC']['JMK'] = 'ミコノス';
area4['JMK'] = 'TC2_1';
area5['JMK'] = 'GRC';

area6['JMK'] = new Object();
area6['JMK'] = 'ミコノス';
area3['GRC']['JTR'] = 'サントリーニ';
area4['JTR'] = 'TC2_1';
area5['JTR'] = 'GRC';

area6['JTR'] = new Object();
area6['JTR'] = 'サントリーニ';
area3['GRD'] = new Object();
area3['GRD']['GUA'] = 'グアテマラシティ';
area4['GUA'] = 'TC1';
area5['GUA'] = 'GRD';

area6['GUA'] = new Object();
area6['GUA'] = 'グアテマラシティ';
area3['GRD']['GND'] = 'セントジョーンズ';
area4['GND'] = 'TC1';
area5['GND'] = 'GRD';

area6['GND'] = new Object();
area6['GND'] = 'セントジョーンズ';
area3['GUM'] = new Object();
area3['GUM']['GUM'] = '★グアム';
area4['GUM'] = 'TC3_5';
area5['GUM'] = 'GUM';

area6['GUM'] = new Object();
area6['GUM'] = '★グアム';
area3['HEK'] = new Object();
area3['HEK']['CHN'] = '黒河';
area4['CHN'] = '';
area5['CHN'] = 'HEK';

area6['CHN'] = new Object();
area6['CHN'] = '黒河';
area3['HKG'] = new Object();
area3['HKG']['HKG'] = '★香港';
area4['HKG'] = 'TC3_1';
area5['HKG'] = 'HKG';

area6['HKG'] = new Object();
area6['HKG'] = '★香港';
area3['HND'] = new Object();
area3['HND']['LCE'] = 'ラセイバ';
area4['LCE'] = 'TC1_3';
area5['LCE'] = 'HND';

area6['LCE'] = new Object();
area6['LCE'] = 'ラセイバ';
area3['HND']['TGU'] = 'テグシガルバ';
area4['TGU'] = 'TC1_3';
area5['TGU'] = 'HND';

area6['TGU'] = new Object();
area6['TGU'] = 'テグシガルバ';
area3['HND']['SAP'] = 'サンペドロスーラ';
area4['SAP'] = 'TC1_3';
area5['SAP'] = 'HND';

area6['SAP'] = new Object();
area6['SAP'] = 'サンペドロスーラ';
area3['HRV'] = new Object();
area3['HRV']['ZAG'] = '★ザブレブ';
area4['ZAG'] = 'TC2_1';
area5['ZAG'] = 'HRV';

area6['ZAG'] = new Object();
area6['ZAG'] = '★ザブレブ';
area3['HRV']['DBV'] = '★ドブロブニク';
area4['DBV'] = 'TC2_1';
area5['DBV'] = 'HRV';

area6['DBV'] = new Object();
area6['DBV'] = '★ドブロブニク';
area3['HRV']['ZAD'] = 'ザダール';
area4['ZAD'] = 'TC2_1';
area5['ZAD'] = 'HRV';

area6['ZAD'] = new Object();
area6['ZAD'] = 'ザダール';
area3['HRV']['SPU'] = 'スプリット';
area4['SPU'] = 'TC2_1';
area5['SPU'] = 'HRV';

area6['SPU'] = new Object();
area6['SPU'] = 'スプリット';
area3['HTI'] = new Object();
area3['HTI']['PAP'] = 'ポルトープランス';
area4['PAP'] = 'TC1_3';
area5['PAP'] = 'HTI';

area6['PAP'] = new Object();
area6['PAP'] = 'ポルトープランス';
area3['HUN'] = new Object();
area3['HUN']['BUD'] = '★ブタペスト';
area4['BUD'] = 'TC2_1';
area5['BUD'] = 'HUN';

area6['BUD'] = new Object();
area6['BUD'] = '★ブタペスト';
area3['HWI'] = new Object();
area3['HWI']['HNL'] = '★ホノルル';
area4['HNL'] = 'TC1_2';
area5['HNL'] = 'HWI';

area6['HNL'] = new Object();
area6['HNL'] = '★ホノルル';
area3['HWI']['KOA'] = 'コナ';
area4['KOA'] = 'TC1_2';
area5['KOA'] = 'HWI';

area6['KOA'] = new Object();
area6['KOA'] = 'コナ';
area3['HWI']['ITO'] = 'ヒロ';
area4['ITO'] = 'TC1_2';
area5['ITO'] = 'HWI';

area6['ITO'] = new Object();
area6['ITO'] = 'ヒロ';
area3['HWI']['OGG'] = 'カフルイ';
area4['OGG'] = 'TC1_2';
area5['OGG'] = 'HWI';

area6['OGG'] = new Object();
area6['OGG'] = 'カフルイ';
area3['HWI']['JHM'] = 'カパルア';
area4['JHM'] = 'TC1_2';
area5['JHM'] = 'HWI';

area6['JHM'] = new Object();
area6['JHM'] = 'カパルア';
area3['HWI']['LNY'] = 'ラナイシティ';
area4['LNY'] = 'TC1_2';
area5['LNY'] = 'HWI';

area6['LNY'] = new Object();
area6['LNY'] = 'ラナイシティ';
area3['HWI']['LIH'] = 'リフェ';
area4['LIH'] = 'TC1_2';
area5['LIH'] = 'HWI';

area6['LIH'] = new Object();
area6['LIH'] = 'リフェ';
area3['IDN'] = new Object();
area3['IDN']['JKT'] = '★ジャカルタ';
area4['JKT'] = 'TC3_2';
area5['JKT'] = 'IDN';

area6['JKT'] = new Object();
area6['JKT'] = '★ジャカルタ';
area3['IDN']['DPS'] = '★デンパサール（バリ島）';
area4['DPS'] = 'TC3_2';
area5['DPS'] = 'IDN';

area6['DPS'] = new Object();
area6['DPS'] = '★デンパサール（バリ島）';
area3['IDN']['SUB'] = 'スラバヤ';
area4['SUB'] = 'TC3_2';
area5['SUB'] = 'IDN';

area6['SUB'] = new Object();
area6['SUB'] = 'スラバヤ';
area3['IDN']['JOG'] = '★ジョグジャカルタ';
area4['JOG'] = 'TC3_2';
area5['JOG'] = 'IDN';

area6['JOG'] = new Object();
area6['JOG'] = '★ジョグジャカルタ';
area3['IDN']['YIA'] = 'ジョグジャカルタ国際空港';
area4['YIA'] = 'TC3_2';
area5['YIA'] = 'IDN';

area6['YIA'] = new Object();
area6['YIA'] = 'ジョグジャカルタ国際空港';
area3['IDN']['SOC'] = 'ソロ';
area4['SOC'] = 'TC3_2';
area5['SOC'] = 'IDN';

area6['SOC'] = new Object();
area6['SOC'] = 'ソロ';
area3['IDN']['BPN'] = 'バリクパパン';
area4['BPN'] = 'TC3_2';
area5['BPN'] = 'IDN';

area6['BPN'] = new Object();
area6['BPN'] = 'バリクパパン';
area3['IDN']['PLM'] = 'パレンバン';
area4['PLM'] = 'TC3_2';
area5['PLM'] = 'IDN';

area6['PLM'] = new Object();
area6['PLM'] = 'パレンバン';
area3['IDN']['BDO'] = 'バンドン';
area4['BDO'] = 'TC3_2';
area5['BDO'] = 'IDN';

area6['BDO'] = new Object();
area6['BDO'] = 'バンドン';
area3['IDN']['MDC'] = 'マナド';
area4['MDC'] = 'TC3_2';
area5['MDC'] = 'IDN';

area6['MDC'] = new Object();
area6['MDC'] = 'マナド';
area3['IDN']['KNO'] = 'メダン';
area4['KNO'] = 'TC3_2';
area5['KNO'] = 'IDN';

area6['KNO'] = new Object();
area6['KNO'] = 'メダン';
area3['IDN']['CGK'] = 'ジャカルタ（スカルノハッタ）';
area4['CGK'] = 'TC3_2';
area5['CGK'] = 'IDN';

area6['CGK'] = new Object();
area6['CGK'] = 'ジャカルタ（スカルノハッタ）';
area3['IDN']['HLP'] = 'ジャカルタ（ハリム・プルダナクスマ）';
area4['HLP'] = 'TC3_2';
area5['HLP'] = 'IDN';

area6['HLP'] = new Object();
area6['HLP'] = 'ジャカルタ（ハリム・プルダナクスマ）';
area3['IDN']['LOP'] = 'ロンボク島';
area4['LOP'] = 'TC3_2';
area5['LOP'] = 'IDN';

area6['LOP'] = new Object();
area6['LOP'] = 'ロンボク島';
area3['IND'] = new Object();
area3['IND']['CCU'] = '★コルカタ（旧カルカッタ）';
area4['CCU'] = 'TC3_2';
area5['CCU'] = 'IND';

area6['CCU'] = new Object();
area6['CCU'] = '★コルカタ（旧カルカッタ）';
area3['IND']['DEL'] = '★デリー';
area4['DEL'] = 'TC3_2';
area5['DEL'] = 'IND';

area6['DEL'] = new Object();
area6['DEL'] = '★デリー';
area3['IND']['BOM'] = '★ムンバイ';
area4['BOM'] = 'TC3_2';
area5['BOM'] = 'IND';

area6['BOM'] = new Object();
area6['BOM'] = '★ムンバイ';
area3['IND']['MAA'] = 'チェンナイ（旧マドラス）';
area4['MAA'] = 'TC3_2';
area5['MAA'] = 'IND';

area6['MAA'] = new Object();
area6['MAA'] = 'チェンナイ（旧マドラス）';
area3['IND']['AMD'] = 'アーメダバード';
area4['AMD'] = 'TC3_2';
area5['AMD'] = 'IND';

area6['AMD'] = new Object();
area6['AMD'] = 'アーメダバード';
area3['IND']['IXU'] = 'アウランガバード';
area4['IXU'] = 'TC3_2';
area5['IXU'] = 'IND';

area6['IXU'] = new Object();
area6['IXU'] = 'アウランガバード';
area3['IND']['AGR'] = 'アグラ';
area4['AGR'] = 'TC3_2';
area5['AGR'] = 'IND';

area6['AGR'] = new Object();
area6['AGR'] = 'アグラ';
area3['IND']['ATQ'] = 'アムリトサル';
area4['ATQ'] = 'TC3_2';
area5['ATQ'] = 'IND';

area6['ATQ'] = new Object();
area6['ATQ'] = 'アムリトサル';
area3['IND']['IDR'] = 'インドール';
area4['IDR'] = 'TC3_2';
area5['IDR'] = 'IND';

area6['IDR'] = new Object();
area6['IDR'] = 'インドール';
area3['IND']['UDR'] = 'ウダイプール';
area4['UDR'] = 'TC3_2';
area5['UDR'] = 'IND';

area6['UDR'] = new Object();
area6['UDR'] = 'ウダイプール';
area3['IND']['GAY'] = 'ガヤ';
area4['GAY'] = 'TC3_2';
area5['GAY'] = 'IND';

area6['GAY'] = new Object();
area6['GAY'] = 'ガヤ';
area3['IND']['GOI'] = 'ゴア';
area4['GOI'] = 'TC3_2';
area5['GOI'] = 'IND';

area6['GOI'] = new Object();
area6['GOI'] = 'ゴア';
area3['IND']['CCJ'] = 'コージコード';
area4['CCJ'] = 'TC3_2';
area5['CCJ'] = 'IND';

area6['CCJ'] = new Object();
area6['CCJ'] = 'コージコード';
area3['IND']['COK'] = 'コーチン';
area4['COK'] = 'TC3_2';
area5['COK'] = 'IND';

area6['COK'] = new Object();
area6['COK'] = 'コーチン';
area3['IND']['CJB'] = 'コーヤンブットゥール';
area4['CJB'] = 'TC3_2';
area5['CJB'] = 'IND';

area6['CJB'] = new Object();
area6['CJB'] = 'コーヤンブットゥール';
area3['IND']['JAI'] = 'ジャイプール';
area4['JAI'] = 'TC3_2';
area5['JAI'] = 'IND';

area6['JAI'] = new Object();
area6['JAI'] = 'ジャイプール';
area3['IND']['IXJ'] = 'ジャンムー';
area4['IXJ'] = 'TC3_2';
area5['IXJ'] = 'IND';

area6['IXJ'] = new Object();
area6['IXJ'] = 'ジャンムー';
area3['IND']['JDH'] = 'ジョードプール';
area4['JDH'] = 'TC3_2';
area5['JDH'] = 'IND';

area6['JDH'] = new Object();
area6['JDH'] = 'ジョードプール';
area3['IND']['SXR'] = 'スリナガル';
area4['SXR'] = 'TC3_2';
area5['SXR'] = 'IND';

area6['SXR'] = new Object();
area6['SXR'] = 'スリナガル';
area3['IND']['IXC'] = 'チャンディガル';
area4['IXC'] = 'TC3_2';
area5['IXC'] = 'IND';

area6['IXC'] = new Object();
area6['IXC'] = 'チャンディガル';
area3['IND']['TIR'] = 'ティルパティ';
area4['TIR'] = 'TC3_2';
area5['TIR'] = 'IND';

area6['TIR'] = new Object();
area6['TIR'] = 'ティルパティ';
area3['IND']['TRV'] = 'ティルヴァナンタプラム';
area4['TRV'] = 'TC3_2';
area5['TRV'] = 'IND';

area6['TRV'] = new Object();
area6['TRV'] = 'ティルヴァナンタプラム';
area3['IND']['NAG'] = 'ナーグプール';
area4['NAG'] = 'TC3_2';
area5['NAG'] = 'IND';

area6['NAG'] = new Object();
area6['NAG'] = 'ナーグプール';
area3['IND']['HYD'] = 'ハイデラバード';
area4['HYD'] = 'TC3_2';
area5['HYD'] = 'IND';

area6['HYD'] = new Object();
area6['HYD'] = 'ハイデラバード';
area3['IND']['PAT'] = 'パトナ';
area4['PAT'] = 'TC3_2';
area5['PAT'] = 'IND';

area6['PAT'] = new Object();
area6['PAT'] = 'パトナ';
area3['IND']['VNS'] = 'バラナシ（ベナレス）';
area4['VNS'] = 'TC3_2';
area5['VNS'] = 'IND';

area6['VNS'] = new Object();
area6['VNS'] = 'バラナシ（ベナレス）';
area3['IND']['PNQ'] = 'プネ';
area4['PNQ'] = 'TC3_2';
area5['PNQ'] = 'IND';

area6['PNQ'] = new Object();
area6['PNQ'] = 'プネ';
area3['IND']['BBI'] = 'ブバネシュワル';
area4['BBI'] = 'TC3_2';
area5['BBI'] = 'IND';

area6['BBI'] = new Object();
area6['BBI'] = 'ブバネシュワル';
area3['IND']['BHO'] = 'ボーパール';
area4['BHO'] = 'TC3_2';
area5['BHO'] = 'IND';

area6['BHO'] = new Object();
area6['BHO'] = 'ボーパール';
area3['IND']['IXE'] = 'マンガロール';
area4['IXE'] = 'TC3_2';
area5['IXE'] = 'IND';

area6['IXE'] = new Object();
area6['IXE'] = 'マンガロール';
area3['IND']['RPR'] = 'ライプル';
area4['RPR'] = 'TC3_2';
area5['RPR'] = 'IND';

area6['RPR'] = new Object();
area6['RPR'] = 'ライプル';
area3['IND']['LKO'] = 'ラクナウ';
area4['LKO'] = 'TC3_2';
area5['LKO'] = 'IND';

area6['LKO'] = new Object();
area6['LKO'] = 'ラクナウ';
area3['IND']['IXL'] = 'レー';
area4['IXL'] = 'TC3_2';
area5['IXL'] = 'IND';

area6['IXL'] = new Object();
area6['IXL'] = 'レー';
area3['IND']['TRZ'] = 'ティルチラパリ';
area4['TRZ'] = 'TC3_2';
area5['TRZ'] = 'IND';

area6['TRZ'] = new Object();
area6['TRZ'] = 'ティルチラパリ';
area3['IND']['BLR'] = 'バンガロール';
area4['BLR'] = 'TC3_2';
area5['BLR'] = 'IND';

area6['BLR'] = new Object();
area6['BLR'] = 'バンガロール';
area3['IRL'] = new Object();
area3['IRL']['DUB'] = '★ダブリン';
area4['DUB'] = 'TC2_1';
area5['DUB'] = 'IRL';

area6['DUB'] = new Object();
area6['DUB'] = '★ダブリン';
area3['IRL']['ORK'] = 'コーク';
area4['ORK'] = 'TC2_1';
area5['ORK'] = 'IRL';

area6['ORK'] = new Object();
area6['ORK'] = 'コーク';
area3['IRL']['SNN'] = 'シャノン';
area4['SNN'] = 'TC2_1';
area5['SNN'] = 'IRL';

area6['SNN'] = new Object();
area6['SNN'] = 'シャノン';
area3['IRL']['NOC'] = 'アイルランド・ウエスト空港ノック';
area4['NOC'] = 'TC2_1';
area5['NOC'] = 'IRL';

area6['NOC'] = new Object();
area6['NOC'] = 'アイルランド・ウエスト空港ノック';
area3['IRN'] = new Object();
area3['IRN']['SYZ'] = 'シーラーズ';
area4['SYZ'] = 'TC2_2';
area5['SYZ'] = 'IRN';

area6['SYZ'] = new Object();
area6['SYZ'] = 'シーラーズ';
area3['IRN']['TBZ'] = 'タブリーズ';
area4['TBZ'] = 'TC2_2';
area5['TBZ'] = 'IRN';

area6['TBZ'] = new Object();
area6['TBZ'] = 'タブリーズ';
area3['IRN']['IKA'] = '★テヘラン（エマーム・ホメイニー）';
area4['IKA'] = 'TC2_2';
area5['IKA'] = 'IRN';

area6['IKA'] = new Object();
area6['IKA'] = '★テヘラン（エマーム・ホメイニー）';
area3['IRN']['THR'] = 'テヘラン（メヘラーバード）';
area4['THR'] = 'TC2_2';
area5['THR'] = 'IRN';

area6['THR'] = new Object();
area6['THR'] = 'テヘラン（メヘラーバード）';
area3['IRN']['MHD'] = 'マシュハド';
area4['MHD'] = 'TC2_2';
area5['MHD'] = 'IRN';

area6['MHD'] = new Object();
area6['MHD'] = 'マシュハド';
area3['ISL'] = new Object();
area3['ISL']['KEF'] = 'レイキャビク';
area4['KEF'] = 'TC2_1';
area5['KEF'] = 'ISL';

area6['KEF'] = new Object();
area6['KEF'] = 'レイキャビク';
area3['ISR'] = new Object();
area3['ISR']['TLV'] = '★テルアビブ';
area4['TLV'] = 'TC2_2';
area5['TLV'] = 'ISR';

area6['TLV'] = new Object();
area6['TLV'] = '★テルアビブ';
area3['ITA'] = new Object();
area3['ITA']['ROM'] = '★ローマ';
area4['ROM'] = 'TC2_1';
area5['ROM'] = 'ITA';

area6['ROM'] = new Object();
area6['ROM'] = '★ローマ';
area3['ITA']['MIL'] = '★ミラノ';
area4['MIL'] = 'TC2_1';
area5['MIL'] = 'ITA';

area6['MIL'] = new Object();
area6['MIL'] = '★ミラノ';
area3['ITA']['VCE'] = '★ヴェネツィア';
area4['VCE'] = 'TC2_1';
area5['VCE'] = 'ITA';

area6['VCE'] = new Object();
area6['VCE'] = '★ヴェネツィア';
area3['ITA']['FLR'] = '★フィレンツェ';
area4['FLR'] = 'TC2_1';
area5['FLR'] = 'ITA';

area6['FLR'] = new Object();
area6['FLR'] = '★フィレンツェ';
area3['ITA']['NAP'] = '★ナポリ';
area4['NAP'] = 'TC2_1';
area5['NAP'] = 'ITA';

area6['NAP'] = new Object();
area6['NAP'] = '★ナポリ';
area3['ITA']['BLQ'] = 'ボローニャ';
area4['BLQ'] = 'TC2_1';
area5['BLQ'] = 'ITA';

area6['BLQ'] = new Object();
area6['BLQ'] = 'ボローニャ';
area3['ITA']['CTA'] = 'カターニア';
area4['CTA'] = 'TC2_1';
area5['CTA'] = 'ITA';

area6['CTA'] = new Object();
area6['CTA'] = 'カターニア';
area3['ITA']['PMO'] = 'パレルモ';
area4['PMO'] = 'TC2_1';
area5['PMO'] = 'ITA';

area6['PMO'] = new Object();
area6['PMO'] = 'パレルモ';
area3['ITA']['PSA'] = 'ピサ';
area4['PSA'] = 'TC2_1';
area5['PSA'] = 'ITA';

area6['PSA'] = new Object();
area6['PSA'] = 'ピサ';
area3['ITA']['VRN'] = 'ヴェローナ';
area4['VRN'] = 'TC2_1';
area5['VRN'] = 'ITA';

area6['VRN'] = new Object();
area6['VRN'] = 'ヴェローナ';
area3['ITA']['MXP'] = 'ミラノ（マルペンサ）';
area4['MXP'] = 'TC2_1';
area5['MXP'] = 'ITA';

area6['MXP'] = new Object();
area6['MXP'] = 'ミラノ（マルペンサ）';
area3['ITA']['LIN'] = 'ミラノ（ミラノ・リナーテ）';
area4['LIN'] = 'TC2_1';
area5['LIN'] = 'ITA';

area6['LIN'] = new Object();
area6['LIN'] = 'ミラノ（ミラノ・リナーテ）';
area3['ITA']['FCO'] = 'ローマ（フィウミチーノ）';
area4['FCO'] = 'TC2_1';
area5['FCO'] = 'ITA';

area6['FCO'] = new Object();
area6['FCO'] = 'ローマ（フィウミチーノ）';
area3['ITA']['AOI'] = 'アンコーナ';
area4['AOI'] = 'TC2_1';
area5['AOI'] = 'ITA';

area6['AOI'] = new Object();
area6['AOI'] = 'アンコーナ';
area3['ITA']['RMI'] = 'リミニ';
area4['RMI'] = 'TC2_1';
area5['RMI'] = 'ITA';

area6['RMI'] = new Object();
area6['RMI'] = 'リミニ';
area3['ITA']['SUF'] = 'ラメーツィア・テルメ';
area4['SUF'] = 'TC2_1';
area5['SUF'] = 'ITA';

area6['SUF'] = new Object();
area6['SUF'] = 'ラメーツィア・テルメ';
area3['ITA']['BGY'] = 'ミラノ（ベルガモ）';
area4['BGY'] = 'TC2_1';
area5['BGY'] = 'ITA';

area6['BGY'] = new Object();
area6['BGY'] = 'ミラノ（ベルガモ）';
area3['ITA']['CAG'] = 'カリャーリ';
area4['CAG'] = 'TC2_1';
area5['CAG'] = 'ITA';

area6['CAG'] = new Object();
area6['CAG'] = 'カリャーリ';
area3['ITA']['AHO'] = 'アルゲーロ';
area4['AHO'] = 'TC2_1';
area5['AHO'] = 'ITA';

area6['AHO'] = new Object();
area6['AHO'] = 'アルゲーロ';
area3['ITA']['REG'] = 'レッジョ・ディ・カラブリア';
area4['REG'] = 'TC2_1';
area5['REG'] = 'ITA';

area6['REG'] = new Object();
area6['REG'] = 'レッジョ・ディ・カラブリア';
area3['ITA']['BRI'] = 'バーリ';
area4['BRI'] = 'TC2_1';
area5['BRI'] = 'ITA';

area6['BRI'] = new Object();
area6['BRI'] = 'バーリ';
area3['ITA']['BZO'] = 'ボルツァーノ';
area4['BZO'] = 'TC2_1';
area5['BZO'] = 'ITA';

area6['BZO'] = new Object();
area6['BZO'] = 'ボルツァーノ';
area3['ITA']['GOA'] = 'ジェノヴァ';
area4['GOA'] = 'TC2_1';
area5['GOA'] = 'ITA';

area6['GOA'] = new Object();
area6['GOA'] = 'ジェノヴァ';
area3['ITA']['LMP'] = 'ランペドゥーザ';
area4['LMP'] = 'TC2_1';
area5['LMP'] = 'ITA';

area6['LMP'] = new Object();
area6['LMP'] = 'ランペドゥーザ';
area3['ITA']['PMF'] = 'パルマ';
area4['PMF'] = 'TC2_1';
area5['PMF'] = 'ITA';

area6['PMF'] = new Object();
area6['PMF'] = 'パルマ';
area3['ITA']['TRN'] = 'トリノ';
area4['TRN'] = 'TC2_1';
area5['TRN'] = 'ITA';

area6['TRN'] = new Object();
area6['TRN'] = 'トリノ';
area3['JAM'] = new Object();
area3['JAM']['MBJ'] = 'モンテゴベイ';
area4['MBJ'] = 'TC1_3';
area5['MBJ'] = 'JAM';

area6['MBJ'] = new Object();
area6['MBJ'] = 'モンテゴベイ';
area3['JAM']['KIN'] = 'キングストン';
area4['KIN'] = 'TC1_3';
area5['KIN'] = 'JAM';

area6['KIN'] = new Object();
area6['KIN'] = 'キングストン';
area3['JOR'] = new Object();
area3['JOR']['AMM'] = '★アンマン';
area4['AMM'] = 'TC2_2';
area5['AMM'] = 'JOR';

area6['AMM'] = new Object();
area6['AMM'] = '★アンマン';
area3['JPY'] = new Object();
area3['JPY']['TIF'] = 'タイフ';
area4['TIF'] = '';
area5['TIF'] = 'JPY';

area6['TIF'] = new Object();
area6['TIF'] = 'タイフ';
area3['JPY']['WUX'] = '無錫';
area4['WUX'] = '';
area5['WUX'] = 'JPY';

area6['WUX'] = new Object();
area6['WUX'] = '無錫';
area3['JPY']['OXB'] = 'ビサウ';
area4['OXB'] = '';
area5['OXB'] = 'JPY';

area6['OXB'] = new Object();
area6['OXB'] = 'ビサウ';
area3['JPY']['DYU'] = 'ドゥシャンベ';
area4['DYU'] = '';
area5['DYU'] = 'JPY';

area6['DYU'] = new Object();
area6['DYU'] = 'ドゥシャンベ';
area3['JPY']['DAT'] = '大同';
area4['DAT'] = '';
area5['DAT'] = 'JPY';

area6['DAT'] = new Object();
area6['DAT'] = '大同';
area3['JPY']['SJW'] = '石家荘';
area4['SJW'] = '';
area5['SJW'] = 'JPY';

area6['SJW'] = new Object();
area6['SJW'] = '石家荘';
area3['JPY']['TFU'] = '成都天府国際空港';
area4['TFU'] = '';
area5['TFU'] = 'JPY';

area6['TFU'] = new Object();
area6['TFU'] = '成都天府国際空港';
area3['JPY']['CKY'] = 'コナクリ';
area4['CKY'] = '';
area5['CKY'] = 'JPY';

area6['CKY'] = new Object();
area6['CKY'] = 'コナクリ';
area3['JPY']['HBE'] = 'アレクサンドリア（ボルグ・エル・アラブ）';
area4['HBE'] = '';
area5['HBE'] = 'JPY';

area6['HBE'] = new Object();
area6['HBE'] = 'アレクサンドリア（ボルグ・エル・アラブ）';
area3['JPY']['SYR'] = 'シラキューズ';
area4['SYR'] = '';
area5['SYR'] = 'JPY';

area6['SYR'] = new Object();
area6['SYR'] = 'シラキューズ';
area3['KAZ'] = new Object();
area3['KAZ']['ALA'] = '★アルマトイ';
area4['ALA'] = 'TC3_2';
area5['ALA'] = 'KAZ';

area6['ALA'] = new Object();
area6['ALA'] = '★アルマトイ';
area3['KAZ']['TSE'] = '★ヌルスルタン（旧：アスタナ）';
area4['TSE'] = 'TC3_2';
area5['TSE'] = 'KAZ';

area6['TSE'] = new Object();
area6['TSE'] = '★ヌルスルタン（旧：アスタナ）';
area3['KAZ']['CIT'] = 'シムケント';
area4['CIT'] = 'TC3_2';
area5['CIT'] = 'KAZ';

area6['CIT'] = new Object();
area6['CIT'] = 'シムケント';
area3['KEN'] = new Object();
area3['KEN']['NBO'] = '★ナイロビ';
area4['NBO'] = 'TC2_2';
area5['NBO'] = 'KEN';

area6['NBO'] = new Object();
area6['NBO'] = '★ナイロビ';
area3['KEN']['MBA'] = 'モンバサ';
area4['MBA'] = 'TC2_2';
area5['MBA'] = 'KEN';

area6['MBA'] = new Object();
area6['MBA'] = 'モンバサ';
area3['KGZ'] = new Object();
area3['KGZ']['FRU'] = 'ビシュケク';
area4['FRU'] = '';
area5['FRU'] = 'KGZ';

area6['FRU'] = new Object();
area6['FRU'] = 'ビシュケク';
area3['KHM'] = new Object();
area3['KHM']['REP'] = '★シェムリアップ';
area4['REP'] = 'TC3_2';
area5['REP'] = 'KHM';

area6['REP'] = new Object();
area6['REP'] = '★シェムリアップ';
area3['KHM']['PNH'] = 'プノンペン';
area4['PNH'] = 'TC3_2';
area5['PNH'] = 'KHM';

area6['PNH'] = new Object();
area6['PNH'] = 'プノンペン';
area3['KHM']['KOS'] = 'シアヌークビル';
area4['KOS'] = 'TC3_2';
area5['KOS'] = 'KHM';

area6['KOS'] = new Object();
area6['KOS'] = 'シアヌークビル';
area3['KIR'] = new Object();
area3['KIR']['TRW'] = '★タラワ';
area4['TRW'] = 'TC3_5';
area5['TRW'] = 'KIR';

area6['TRW'] = new Object();
area6['TRW'] = '★タラワ';
area3['KOR'] = new Object();
area3['KOR']['SEL'] = '★ソウル';
area4['SEL'] = 'TC3_4';
area5['SEL'] = 'KOR';

area6['SEL'] = new Object();
area6['SEL'] = '★ソウル';
area3['KOR']['PUS'] = '★釜山';
area4['PUS'] = 'TC3_4';
area5['PUS'] = 'KOR';

area6['PUS'] = new Object();
area6['PUS'] = '★釜山';
area3['KOR']['CJU'] = '済州島';
area4['CJU'] = 'TC3_4';
area5['CJU'] = 'KOR';

area6['CJU'] = new Object();
area6['CJU'] = '済州島';
area3['KOR']['ICN'] = 'ソウル（仁川）';
area4['ICN'] = 'TC3_4';
area5['ICN'] = 'KOR';

area6['ICN'] = new Object();
area6['ICN'] = 'ソウル（仁川）';
area3['KOR']['GMP'] = 'ソウル(金浦)';
area4['GMP'] = 'TC3_4';
area5['GMP'] = 'KOR';

area6['GMP'] = new Object();
area6['GMP'] = 'ソウル(金浦)';
area3['KOR']['TAE'] = '大邱';
area4['TAE'] = 'TC3_4';
area5['TAE'] = 'KOR';

area6['TAE'] = new Object();
area6['TAE'] = '大邱';
area3['KOR']['CJJ'] = '清洲';
area4['CJJ'] = 'TC3_4';
area5['CJJ'] = 'KOR';

area6['CJJ'] = new Object();
area6['CJJ'] = '清洲';
area3['KOR']['MWX'] = '務安';
area4['MWX'] = 'TC3_4';
area5['MWX'] = 'KOR';

area6['MWX'] = new Object();
area6['MWX'] = '務安';
area3['KWT'] = new Object();
area3['KWT']['KWI'] = 'クウェート';
area4['KWI'] = 'TC2_2';
area5['KWI'] = 'KWT';

area6['KWI'] = new Object();
area6['KWI'] = 'クウェート';
area3['LAO'] = new Object();
area3['LAO']['VTE'] = '★ビェンチャン';
area4['VTE'] = 'TC3_2';
area5['VTE'] = 'LAO';

area6['VTE'] = new Object();
area6['VTE'] = '★ビェンチャン';
area3['LAO']['LPQ'] = 'ルアンパバーン';
area4['LPQ'] = 'TC3_2';
area5['LPQ'] = 'LAO';

area6['LPQ'] = new Object();
area6['LPQ'] = 'ルアンパバーン';
area3['LBN'] = new Object();
area3['LBN']['BEY'] = '★ベイルート';
area4['BEY'] = 'TC2_2';
area5['BEY'] = 'LBN';

area6['BEY'] = new Object();
area6['BEY'] = '★ベイルート';
area3['LBR'] = new Object();
area3['LBR']['MLW'] = '★モンロビア（ジェームス・スプリッグス・ペイン）';
area4['MLW'] = 'TC2_2';
area5['MLW'] = 'LBR';

area6['MLW'] = new Object();
area6['MLW'] = '★モンロビア（ジェームス・スプリッグス・ペイン）';
area3['LBR']['ROB'] = 'モンロビア（モンロビア・ロバーツ）';
area4['ROB'] = 'TC2_2';
area5['ROB'] = 'LBR';

area6['ROB'] = new Object();
area6['ROB'] = 'モンロビア（モンロビア・ロバーツ）';
area3['LKA'] = new Object();
area3['LKA']['CMB'] = '★コロンボ';
area4['CMB'] = 'TC3_2';
area5['CMB'] = 'LKA';

area6['CMB'] = new Object();
area6['CMB'] = '★コロンボ';
area3['LTU'] = new Object();
area3['LTU']['VNO'] = '★ビリニュス';
area4['VNO'] = 'TC2_1';
area5['VNO'] = 'LTU';

area6['VNO'] = new Object();
area6['VNO'] = '★ビリニュス';
area3['LUX'] = new Object();
area3['LUX']['LUX'] = '★ルクセンブルグ';
area4['LUX'] = 'TC2_1';
area5['LUX'] = 'LUX';

area6['LUX'] = new Object();
area6['LUX'] = '★ルクセンブルグ';
area3['LVA'] = new Object();
area3['LVA']['RIX'] = 'リガ';
area4['RIX'] = 'TC2_1';
area5['RIX'] = 'LVA';

area6['RIX'] = new Object();
area6['RIX'] = 'リガ';
area3['MAC'] = new Object();
area3['MAC']['MFM'] = '★マカオ';
area4['MFM'] = 'TC3_1';
area5['MFM'] = 'MAC';

area6['MFM'] = new Object();
area6['MFM'] = '★マカオ';
area3['MAC']['YFT'] = 'マカオ（タイパＦＴ）';
area4['YFT'] = 'TC3_1';
area5['YFT'] = 'MAC';

area6['YFT'] = new Object();
area6['YFT'] = 'マカオ（タイパＦＴ）';
area3['MAR'] = new Object();
area3['MAR']['CAS'] = '★カサブランカ';
area4['CAS'] = 'TC2_2';
area5['CAS'] = 'MAR';

area6['CAS'] = new Object();
area6['CAS'] = '★カサブランカ';
area3['MAR']['RBA'] = 'ラバト';
area4['RBA'] = 'TC2_2';
area5['RBA'] = 'MAR';

area6['RBA'] = new Object();
area6['RBA'] = 'ラバト';
area3['MAR']['RAK'] = '★マラケシュ';
area4['RAK'] = 'TC2_2';
area5['RAK'] = 'MAR';

area6['RAK'] = new Object();
area6['RAK'] = '★マラケシュ';
area3['MAR']['TNG'] = 'タンジェ';
area4['TNG'] = 'TC2_2';
area5['TNG'] = 'MAR';

area6['TNG'] = new Object();
area6['TNG'] = 'タンジェ';
area3['MAR']['CMN'] = '★カサブランカ';
area4['CMN'] = 'TC2_2';
area5['CMN'] = 'MAR';

area6['CMN'] = new Object();
area6['CMN'] = '★カサブランカ';
area3['MDA'] = new Object();
area3['MDA']['KIV'] = '★キシナウ';
area4['KIV'] = 'TC2_1';
area5['KIV'] = 'MDA';

area6['KIV'] = new Object();
area6['KIV'] = '★キシナウ';
area3['MDG'] = new Object();
area3['MDG']['TNR'] = '★アンタナナリボ';
area4['TNR'] = 'TC2_2';
area5['TNR'] = 'MDG';

area6['TNR'] = new Object();
area6['TNR'] = '★アンタナナリボ';
area3['MDV'] = new Object();
area3['MDV']['MLE'] = '★マーレ';
area4['MLE'] = 'TC3_2';
area5['MLE'] = 'MDV';

area6['MLE'] = new Object();
area6['MLE'] = '★マーレ';
area3['MEX'] = new Object();
area3['MEX']['MEX'] = '★メキシコシティ';
area4['MEX'] = 'TC1_3';
area5['MEX'] = 'MEX';

area6['MEX'] = new Object();
area6['MEX'] = '★メキシコシティ';
area3['MEX']['CUN'] = '★カンクン';
area4['CUN'] = 'TC1_3';
area5['CUN'] = 'MEX';

area6['CUN'] = new Object();
area6['CUN'] = '★カンクン';
area3['MEX']['GDL'] = 'グアダラハラ';
area4['GDL'] = 'TC1_3';
area5['GDL'] = 'MEX';

area6['GDL'] = new Object();
area6['GDL'] = 'グアダラハラ';
area3['MEX']['MTY'] = 'モンテレイ';
area4['MTY'] = 'TC1_3';
area5['MTY'] = 'MEX';

area6['MTY'] = new Object();
area6['MTY'] = 'モンテレイ';
area3['MEX']['ACA'] = 'アカプルコ';
area4['ACA'] = 'TC1_3';
area5['ACA'] = 'MEX';

area6['ACA'] = new Object();
area6['ACA'] = 'アカプルコ';
area3['MEX']['MID'] = 'メリダ';
area4['MID'] = 'TC1_3';
area5['MID'] = 'MEX';

area6['MID'] = new Object();
area6['MID'] = 'メリダ';
area3['MEX']['BJX'] = 'レオン';
area4['BJX'] = 'TC1_3';
area5['BJX'] = 'MEX';

area6['BJX'] = new Object();
area6['BJX'] = 'レオン';
area3['MEX']['OAX'] = 'オアハカ';
area4['OAX'] = 'TC1_3';
area5['OAX'] = 'MEX';

area6['OAX'] = new Object();
area6['OAX'] = 'オアハカ';
area3['MEX']['QRO'] = 'ケレタロ';
area4['QRO'] = 'TC1_3';
area5['QRO'] = 'MEX';

area6['QRO'] = new Object();
area6['QRO'] = 'ケレタロ';
area3['MEX']['AGU'] = 'アグアスカリエンテス';
area4['AGU'] = 'TC1_3';
area5['AGU'] = 'MEX';

area6['AGU'] = new Object();
area6['AGU'] = 'アグアスカリエンテス';
area3['MEX']['CPE'] = 'カンペチェ';
area4['CPE'] = 'TC1_3';
area5['CPE'] = 'MEX';

area6['CPE'] = new Object();
area6['CPE'] = 'カンペチェ';
area3['MEX']['TLC'] = 'トルーカ';
area4['TLC'] = 'TC1_3';
area5['TLC'] = 'MEX';

area6['TLC'] = new Object();
area6['TLC'] = 'トルーカ';
area3['MHL'] = new Object();
area3['MHL']['MAJ'] = '★マジュロ';
area4['MAJ'] = 'TC3_5';
area5['MAJ'] = 'MHL';

area6['MAJ'] = new Object();
area6['MAJ'] = '★マジュロ';
area3['MKD'] = new Object();
area3['MKD']['SKP'] = 'スコピエ';
area4['SKP'] = 'TC2_1';
area5['SKP'] = 'MKD';

area6['SKP'] = new Object();
area6['SKP'] = 'スコピエ';
area3['MLI'] = new Object();
area3['MLI']['BKO'] = '★バマコ';
area4['BKO'] = 'TC2_2';
area5['BKO'] = 'MLI';

area6['BKO'] = new Object();
area6['BKO'] = '★バマコ';
area3['MLI']['NIM'] = 'ニアメ';
area4['NIM'] = 'TC2_2';
area5['NIM'] = 'MLI';

area6['NIM'] = new Object();
area6['NIM'] = 'ニアメ';
area3['MLT'] = new Object();
area3['MLT']['MLA'] = '★マルタ（バレッタ）';
area4['MLA'] = 'TC2_1';
area5['MLA'] = 'MLT';

area6['MLA'] = new Object();
area6['MLA'] = '★マルタ（バレッタ）';
area3['MMR'] = new Object();
area3['MMR']['RGN'] = '★ヤンゴン';
area4['RGN'] = 'TC3_2';
area5['RGN'] = 'MMR';

area6['RGN'] = new Object();
area6['RGN'] = '★ヤンゴン';
area3['MNE'] = new Object();
area3['MNE']['TGD'] = '★ポドゴリツァ';
area4['TGD'] = 'TC2_1';
area5['TGD'] = 'MNE';

area6['TGD'] = new Object();
area6['TGD'] = '★ポドゴリツァ';
area3['MNE']['TIV'] = 'ティヴァト';
area4['TIV'] = 'TC2_1';
area5['TIV'] = 'MNE';

area6['TIV'] = new Object();
area6['TIV'] = 'ティヴァト';
area3['MNG'] = new Object();
area3['MNG']['UBN'] = '★ウランバートル チンギスハーン';
area4['UBN'] = 'TC3_2';
area5['UBN'] = 'MNG';

area6['UBN'] = new Object();
area6['UBN'] = '★ウランバートル チンギスハーン';
area3['MOZ'] = new Object();
area3['MOZ']['MPM'] = '★マプト';
area4['MPM'] = 'TC2_2';
area5['MPM'] = 'MOZ';

area6['MPM'] = new Object();
area6['MPM'] = '★マプト';
area3['MRT'] = new Object();
area3['MRT']['NKC'] = 'ヌアクショット';
area4['NKC'] = 'TC2_2';
area5['NKC'] = 'MRT';

area6['NKC'] = new Object();
area6['NKC'] = 'ヌアクショット';
area3['MUS'] = new Object();
area3['MUS']['MRU'] = '★ポートルイス';
area4['MRU'] = 'TC2_2';
area5['MRU'] = 'MUS';

area6['MRU'] = new Object();
area6['MRU'] = '★ポートルイス';
area3['MWI'] = new Object();
area3['MWI']['LLW'] = '★リロングウェ';
area4['LLW'] = 'TC2_2';
area5['LLW'] = 'MWI';

area6['LLW'] = new Object();
area6['LLW'] = '★リロングウェ';
area3['MYS'] = new Object();
area3['MYS']['KUL'] = '★クアラルンプール';
area4['KUL'] = 'TC3_2';
area5['KUL'] = 'MYS';

area6['KUL'] = new Object();
area6['KUL'] = '★クアラルンプール';
area3['MYS']['BKI'] = 'コタキナバル';
area4['BKI'] = 'TC3_2';
area5['BKI'] = 'MYS';

area6['BKI'] = new Object();
area6['BKI'] = 'コタキナバル';
area3['MYS']['AOR'] = 'アロースター';
area4['AOR'] = 'TC3_2';
area5['AOR'] = 'MYS';

area6['AOR'] = new Object();
area6['AOR'] = 'アロースター';
area3['MYS']['TGG'] = 'クアラトレンガヌ';
area4['TGG'] = 'TC3_2';
area5['TGG'] = 'MYS';

area6['TGG'] = new Object();
area6['TGG'] = 'クアラトレンガヌ';
area3['MYS']['KUA'] = 'クアンタン';
area4['KUA'] = 'TC3_2';
area5['KUA'] = 'MYS';

area6['KUA'] = new Object();
area6['KUA'] = 'クアンタン';
area3['MYS']['JHB'] = 'ジョホール・バル';
area4['JHB'] = 'TC3_2';
area5['JHB'] = 'MYS';

area6['JHB'] = new Object();
area6['JHB'] = 'ジョホール・バル';
area3['MYS']['LGK'] = 'ランカウイ';
area4['LGK'] = 'TC3_2';
area5['LGK'] = 'MYS';

area6['LGK'] = new Object();
area6['LGK'] = 'ランカウイ';
area3['MYS']['KBR'] = 'コタ・バル';
area4['KBR'] = 'TC3_2';
area5['KBR'] = 'MYS';

area6['KBR'] = new Object();
area6['KBR'] = 'コタ・バル';
area3['MYS']['PEN'] = 'ペナン島';
area4['PEN'] = 'TC3_2';
area5['PEN'] = 'MYS';

area6['PEN'] = new Object();
area6['PEN'] = 'ペナン島';
area3['MYS']['SDK'] = 'サンダカン';
area4['SDK'] = 'TC3_2';
area5['SDK'] = 'MYS';

area6['SDK'] = new Object();
area6['SDK'] = 'サンダカン';
area3['MYS']['TWU'] = 'タワウ';
area4['TWU'] = 'TC3_2';
area5['TWU'] = 'MYS';

area6['TWU'] = new Object();
area6['TWU'] = 'タワウ';
area3['MYS']['KCH'] = 'クチン';
area4['KCH'] = 'TC3_2';
area5['KCH'] = 'MYS';

area6['KCH'] = new Object();
area6['KCH'] = 'クチン';
area3['MYS']['SBW'] = 'シブ';
area4['SBW'] = 'TC3_2';
area5['SBW'] = 'MYS';

area6['SBW'] = new Object();
area6['SBW'] = 'シブ';
area3['MYS']['BTU'] = 'ビントゥル';
area4['BTU'] = 'TC3_2';
area5['BTU'] = 'MYS';

area6['BTU'] = new Object();
area6['BTU'] = 'ビントゥル';
area3['MYS']['LBU'] = 'ラブアン';
area4['LBU'] = 'TC3_2';
area5['LBU'] = 'MYS';

area6['LBU'] = new Object();
area6['LBU'] = 'ラブアン';
area3['MYS']['MYY'] = 'ミリ';
area4['MYY'] = 'TC3_2';
area5['MYY'] = 'MYS';

area6['MYY'] = new Object();
area6['MYY'] = 'ミリ';
area3['NAM'] = new Object();
area3['NAM']['WDH'] = 'ウィントフック';
area4['WDH'] = 'TC2_2';
area5['WDH'] = 'NAM';

area6['WDH'] = new Object();
area6['WDH'] = 'ウィントフック';
area3['NCL'] = new Object();
area3['NCL']['NOU'] = '★ヌメア';
area4['NOU'] = 'TC3_3';
area5['NOU'] = 'NCL';

area6['NOU'] = new Object();
area6['NOU'] = '★ヌメア';
area3['NGA'] = new Object();
area3['NGA']['LOS'] = 'ラゴス';
area4['LOS'] = '';
area5['LOS'] = 'NGA';

area6['LOS'] = new Object();
area6['LOS'] = 'ラゴス';
area3['NGA']['ABV'] = 'アブジャ';
area4['ABV'] = '';
area5['ABV'] = 'NGA';

area6['ABV'] = new Object();
area6['ABV'] = 'アブジャ';
area3['NGA']['KAN'] = 'カノ';
area4['KAN'] = '';
area5['KAN'] = 'NGA';

area6['KAN'] = new Object();
area6['KAN'] = 'カノ';
area3['NIC'] = new Object();
area3['NIC']['MGA'] = 'マナグア';
area4['MGA'] = 'TC1_3';
area5['MGA'] = 'NIC';

area6['MGA'] = new Object();
area6['MGA'] = 'マナグア';
area3['NLD'] = new Object();
area3['NLD']['AMS'] = '★アムステルダム';
area4['AMS'] = 'TC2_1';
area5['AMS'] = 'NLD';

area6['AMS'] = new Object();
area6['AMS'] = '★アムステルダム';
area3['NLD']['RTM'] = 'ロッテルダム';
area4['RTM'] = 'TC2_1';
area5['RTM'] = 'NLD';

area6['RTM'] = new Object();
area6['RTM'] = 'ロッテルダム';
area3['NLD']['SXM'] = 'セント・マーチン島';
area4['SXM'] = 'TC2_1';
area5['SXM'] = 'NLD';

area6['SXM'] = new Object();
area6['SXM'] = 'セント・マーチン島';
area3['NOR'] = new Object();
area3['NOR']['OSL'] = '★オスロ';
area4['OSL'] = 'TC2_1';
area5['OSL'] = 'NOR';

area6['OSL'] = new Object();
area6['OSL'] = '★オスロ';
area3['NOR']['SVG'] = 'スタバンゲル';
area4['SVG'] = 'TC2_1';
area5['SVG'] = 'NOR';

area6['SVG'] = new Object();
area6['SVG'] = 'スタバンゲル';
area3['NOR']['MOL'] = 'モルデ';
area4['MOL'] = 'TC2_1';
area5['MOL'] = 'NOR';

area6['MOL'] = new Object();
area6['MOL'] = 'モルデ';
area3['NOR']['TOS'] = 'トロムソ';
area4['TOS'] = 'TC2_1';
area5['TOS'] = 'NOR';

area6['TOS'] = new Object();
area6['TOS'] = 'トロムソ';
area3['NOR']['KSU'] = 'クリスチャンスン';
area4['KSU'] = 'TC2_1';
area5['KSU'] = 'NOR';

area6['KSU'] = new Object();
area6['KSU'] = 'クリスチャンスン';
area3['NOR']['KRS'] = 'クリスティアンサン';
area4['KRS'] = 'TC2_1';
area5['KRS'] = 'NOR';

area6['KRS'] = new Object();
area6['KRS'] = 'クリスティアンサン';
area3['NOR']['KKN'] = 'キルケネス';
area4['KKN'] = 'TC2_1';
area5['KKN'] = 'NOR';

area6['KKN'] = new Object();
area6['KKN'] = 'キルケネス';
area3['NOR']['HAU'] = 'ハウゲスン';
area4['HAU'] = 'TC2_1';
area5['HAU'] = 'NOR';

area6['HAU'] = new Object();
area6['HAU'] = 'ハウゲスン';
area3['NOR']['BOO'] = 'ボーデ';
area4['BOO'] = 'TC2_1';
area5['BOO'] = 'NOR';

area6['BOO'] = new Object();
area6['BOO'] = 'ボーデ';
area3['NOR']['BGO'] = 'ベルゲン';
area4['BGO'] = 'TC2_1';
area5['BGO'] = 'NOR';

area6['BGO'] = new Object();
area6['BGO'] = 'ベルゲン';
area3['NOR']['ALF'] = 'アルタ';
area4['ALF'] = 'TC2_1';
area5['ALF'] = 'NOR';

area6['ALF'] = new Object();
area6['ALF'] = 'アルタ';
area3['NOR']['TRD'] = 'トロンハイム';
area4['TRD'] = 'TC2_1';
area5['TRD'] = 'NOR';

area6['TRD'] = new Object();
area6['TRD'] = 'トロンハイム';
area3['NPL'] = new Object();
area3['NPL']['KTM'] = '★カトマンズ';
area4['KTM'] = 'TC3_2';
area5['KTM'] = 'NPL';

area6['KTM'] = new Object();
area6['KTM'] = '★カトマンズ';
area3['NRU'] = new Object();
area3['NRU']['NRU'] = '★ナウル';
area4['NRU'] = 'TC3_3';
area5['NRU'] = 'NRU';

area6['NRU'] = new Object();
area6['NRU'] = '★ナウル';
area3['NZL'] = new Object();
area3['NZL']['AKL'] = '★オークランド';
area4['AKL'] = 'TC3_3';
area5['AKL'] = 'NZL';

area6['AKL'] = new Object();
area6['AKL'] = '★オークランド';
area3['NZL']['CHC'] = '★クライストチャーチ';
area4['CHC'] = 'TC3_3';
area5['CHC'] = 'NZL';

area6['CHC'] = new Object();
area6['CHC'] = '★クライストチャーチ';
area3['NZL']['ZQN'] = '★クイーンズタウン';
area4['ZQN'] = 'TC3_3';
area5['ZQN'] = 'NZL';

area6['ZQN'] = new Object();
area6['ZQN'] = '★クイーンズタウン';
area3['NZL']['GIS'] = 'ギズボーン';
area4['GIS'] = 'TC3_3';
area5['GIS'] = 'NZL';

area6['GIS'] = new Object();
area6['GIS'] = 'ギズボーン';
area3['NZL']['HLZ'] = 'ハミルトン';
area4['HLZ'] = 'TC3_3';
area5['HLZ'] = 'NZL';

area6['HLZ'] = new Object();
area6['HLZ'] = 'ハミルトン';
area3['NZL']['HKK'] = 'ホキティカ';
area4['HKK'] = 'TC3_3';
area5['HKK'] = 'NZL';

area6['HKK'] = new Object();
area6['HKK'] = 'ホキティカ';
area3['NZL']['IVC'] = 'インバーカーギル';
area4['IVC'] = 'TC3_3';
area5['IVC'] = 'NZL';

area6['IVC'] = new Object();
area6['IVC'] = 'インバーカーギル';
area3['NZL']['KKE'] = 'ケリケリ（ベイ・オブ・アイランド）';
area4['KKE'] = 'TC3_3';
area5['KKE'] = 'NZL';

area6['KKE'] = new Object();
area6['KKE'] = 'ケリケリ（ベイ・オブ・アイランド）';
area3['NZL']['MRO'] = 'マスタートン';
area4['MRO'] = 'TC3_3';
area5['MRO'] = 'NZL';

area6['MRO'] = new Object();
area6['MRO'] = 'マスタートン';
area3['NZL']['NPE'] = 'ネイピア/ヘースティングス';
area4['NPE'] = 'TC3_3';
area5['NPE'] = 'NZL';

area6['NPE'] = new Object();
area6['NPE'] = 'ネイピア/ヘースティングス';
area3['NZL']['NSN'] = 'ネルソン';
area4['NSN'] = 'TC3_3';
area5['NSN'] = 'NZL';

area6['NSN'] = new Object();
area6['NSN'] = 'ネルソン';
area3['NZL']['PMR'] = 'パーマストンノース';
area4['PMR'] = 'TC3_3';
area5['PMR'] = 'NZL';

area6['PMR'] = new Object();
area6['PMR'] = 'パーマストンノース';
area3['NZL']['DUD'] = 'ダニーデン';
area4['DUD'] = 'TC3_3';
area5['DUD'] = 'NZL';

area6['DUD'] = new Object();
area6['DUD'] = 'ダニーデン';
area3['NZL']['ROT'] = 'ロトルア';
area4['ROT'] = 'TC3_3';
area5['ROT'] = 'NZL';

area6['ROT'] = new Object();
area6['ROT'] = 'ロトルア';
area3['NZL']['TUO'] = 'タウポ';
area4['TUO'] = 'TC3_3';
area5['TUO'] = 'NZL';

area6['TUO'] = new Object();
area6['TUO'] = 'タウポ';
area3['NZL']['TRG'] = 'タウランガ';
area4['TRG'] = 'TC3_3';
area5['TRG'] = 'NZL';

area6['TRG'] = new Object();
area6['TRG'] = 'タウランガ';
area3['NZL']['TIU'] = 'ティマル';
area4['TIU'] = 'TC3_3';
area5['TIU'] = 'NZL';

area6['TIU'] = new Object();
area6['TIU'] = 'ティマル';
area3['NZL']['WKA'] = 'ワナカ';
area4['WKA'] = 'TC3_3';
area5['WKA'] = 'NZL';

area6['WKA'] = new Object();
area6['WKA'] = 'ワナカ';
area3['NZL']['WAG'] = 'ワンガヌイ';
area4['WAG'] = 'TC3_3';
area5['WAG'] = 'NZL';

area6['WAG'] = new Object();
area6['WAG'] = 'ワンガヌイ';
area3['NZL']['WLG'] = 'ウェリントン';
area4['WLG'] = 'TC3_3';
area5['WLG'] = 'NZL';

area6['WLG'] = new Object();
area6['WLG'] = 'ウェリントン';
area3['NZL']['WSZ'] = 'ウェストポート';
area4['WSZ'] = 'TC3_3';
area5['WSZ'] = 'NZL';

area6['WSZ'] = new Object();
area6['WSZ'] = 'ウェストポート';
area3['OMN'] = new Object();
area3['OMN']['OHS'] = 'ソハール';
area4['OHS'] = 'TC2_2';
area5['OHS'] = 'OMN';

area6['OHS'] = new Object();
area6['OHS'] = 'ソハール';
area3['OMN']['SLL'] = 'サラーラ';
area4['SLL'] = 'TC2_2';
area5['SLL'] = 'OMN';

area6['SLL'] = new Object();
area6['SLL'] = 'サラーラ';
area3['OMN']['MCT'] = 'マスカット';
area4['MCT'] = 'TC2_2';
area5['MCT'] = 'OMN';

area6['MCT'] = new Object();
area6['MCT'] = 'マスカット';
area3['PAK'] = new Object();
area3['PAK']['ISB'] = '★イスラマバード';
area4['ISB'] = 'TC3_2';
area5['ISB'] = 'PAK';

area6['ISB'] = new Object();
area6['ISB'] = '★イスラマバード';
area3['PAK']['KHI'] = 'カラチ';
area4['KHI'] = 'TC3_2';
area5['KHI'] = 'PAK';

area6['KHI'] = new Object();
area6['KHI'] = 'カラチ';
area3['PAK']['PEW'] = 'ペシャワール';
area4['PEW'] = 'TC3_2';
area5['PEW'] = 'PAK';

area6['PEW'] = new Object();
area6['PEW'] = 'ペシャワール';
area3['PAK']['LHE'] = 'ラホール';
area4['LHE'] = 'TC3_2';
area5['LHE'] = 'PAK';

area6['LHE'] = new Object();
area6['LHE'] = 'ラホール';
area3['PAN'] = new Object();
area3['PAN']['PTY'] = 'パナマシティ';
area4['PTY'] = 'TC1_3';
area5['PTY'] = 'PAN';

area6['PTY'] = new Object();
area6['PTY'] = 'パナマシティ';
area3['PER'] = new Object();
area3['PER']['LIM'] = 'リマ';
area4['LIM'] = 'TC1_3';
area5['LIM'] = 'PER';

area6['LIM'] = new Object();
area6['LIM'] = 'リマ';
area3['PER']['CUZ'] = 'クスコ';
area4['CUZ'] = 'TC1_3';
area5['CUZ'] = 'PER';

area6['CUZ'] = new Object();
area6['CUZ'] = 'クスコ';
area3['PHL'] = new Object();
area3['PHL']['MNL'] = '★マニラ';
area4['MNL'] = 'TC3_2';
area5['MNL'] = 'PHL';

area6['MNL'] = new Object();
area6['MNL'] = '★マニラ';
area3['PHL']['CEB'] = '★セブ';
area4['CEB'] = 'TC3_2';
area5['CEB'] = 'PHL';

area6['CEB'] = new Object();
area6['CEB'] = '★セブ';
area3['PHL']['DVO'] = 'ダバオ';
area4['DVO'] = 'TC3_2';
area5['DVO'] = 'PHL';

area6['DVO'] = new Object();
area6['DVO'] = 'ダバオ';
area3['PHL']['CRK'] = 'クラーク';
area4['CRK'] = 'TC3_2';
area5['CRK'] = 'PHL';

area6['CRK'] = new Object();
area6['CRK'] = 'クラーク';
area3['PHL']['LAO'] = 'ラオアグ';
area4['LAO'] = 'TC3_2';
area5['LAO'] = 'PHL';

area6['LAO'] = new Object();
area6['LAO'] = 'ラオアグ';
area3['PHL']['BCD'] = 'バコロド';
area4['BCD'] = 'TC3_2';
area5['BCD'] = 'PHL';

area6['BCD'] = new Object();
area6['BCD'] = 'バコロド';
area3['PHL']['DGT'] = 'ドゥマゲテ';
area4['DGT'] = 'TC3_2';
area5['DGT'] = 'PHL';

area6['DGT'] = new Object();
area6['DGT'] = 'ドゥマゲテ';
area3['PHL']['DPL'] = 'ディポログ';
area4['DPL'] = 'TC3_2';
area5['DPL'] = 'PHL';

area6['DPL'] = new Object();
area6['DPL'] = 'ディポログ';
area3['PHL']['GES'] = 'ジェネラルサントス';
area4['GES'] = 'TC3_2';
area5['GES'] = 'PHL';

area6['GES'] = new Object();
area6['GES'] = 'ジェネラルサントス';
area3['PHL']['ILO'] = 'イロイロ';
area4['ILO'] = 'TC3_2';
area5['ILO'] = 'PHL';

area6['ILO'] = new Object();
area6['ILO'] = 'イロイロ';
area3['PHL']['PPS'] = 'プエルト・プリンセサ';
area4['PPS'] = 'TC3_2';
area5['PPS'] = 'PHL';

area6['PPS'] = new Object();
area6['PPS'] = 'プエルト・プリンセサ';
area3['PHL']['RXS'] = 'ロハス';
area4['RXS'] = 'TC3_2';
area5['RXS'] = 'PHL';

area6['RXS'] = new Object();
area6['RXS'] = 'ロハス';
area3['PHL']['TAC'] = 'タクロバン';
area4['TAC'] = 'TC3_2';
area5['TAC'] = 'PHL';

area6['TAC'] = new Object();
area6['TAC'] = 'タクロバン';
area3['PHL']['LGP'] = 'レガスピ';
area4['LGP'] = 'TC3_2';
area5['LGP'] = 'PHL';

area6['LGP'] = new Object();
area6['LGP'] = 'レガスピ';
area3['PHL']['BXU'] = 'ブトゥアン';
area4['BXU'] = 'TC3_2';
area5['BXU'] = 'PHL';

area6['BXU'] = new Object();
area6['BXU'] = 'ブトゥアン';
area3['PHL']['CBO'] = 'コタバト';
area4['CBO'] = 'TC3_2';
area5['CBO'] = 'PHL';

area6['CBO'] = new Object();
area6['CBO'] = 'コタバト';
area3['PHL']['TAG'] = 'タグビララン';
area4['TAG'] = 'TC3_2';
area5['TAG'] = 'PHL';

area6['TAG'] = new Object();
area6['TAG'] = 'タグビララン';
area3['PHL']['DRP'] = 'ダラガ(ビコール)';
area4['DRP'] = 'TC3_2';
area5['DRP'] = 'PHL';

area6['DRP'] = new Object();
area6['DRP'] = 'ダラガ(ビコール)';
area3['PHL']['CGY'] = 'カガヤンデオロ';
area4['CGY'] = 'TC3_2';
area5['CGY'] = 'PHL';

area6['CGY'] = new Object();
area6['CGY'] = 'カガヤンデオロ';
area3['PLW'] = new Object();
area3['PLW']['ROR'] = '★パラオ';
area4['ROR'] = 'TC3_5';
area5['ROR'] = 'PLW';

area6['ROR'] = new Object();
area6['ROR'] = '★パラオ';
area3['PNG'] = new Object();
area3['PNG']['POM'] = '★ポートモレスビー';
area4['POM'] = 'TC3_3';
area5['POM'] = 'PNG';

area6['POM'] = new Object();
area6['POM'] = '★ポートモレスビー';
area3['POL'] = new Object();
area3['POL']['WAW'] = '★ワルシャワ';
area4['WAW'] = 'TC2_1';
area5['WAW'] = 'POL';

area6['WAW'] = new Object();
area6['WAW'] = '★ワルシャワ';
area3['POL']['KTW'] = 'カトヴィッツェ';
area4['KTW'] = 'TC2_1';
area5['KTW'] = 'POL';

area6['KTW'] = new Object();
area6['KTW'] = 'カトヴィッツェ';
area3['POL']['KRK'] = 'クラクフ';
area4['KRK'] = 'TC2_1';
area5['KRK'] = 'POL';

area6['KRK'] = new Object();
area6['KRK'] = 'クラクフ';
area3['POL']['RZE'] = 'ジェシェフ';
area4['RZE'] = 'TC2_1';
area5['RZE'] = 'POL';

area6['RZE'] = new Object();
area6['RZE'] = 'ジェシェフ';
area3['POL']['GDN'] = 'グダニスク';
area4['GDN'] = 'TC2_1';
area5['GDN'] = 'POL';

area6['GDN'] = new Object();
area6['GDN'] = 'グダニスク';
area3['POL']['POZ'] = 'ポズナン';
area4['POZ'] = 'TC2_1';
area5['POZ'] = 'POL';

area6['POZ'] = new Object();
area6['POZ'] = 'ポズナン';
area3['PRI'] = new Object();
area3['PRI']['SJU'] = 'サンフアン';
area4['SJU'] = 'TC1_3';
area5['SJU'] = 'PRI';

area6['SJU'] = new Object();
area6['SJU'] = 'サンフアン';
area3['PRT'] = new Object();
area3['PRT']['LIS'] = '★リスボン';
area4['LIS'] = 'TC2_1';
area5['LIS'] = 'PRT';

area6['LIS'] = new Object();
area6['LIS'] = '★リスボン';
area3['PRT']['OPO'] = 'ポルト';
area4['OPO'] = 'TC2_1';
area5['OPO'] = 'PRT';

area6['OPO'] = new Object();
area6['OPO'] = 'ポルト';
area3['PRT']['FAO'] = 'ファロ';
area4['FAO'] = 'TC2_1';
area5['FAO'] = 'PRT';

area6['FAO'] = new Object();
area6['FAO'] = 'ファロ';
area3['PRY'] = new Object();
area3['PRY']['ASU'] = 'アスンシオン';
area4['ASU'] = 'TC1_3';
area5['ASU'] = 'PRY';

area6['ASU'] = new Object();
area6['ASU'] = 'アスンシオン';
area3['PYF'] = new Object();
area3['PYF']['PPT'] = '★パペーテ';
area4['PPT'] = 'TC3_3';
area5['PPT'] = 'PYF';

area6['PPT'] = new Object();
area6['PPT'] = '★パペーテ';
area3['QAT'] = new Object();
area3['QAT']['DOH'] = '★ドーハ';
area4['DOH'] = 'TC2_2';
area5['DOH'] = 'QAT';

area6['DOH'] = new Object();
area6['DOH'] = '★ドーハ';
area3['ROP'] = new Object();
area3['ROP']['ROP'] = '★ロタ';
area4['ROP'] = 'TC3_5';
area5['ROP'] = 'ROP';

area6['ROP'] = new Object();
area6['ROP'] = '★ロタ';
area3['ROU'] = new Object();
area3['ROU']['BUH'] = '★ブカレスト';
area4['BUH'] = 'TC2_1';
area5['BUH'] = 'ROU';

area6['BUH'] = new Object();
area6['BUH'] = '★ブカレスト';
area3['ROU']['OTP'] = 'ブカレスト';
area4['OTP'] = 'TC2_1';
area5['OTP'] = 'ROU';

area6['OTP'] = new Object();
area6['OTP'] = 'ブカレスト';
area3['ROU']['CLJ'] = 'クルージュ';
area4['CLJ'] = 'TC2_1';
area5['CLJ'] = 'ROU';

area6['CLJ'] = new Object();
area6['CLJ'] = 'クルージュ';
area3['ROU']['IAS'] = 'ヤシ';
area4['IAS'] = 'TC2_1';
area5['IAS'] = 'ROU';

area6['IAS'] = new Object();
area6['IAS'] = 'ヤシ';
area3['ROU']['SBZ'] = 'シビウ';
area4['SBZ'] = 'TC2_1';
area5['SBZ'] = 'ROU';

area6['SBZ'] = new Object();
area6['SBZ'] = 'シビウ';
area3['ROU']['TSR'] = 'ティミソアラ';
area4['TSR'] = 'TC2_1';
area5['TSR'] = 'ROU';

area6['TSR'] = new Object();
area6['TSR'] = 'ティミソアラ';
area3['RUS'] = new Object();
area3['RUS']['MOW'] = '★モスクワ';
area4['MOW'] = 'TC2_1';
area5['MOW'] = 'RUS';

area6['MOW'] = new Object();
area6['MOW'] = '★モスクワ';
area3['RUS']['LED'] = '★サンクトペテルブルグ';
area4['LED'] = 'TC2_1';
area5['LED'] = 'RUS';

area6['LED'] = new Object();
area6['LED'] = '★サンクトペテルブルグ';
area3['RUS']['AER'] = 'ソチ';
area4['AER'] = 'TC2_1';
area5['AER'] = 'RUS';

area6['AER'] = new Object();
area6['AER'] = 'ソチ';
area3['RUS']['KHV'] = 'ハバロフスク';
area4['KHV'] = 'TC2_1';
area5['KHV'] = 'RUS';

area6['KHV'] = new Object();
area6['KHV'] = 'ハバロフスク';
area3['RUS']['PEE'] = 'ペルミ';
area4['PEE'] = 'TC2_1';
area5['PEE'] = 'RUS';

area6['PEE'] = new Object();
area6['PEE'] = 'ペルミ';
area3['RUS']['MMK'] = 'ムルマンスク';
area4['MMK'] = 'TC2_1';
area5['MMK'] = 'RUS';

area6['MMK'] = new Object();
area6['MMK'] = 'ムルマンスク';
area3['RUS']['UUS'] = 'ユジノサハリンスク';
area4['UUS'] = 'TC2_1';
area5['UUS'] = 'RUS';

area6['UUS'] = new Object();
area6['UUS'] = 'ユジノサハリンスク';
area3['RUS']['ROV'] = 'ロストフ・ナ・ドヌ';
area4['ROV'] = 'TC2_1';
area5['ROV'] = 'RUS';

area6['ROV'] = new Object();
area6['ROV'] = 'ロストフ・ナ・ドヌ';
area3['RUS']['SVX'] = 'エカテリンブルク';
area4['SVX'] = 'TC2_1';
area5['SVX'] = 'RUS';

area6['SVX'] = new Object();
area6['SVX'] = 'エカテリンブルク';
area3['RUS']['GOJ'] = 'ニジニノヴゴロド';
area4['GOJ'] = 'TC2_1';
area5['GOJ'] = 'RUS';

area6['GOJ'] = new Object();
area6['GOJ'] = 'ニジニノヴゴロド';
area3['RUS']['KGD'] = 'カリーニングラード';
area4['KGD'] = 'TC2_1';
area5['KGD'] = 'RUS';

area6['KGD'] = new Object();
area6['KGD'] = 'カリーニングラード';
area3['RUS']['KUF'] = 'サマラ';
area4['KUF'] = 'TC2_1';
area5['KUF'] = 'RUS';

area6['KUF'] = new Object();
area6['KUF'] = 'サマラ';
area3['RUS']['KZN'] = 'カザン';
area4['KZN'] = 'TC2_1';
area5['KZN'] = 'RUS';

area6['KZN'] = new Object();
area6['KZN'] = 'カザン';
area3['RUS']['KJA'] = 'クラスノヤルスク';
area4['KJA'] = 'TC2_1';
area5['KJA'] = 'RUS';

area6['KJA'] = new Object();
area6['KJA'] = 'クラスノヤルスク';
area3['RUS']['OVB'] = 'ノヴォシビルスク';
area4['OVB'] = 'TC2_1';
area5['OVB'] = 'RUS';

area6['OVB'] = new Object();
area6['OVB'] = 'ノヴォシビルスク';
area3['RUS']['VOG'] = 'ヴォルゴグラード';
area4['VOG'] = 'TC2_1';
area5['VOG'] = 'RUS';

area6['VOG'] = new Object();
area6['VOG'] = 'ヴォルゴグラード';
area3['RUS']['ASF'] = 'アストラハン';
area4['ASF'] = 'TC2_1';
area5['ASF'] = 'RUS';

area6['ASF'] = new Object();
area6['ASF'] = 'アストラハン';
area3['RUS']['KRR'] = 'クラスノダル';
area4['KRR'] = 'TC2_1';
area5['KRR'] = 'RUS';

area6['KRR'] = new Object();
area6['KRR'] = 'クラスノダル';
area3['RUS']['ARH'] = 'アルハンゲリスク';
area4['ARH'] = 'TC2_1';
area5['ARH'] = 'RUS';

area6['ARH'] = new Object();
area6['ARH'] = 'アルハンゲリスク';
area3['RUS']['VVO'] = 'ウラジオストック';
area4['VVO'] = 'TC2_1';
area5['VVO'] = 'RUS';

area6['VVO'] = new Object();
area6['VVO'] = 'ウラジオストック';
area3['RUS']['SVO'] = 'モスクワ（シェレメーチエヴォ）';
area4['SVO'] = 'TC2_1';
area5['SVO'] = 'RUS';

area6['SVO'] = new Object();
area6['SVO'] = 'モスクワ（シェレメーチエヴォ）';
area3['RUS']['DME'] = 'モスクワ（ドモジェドヴォ）';
area4['DME'] = 'TC2_1';
area5['DME'] = 'RUS';

area6['DME'] = new Object();
area6['DME'] = 'モスクワ（ドモジェドヴォ）';
area3['RUS']['VKO'] = 'モスクワ（ヴヌーコヴォ）';
area4['VKO'] = 'TC2_1';
area5['VKO'] = 'RUS';

area6['VKO'] = new Object();
area6['VKO'] = 'モスクワ（ヴヌーコヴォ）';
area3['RUS']['GSV'] = 'サラトフ';
area4['GSV'] = 'TC2_1';
area5['GSV'] = 'RUS';

area6['GSV'] = new Object();
area6['GSV'] = 'サラトフ';
area3['RUS']['AAQ'] = 'アナパ';
area4['AAQ'] = 'TC2_1';
area5['AAQ'] = 'RUS';

area6['AAQ'] = new Object();
area6['AAQ'] = 'アナパ';
area3['RUS']['GDZ'] = 'ゲレンジーク';
area4['GDZ'] = 'TC2_1';
area5['GDZ'] = 'RUS';

area6['GDZ'] = new Object();
area6['GDZ'] = 'ゲレンジーク';
area3['RUS']['CEK'] = 'チェリャビンスク';
area4['CEK'] = 'TC2_1';
area5['CEK'] = 'RUS';

area6['CEK'] = new Object();
area6['CEK'] = 'チェリャビンスク';
area3['RUS']['EGO'] = 'ベルゴロド';
area4['EGO'] = 'TC2_1';
area5['EGO'] = 'RUS';

area6['EGO'] = new Object();
area6['EGO'] = 'ベルゴロド';
area3['RUS']['GRV'] = 'グロズヌイ';
area4['GRV'] = 'TC2_1';
area5['GRV'] = 'RUS';

area6['GRV'] = new Object();
area6['GRV'] = 'グロズヌイ';
area3['RUS']['IGT'] = 'ナズラン';
area4['IGT'] = 'TC2_1';
area5['IGT'] = 'RUS';

area6['IGT'] = new Object();
area6['IGT'] = 'ナズラン';
area3['RUS']['IJK'] = 'イジェフスク';
area4['IJK'] = 'TC2_1';
area5['IJK'] = 'RUS';

area6['IJK'] = new Object();
area6['IJK'] = 'イジェフスク';
area3['RUS']['MCX'] = 'マハチカラ';
area4['MCX'] = 'TC2_1';
area5['MCX'] = 'RUS';

area6['MCX'] = new Object();
area6['MCX'] = 'マハチカラ';
area3['RUS']['MRV'] = 'ミネラーリヌィエ・ヴォードィ';
area4['MRV'] = 'TC2_1';
area5['MRV'] = 'RUS';

area6['MRV'] = new Object();
area6['MRV'] = 'ミネラーリヌィエ・ヴォードィ';
area3['RUS']['MQF'] = 'マグニトゴルスク';
area4['MQF'] = 'TC2_1';
area5['MQF'] = 'RUS';

area6['MQF'] = new Object();
area6['MQF'] = 'マグニトゴルスク';
area3['RUS']['OGZ'] = 'ウラジカフカス';
area4['OGZ'] = 'TC2_1';
area5['OGZ'] = 'RUS';

area6['OGZ'] = new Object();
area6['OGZ'] = 'ウラジカフカス';
area3['RUS']['REN'] = 'オレンブルク';
area4['REN'] = 'TC2_1';
area5['REN'] = 'RUS';

area6['REN'] = new Object();
area6['REN'] = 'オレンブルク';
area3['RUS']['SCW'] = 'スィクティフカル';
area4['SCW'] = 'TC2_1';
area5['SCW'] = 'RUS';

area6['SCW'] = new Object();
area6['SCW'] = 'スィクティフカル';
area3['RUS']['UFA'] = 'ウファ';
area4['UFA'] = 'TC2_1';
area5['UFA'] = 'RUS';

area6['UFA'] = new Object();
area6['UFA'] = 'ウファ';
area3['RUS']['ULV'] = 'ウリヤノフスク';
area4['ULV'] = 'TC2_1';
area5['ULV'] = 'RUS';

area6['ULV'] = new Object();
area6['ULV'] = 'ウリヤノフスク';
area3['RUS']['NAL'] = 'ナリチク';
area4['NAL'] = 'TC2_1';
area5['NAL'] = 'RUS';

area6['NAL'] = new Object();
area6['NAL'] = 'ナリチク';
area3['RUS']['NBC'] = 'ニジネカムスク';
area4['NBC'] = 'TC2_1';
area5['NBC'] = 'RUS';

area6['NBC'] = new Object();
area6['NBC'] = 'ニジネカムスク';
area3['RUS']['VOZ'] = 'ヴォロネジ';
area4['VOZ'] = 'TC2_1';
area5['VOZ'] = 'RUS';

area6['VOZ'] = new Object();
area6['VOZ'] = 'ヴォロネジ';
area3['RUS']['IKT'] = 'イルクーツク';
area4['IKT'] = 'TC2_1';
area5['IKT'] = 'RUS';

area6['IKT'] = new Object();
area6['IKT'] = 'イルクーツク';
area3['RUS']['YKS'] = 'ヤクーツク';
area4['YKS'] = 'TC2_1';
area5['YKS'] = 'RUS';

area6['YKS'] = new Object();
area6['YKS'] = 'ヤクーツク';
area3['RUS']['SKX'] = 'サランスク';
area4['SKX'] = 'TC2_1';
area5['SKX'] = 'RUS';

area6['SKX'] = new Object();
area6['SKX'] = 'サランスク';
area3['RUS']['PKC'] = 'ペトロパブロフクカムチャツキー';
area4['PKC'] = 'TC2_1';
area5['PKC'] = 'RUS';

area6['PKC'] = new Object();
area6['PKC'] = 'ペトロパブロフクカムチャツキー';
area3['RUS']['PES'] = 'ペトロザヴォーツク';
area4['PES'] = 'TC2_1';
area5['PES'] = 'RUS';

area6['PES'] = new Object();
area6['PES'] = 'ペトロザヴォーツク';
area3['RWA'] = new Object();
area3['RWA']['KGL'] = '★キガリ';
area4['KGL'] = 'TC2_2';
area5['KGL'] = 'RWA';

area6['KGL'] = new Object();
area6['KGL'] = '★キガリ';
area3['SAU'] = new Object();
area3['SAU']['RUH'] = '★リヤド';
area4['RUH'] = 'TC2_2';
area5['RUH'] = 'SAU';

area6['RUH'] = new Object();
area6['RUH'] = '★リヤド';
area3['SAU']['JED'] = 'ジッダ';
area4['JED'] = 'TC2_2';
area5['JED'] = 'SAU';

area6['JED'] = new Object();
area6['JED'] = 'ジッダ';
area3['SAU']['DMM'] = 'ダンマーム';
area4['DMM'] = 'TC2_2';
area5['DMM'] = 'SAU';

area6['DMM'] = new Object();
area6['DMM'] = 'ダンマーム';
area3['SAU']['MED'] = 'メディナ';
area4['MED'] = 'TC2_2';
area5['MED'] = 'SAU';

area6['MED'] = new Object();
area6['MED'] = 'メディナ';
area3['SDN'] = new Object();
area3['SDN']['KRT'] = 'ハルツーム';
area4['KRT'] = 'T2_2';
area5['KRT'] = 'SDN';

area6['KRT'] = new Object();
area6['KRT'] = 'ハルツーム';
area3['SEN'] = new Object();
area3['SEN']['DSS'] = '★ダカール';
area4['DSS'] = 'TC2_2';
area5['DSS'] = 'SEN';

area6['DSS'] = new Object();
area6['DSS'] = '★ダカール';
area3['SGP'] = new Object();
area3['SGP']['SIN'] = '★シンガポール';
area4['SIN'] = 'TC3_2';
area5['SIN'] = 'SGP';

area6['SIN'] = new Object();
area6['SIN'] = '★シンガポール';
area3['SLB'] = new Object();
area3['SLB']['HIR'] = '★ホニアラ';
area4['HIR'] = 'TC3_3';
area5['HIR'] = 'SLB';

area6['HIR'] = new Object();
area6['HIR'] = '★ホニアラ';
area3['SLE'] = new Object();
area3['SLE']['FNA'] = '★フリータウン';
area4['FNA'] = 'TC2_2';
area5['FNA'] = 'SLE';

area6['FNA'] = new Object();
area6['FNA'] = '★フリータウン';
area3['SLV'] = new Object();
area3['SLV']['SAL'] = 'サンサルバドル';
area4['SAL'] = 'TC1_3';
area5['SAL'] = 'SLV';

area6['SAL'] = new Object();
area6['SAL'] = 'サンサルバドル';
area3['SPN'] = new Object();
area3['SPN']['SPN'] = '★サイパン';
area4['SPN'] = 'TC3_5';
area5['SPN'] = 'SPN';

area6['SPN'] = new Object();
area6['SPN'] = '★サイパン';
area3['SRB'] = new Object();
area3['SRB']['BEG'] = '★ベオグラード';
area4['BEG'] = 'TC2_1';
area5['BEG'] = 'SRB';

area6['BEG'] = new Object();
area6['BEG'] = '★ベオグラード';
area3['SVK'] = new Object();
area3['SVK']['BTS'] = '★ブラチスラバ';
area4['BTS'] = 'TC2_1';
area5['BTS'] = 'SVK';

area6['BTS'] = new Object();
area6['BTS'] = '★ブラチスラバ';
area3['SVK']['KSC'] = 'コシツェ';
area4['KSC'] = 'TC2_1';
area5['KSC'] = 'SVK';

area6['KSC'] = new Object();
area6['KSC'] = 'コシツェ';
area3['SVN'] = new Object();
area3['SVN']['LJU'] = '★リュブリャーナ';
area4['LJU'] = 'TC2_1';
area5['LJU'] = 'SVN';

area6['LJU'] = new Object();
area6['LJU'] = '★リュブリャーナ';
area3['SWE'] = new Object();
area3['SWE']['STO'] = '★ストックホルム';
area4['STO'] = 'TC2_1';
area5['STO'] = 'SWE';

area6['STO'] = new Object();
area6['STO'] = '★ストックホルム';
area3['SWE']['KRN'] = 'キルナ';
area4['KRN'] = 'TC2_1';
area5['KRN'] = 'SWE';

area6['KRN'] = new Object();
area6['KRN'] = 'キルナ';
area3['SWE']['UME'] = 'ウーメオ';
area4['UME'] = 'TC2_1';
area5['UME'] = 'SWE';

area6['UME'] = new Object();
area6['UME'] = 'ウーメオ';
area3['SWE']['SFT'] = 'シュレフテオ';
area4['SFT'] = 'TC2_1';
area5['SFT'] = 'SWE';

area6['SFT'] = new Object();
area6['SFT'] = 'シュレフテオ';
area3['SWE']['OSD'] = 'エステルスン';
area4['OSD'] = 'TC2_1';
area5['OSD'] = 'SWE';

area6['OSD'] = new Object();
area6['OSD'] = 'エステルスン';
area3['SWE']['LPI'] = 'リンチェーピング';
area4['LPI'] = 'TC2_1';
area5['LPI'] = 'SWE';

area6['LPI'] = new Object();
area6['LPI'] = 'リンチェーピング';
area3['SWE']['LLA'] = 'ルーレオ';
area4['LLA'] = 'TC2_1';
area5['LLA'] = 'SWE';

area6['LLA'] = new Object();
area6['LLA'] = 'ルーレオ';
area3['SWE']['KSD'] = 'カールスタード';
area4['KSD'] = 'TC2_1';
area5['KSD'] = 'SWE';

area6['KSD'] = new Object();
area6['KSD'] = 'カールスタード';
area3['SWE']['JKG'] = 'イエンチェーピング';
area4['JKG'] = 'TC2_1';
area5['JKG'] = 'SWE';

area6['JKG'] = new Object();
area6['JKG'] = 'イエンチェーピング';
area3['SWE']['GOT'] = 'イェーテボリ';
area4['GOT'] = 'TC2_1';
area5['GOT'] = 'SWE';

area6['GOT'] = new Object();
area6['GOT'] = 'イェーテボリ';
area3['SWE']['ARN'] = 'ストックホルム(アーランダ)';
area4['ARN'] = 'TC2_1';
area5['ARN'] = 'SWE';

area6['ARN'] = new Object();
area6['ARN'] = 'ストックホルム(アーランダ)';
area3['SWE']['BMA'] = 'ストックホルム（ブロンマ）';
area4['BMA'] = 'TC2_1';
area5['BMA'] = 'SWE';

area6['BMA'] = new Object();
area6['BMA'] = 'ストックホルム（ブロンマ）';
area3['SYC'] = new Object();
area3['SYC']['SEZ'] = '★セーシェル（マヘ島）';
area4['SEZ'] = 'TC2_2';
area5['SEZ'] = 'SYC';

area6['SEZ'] = new Object();
area6['SEZ'] = '★セーシェル（マヘ島）';
area3['SYR'] = new Object();
area3['SYR']['DAM'] = '★ダマスカス';
area4['DAM'] = 'TC2_2';
area5['DAM'] = 'SYR';

area6['DAM'] = new Object();
area6['DAM'] = '★ダマスカス';
area3['TAN'] = new Object();
area3['TAN']['ZNZ'] = 'ザンジバル';
area4['ZNZ'] = '';
area5['ZNZ'] = 'TAN';

area6['ZNZ'] = new Object();
area6['ZNZ'] = 'ザンジバル';
area3['TGO'] = new Object();
area3['TGO']['LFW'] = 'ロメ';
area4['LFW'] = 'TC2_2';
area5['LFW'] = 'TGO';

area6['LFW'] = new Object();
area6['LFW'] = 'ロメ';
area3['THA'] = new Object();
area3['THA']['BKK'] = '★バンコク';
area4['BKK'] = 'TC3_2';
area5['BKK'] = 'THA';

area6['BKK'] = new Object();
area6['BKK'] = '★バンコク';
area3['THA']['DMK'] = '★バンコク（ドンムアン）';
area4['DMK'] = 'TC3_2';
area5['DMK'] = 'THA';

area6['DMK'] = new Object();
area6['DMK'] = '★バンコク（ドンムアン）';
area3['THA']['CNX'] = 'チェンマイ';
area4['CNX'] = 'TC3_2';
area5['CNX'] = 'THA';

area6['CNX'] = new Object();
area6['CNX'] = 'チェンマイ';
area3['THA']['HKT'] = 'プーケット';
area4['HKT'] = 'TC3_2';
area5['HKT'] = 'THA';

area6['HKT'] = new Object();
area6['HKT'] = 'プーケット';
area3['THA']['USM'] = 'サムイ（島）';
area4['USM'] = 'TC3_2';
area5['USM'] = 'THA';

area6['USM'] = new Object();
area6['USM'] = 'サムイ（島）';
area3['THA']['THS'] = 'スコタイ';
area4['THS'] = 'TC3_2';
area5['THS'] = 'THA';

area6['THS'] = new Object();
area6['THS'] = 'スコタイ';
area3['THA']['URT'] = 'スラートタニ';
area4['URT'] = 'TC3_2';
area5['URT'] = 'THA';

area6['URT'] = new Object();
area6['URT'] = 'スラートタニ';
area3['THA']['CEI'] = 'チェンライ';
area4['CEI'] = 'TC3_2';
area5['CEI'] = 'THA';

area6['CEI'] = new Object();
area6['CEI'] = 'チェンライ';
area3['THA']['HDY'] = 'ハットヤイ';
area4['HDY'] = 'TC3_2';
area5['HDY'] = 'THA';

area6['HDY'] = new Object();
area6['HDY'] = 'ハットヤイ';
area3['THA']['KBV'] = 'クラビ';
area4['KBV'] = 'TC3_2';
area5['KBV'] = 'THA';

area6['KBV'] = new Object();
area6['KBV'] = 'クラビ';
area3['THA']['KKC'] = 'コンケン';
area4['KKC'] = 'TC3_2';
area5['KKC'] = 'THA';

area6['KKC'] = new Object();
area6['KKC'] = 'コンケン';
area3['THA']['UTH'] = 'ウドンタニ';
area4['UTH'] = 'TC3_2';
area5['UTH'] = 'THA';

area6['UTH'] = new Object();
area6['UTH'] = 'ウドンタニ';
area3['TKM'] = new Object();
area3['TKM']['ASB'] = 'アシガバード';
area4['ASB'] = 'TC3_2';
area5['ASB'] = 'TKM';

area6['ASB'] = new Object();
area6['ASB'] = 'アシガバード';
area3['TON'] = new Object();
area3['TON']['TBU'] = '★ファモトゥ';
area4['TBU'] = 'TC3_3';
area5['TBU'] = 'TON';

area6['TBU'] = new Object();
area6['TBU'] = '★ファモトゥ';
area3['TTO'] = new Object();
area3['TTO']['POS'] = 'ポートオブスペイン';
area4['POS'] = 'TC1_3';
area5['POS'] = 'TTO';

area6['POS'] = new Object();
area6['POS'] = 'ポートオブスペイン';
area3['TUN'] = new Object();
area3['TUN']['TUN'] = '★チュニス';
area4['TUN'] = 'TC2_2';
area5['TUN'] = 'TUN';

area6['TUN'] = new Object();
area6['TUN'] = '★チュニス';
area3['TUN']['MIR'] = 'モナスティール';
area4['MIR'] = 'TC2_2';
area5['MIR'] = 'TUN';

area6['MIR'] = new Object();
area6['MIR'] = 'モナスティール';
area3['TUR'] = new Object();
area3['TUR']['IST'] = '★イスタンブール';
area4['IST'] = 'TC2_2';
area5['IST'] = 'TUR';

area6['IST'] = new Object();
area6['IST'] = '★イスタンブール';
area3['TUR']['ANK'] = 'アンカラ';
area4['ANK'] = 'TC2_2';
area5['ANK'] = 'TUR';

area6['ANK'] = new Object();
area6['ANK'] = 'アンカラ';
area3['TUR']['AYT'] = 'アンタルヤ';
area4['AYT'] = 'TC2_2';
area5['AYT'] = 'TUR';

area6['AYT'] = new Object();
area6['AYT'] = 'アンタルヤ';
area3['TUR']['KCM'] = 'カフラマンマラシュ';
area4['KCM'] = 'TC2_2';
area5['KCM'] = 'TUR';

area6['KCM'] = new Object();
area6['KCM'] = 'カフラマンマラシュ';
area3['TUR']['KSY'] = 'カルス';
area4['KSY'] = 'TC2_2';
area5['KSY'] = 'TUR';

area6['KSY'] = new Object();
area6['KSY'] = 'カルス';
area3['TUR']['KYA'] = 'コンヤ';
area4['KYA'] = 'TC2_2';
area5['KYA'] = 'TUR';

area6['KYA'] = new Object();
area6['KYA'] = 'コンヤ';
area3['TUR']['DNZ'] = 'デニズリ';
area4['DNZ'] = 'TC2_2';
area5['DNZ'] = 'TUR';

area6['DNZ'] = new Object();
area6['DNZ'] = 'デニズリ';
area3['TUR']['BAL'] = 'バットマン';
area4['BAL'] = 'TC2_2';
area5['BAL'] = 'TUR';

area6['BAL'] = new Object();
area6['BAL'] = 'バットマン';
area3['TUR']['GNY'] = 'シャンルウルファ';
area4['GNY'] = 'TC2_2';
area5['GNY'] = 'TUR';

area6['GNY'] = new Object();
area6['GNY'] = 'シャンルウルファ';
area3['TUR']['GZT'] = 'ガズィアンテプ';
area4['GZT'] = 'TC2_2';
area5['GZT'] = 'TUR';

area6['GZT'] = new Object();
area6['GZT'] = 'ガズィアンテプ';
area3['TUR']['ASR'] = 'カイセリ';
area4['ASR'] = 'TC2_2';
area5['ASR'] = 'TUR';

area6['ASR'] = new Object();
area6['ASR'] = 'カイセリ';
area3['TUR']['NAV'] = 'ネヴシェヒル';
area4['NAV'] = 'TC2_2';
area5['NAV'] = 'TUR';

area6['NAV'] = new Object();
area6['NAV'] = 'ネヴシェヒル';
area3['TUR']['ESB'] = 'アンカラ';
area4['ESB'] = 'TC2_2';
area5['ESB'] = 'TUR';

area6['ESB'] = new Object();
area6['ESB'] = 'アンカラ';
area3['TUR']['SAW'] = 'イスタンブール（サビハギョクチェン）';
area4['SAW'] = 'TC2_2';
area5['SAW'] = 'TUR';

area6['SAW'] = new Object();
area6['SAW'] = 'イスタンブール（サビハギョクチェン）';
area3['TUR']['TZX'] = 'トラブゾン';
area4['TZX'] = 'TC2_2';
area5['TZX'] = 'TUR';

area6['TZX'] = new Object();
area6['TZX'] = 'トラブゾン';
area3['TUR']['ADB'] = 'イズミール';
area4['ADB'] = 'TC2_2';
area5['ADB'] = 'TUR';

area6['ADB'] = new Object();
area6['ADB'] = 'イズミール';
area3['TUR']['BJV'] = 'ボドルム';
area4['BJV'] = 'TC2_2';
area5['BJV'] = 'TUR';

area6['BJV'] = new Object();
area6['BJV'] = 'ボドルム';
area3['TUR']['DIY'] = 'ディヤルバクル';
area4['DIY'] = 'TC2_2';
area5['DIY'] = 'TUR';

area6['DIY'] = new Object();
area6['DIY'] = 'ディヤルバクル';
area3['TUR']['VAN'] = 'ヴァン';
area4['VAN'] = 'TC2_2';
area5['VAN'] = 'TUR';

area6['VAN'] = new Object();
area6['VAN'] = 'ヴァン';
area3['TUV'] = new Object();
area3['TUV']['FUN'] = '★フナフティ島';
area4['FUN'] = 'TC3_3';
area5['FUN'] = 'TUV';

area6['FUN'] = new Object();
area6['FUN'] = '★フナフティ島';
area3['TWN'] = new Object();
area3['TWN']['TPE'] = '★台北';
area4['TPE'] = 'TC3_4';
area5['TPE'] = 'TWN';

area6['TPE'] = new Object();
area6['TPE'] = '★台北';
area3['TWN']['TSA'] = '台北（松山）';
area4['TSA'] = 'TC3_4';
area5['TSA'] = 'TWN';

area6['TSA'] = new Object();
area6['TSA'] = '台北（松山）';
area3['TWN']['KHH'] = '高雄';
area4['KHH'] = 'TC3_4';
area5['KHH'] = 'TWN';

area6['KHH'] = new Object();
area6['KHH'] = '高雄';
area3['TWN']['RMQ'] = '台中';
area4['RMQ'] = 'TC3_4';
area5['RMQ'] = 'TWN';

area6['RMQ'] = new Object();
area6['RMQ'] = '台中';
area3['TWN']['HUN'] = '花蓮';
area4['HUN'] = 'TC3_4';
area5['HUN'] = 'TWN';

area6['HUN'] = new Object();
area6['HUN'] = '花蓮';
area3['TWN']['KNH'] = '金門';
area4['KNH'] = 'TC3_4';
area5['KNH'] = 'TWN';

area6['KNH'] = new Object();
area6['KNH'] = '金門';
area3['TWN']['TTT'] = '台東';
area4['TTT'] = 'TC3_4';
area5['TTT'] = 'TWN';

area6['TTT'] = new Object();
area6['TTT'] = '台東';
area3['TWN']['HCN'] = '恒春';
area4['HCN'] = 'TC3_4';
area5['HCN'] = 'TWN';

area6['HCN'] = new Object();
area6['HCN'] = '恒春';
area3['TWN']['MZG'] = '馬公';
area4['MZG'] = 'TC3_4';
area5['MZG'] = 'TWN';

area6['MZG'] = new Object();
area6['MZG'] = '馬公';
area3['TWN']['MFK'] = '馬祖北竿';
area4['MFK'] = 'TC3_4';
area5['MFK'] = 'TWN';

area6['MFK'] = new Object();
area6['MFK'] = '馬祖北竿';
area3['TWN']['LZN'] = '馬祖南竿';
area4['LZN'] = 'TC3_4';
area5['LZN'] = 'TWN';

area6['LZN'] = new Object();
area6['LZN'] = '馬祖南竿';
area3['TZA'] = new Object();
area3['TZA']['DAR'] = '★ダルエスサラーム';
area4['DAR'] = 'TC2_2';
area5['DAR'] = 'TZA';

area6['DAR'] = new Object();
area6['DAR'] = '★ダルエスサラーム';
area3['TZA']['JRO'] = 'キリマンジャロ';
area4['JRO'] = 'TC2_2';
area5['JRO'] = 'TZA';

area6['JRO'] = new Object();
area6['JRO'] = 'キリマンジャロ';
area3['UGA'] = new Object();
area3['UGA']['EBB'] = '★エンテベ';
area4['EBB'] = 'TC2_2';
area5['EBB'] = 'UGA';

area6['EBB'] = new Object();
area6['EBB'] = '★エンテベ';
area3['UKR'] = new Object();
area3['UKR']['IEV'] = '★キーウ';
area4['IEV'] = 'TC2_1';
area5['IEV'] = 'UKR';

area6['IEV'] = new Object();
area6['IEV'] = '★キーウ';
area3['UKR']['ODS'] = 'オデーサ';
area4['ODS'] = 'TC2_1';
area5['ODS'] = 'UKR';

area6['ODS'] = new Object();
area6['ODS'] = 'オデーサ';
area3['UKR']['DOK'] = 'ドネツク';
area4['DOK'] = 'TC2_1';
area5['DOK'] = 'UKR';

area6['DOK'] = new Object();
area6['DOK'] = 'ドネツク';
area3['UKR']['KBP'] = 'キーウ/ボリースビリ';
area4['KBP'] = 'TC2_1';
area5['KBP'] = 'UKR';

area6['KBP'] = new Object();
area6['KBP'] = 'キーウ/ボリースビリ';
area3['UKR']['LWO'] = 'リヴィウ';
area4['LWO'] = 'TC2_1';
area5['LWO'] = 'UKR';

area6['LWO'] = new Object();
area6['LWO'] = 'リヴィウ';
area3['UKR']['SIP'] = 'シンフェローポリ';
area4['SIP'] = 'TC2_1';
area5['SIP'] = 'UKR';

area6['SIP'] = new Object();
area6['SIP'] = 'シンフェローポリ';
area3['URY'] = new Object();
area3['URY']['MVD'] = 'モンテビデオ';
area4['MVD'] = 'TC1_3';
area5['MVD'] = 'URY';

area6['MVD'] = new Object();
area6['MVD'] = 'モンテビデオ';
area3['USA'] = new Object();
area3['USA']['NYC'] = '★ニューヨーク';
area4['NYC'] = 'TC1_1';
area5['NYC'] = 'USA';

area6['NYC'] = new Object();
area6['NYC'] = '★ニューヨーク';
area3['USA']['LAX'] = '★ロサンゼルス';
area4['LAX'] = 'TC1_1';
area5['LAX'] = 'USA';

area6['LAX'] = new Object();
area6['LAX'] = '★ロサンゼルス';
area3['USA']['SFO'] = '★サンフランシスコ';
area4['SFO'] = 'TC1_1';
area5['SFO'] = 'USA';

area6['SFO'] = new Object();
area6['SFO'] = '★サンフランシスコ';
area3['USA']['LAS'] = '★ラスベガス';
area4['LAS'] = 'TC1_1';
area5['LAS'] = 'USA';

area6['LAS'] = new Object();
area6['LAS'] = '★ラスベガス';
area3['USA']['ORL'] = '★オーランド';
area4['ORL'] = 'TC1_1';
area5['ORL'] = 'USA';

area6['ORL'] = new Object();
area6['ORL'] = '★オーランド';
area3['USA']['SEA'] = '★シアトル';
area4['SEA'] = 'TC1_1';
area5['SEA'] = 'USA';

area6['SEA'] = new Object();
area6['SEA'] = '★シアトル';
area3['USA']['CHI'] = 'シカゴ';
area4['CHI'] = 'TC1_1';
area5['CHI'] = 'USA';

area6['CHI'] = new Object();
area6['CHI'] = 'シカゴ';
area3['USA']['DFW'] = 'ダラス・フォートワース';
area4['DFW'] = 'TC1_1';
area5['DFW'] = 'USA';

area6['DFW'] = new Object();
area6['DFW'] = 'ダラス・フォートワース';
area3['USA']['WAS'] = 'ワシントンD.C.';
area4['WAS'] = 'TC1_1';
area5['WAS'] = 'USA';

area6['WAS'] = new Object();
area6['WAS'] = 'ワシントンD.C.';
area3['USA']['BOS'] = 'ボストン';
area4['BOS'] = 'TC1_1';
area5['BOS'] = 'USA';

area6['BOS'] = new Object();
area6['BOS'] = 'ボストン';
area3['USA']['MIA'] = 'マイアミ';
area4['MIA'] = 'TC1_1';
area5['MIA'] = 'USA';

area6['MIA'] = new Object();
area6['MIA'] = 'マイアミ';
area3['USA']['SAN'] = 'サンディエゴ';
area4['SAN'] = 'TC1_1';
area5['SAN'] = 'USA';

area6['SAN'] = new Object();
area6['SAN'] = 'サンディエゴ';
area3['USA']['DTT'] = 'デトロイト';
area4['DTT'] = 'TC1_1';
area5['DTT'] = 'USA';

area6['DTT'] = new Object();
area6['DTT'] = 'デトロイト';
area3['USA']['ATL'] = 'アトランタ';
area4['ATL'] = 'TC1_1';
area5['ATL'] = 'USA';

area6['ATL'] = new Object();
area6['ATL'] = 'アトランタ';
area3['USA']['AMA'] = 'アマリロ';
area4['AMA'] = 'TC1_1';
area5['AMA'] = 'USA';

area6['AMA'] = new Object();
area6['AMA'] = 'アマリロ';
area3['USA']['ABQ'] = 'アルバカーキ';
area4['ABQ'] = 'TC1_1';
area5['ABQ'] = 'USA';

area6['ABQ'] = new Object();
area6['ABQ'] = 'アルバカーキ';
area3['USA']['AEX'] = 'アレクサンドリア';
area4['AEX'] = 'TC1_1';
area5['AEX'] = 'USA';

area6['AEX'] = new Object();
area6['AEX'] = 'アレクサンドリア';
area3['USA']['ABE'] = 'アレンタウン/ベスレヘム/イーストン';
area4['ABE'] = 'TC1_1';
area5['ABE'] = 'USA';

area6['ABE'] = new Object();
area6['ABE'] = 'アレンタウン/ベスレヘム/イーストン';
area3['USA']['ANC'] = 'アンカレッジ';
area4['ANC'] = 'TC1_1';
area5['ANC'] = 'USA';

area6['ANC'] = new Object();
area6['ANC'] = 'アンカレッジ';
area3['USA']['INL'] = 'インターナショナルフォールズ';
area4['INL'] = 'TC1_1';
area5['INL'] = 'USA';

area6['INL'] = new Object();
area6['INL'] = 'インターナショナルフォールズ';
area3['USA']['ISN'] = 'ウィリストン';
area4['ISN'] = 'TC1_1';
area5['ISN'] = 'USA';

area6['ISN'] = new Object();
area6['ISN'] = 'ウィリストン';
area3['USA']['AVP'] = 'ウィルクスバリ/スクラントン';
area4['AVP'] = 'TC1_1';
area5['AVP'] = 'USA';

area6['AVP'] = new Object();
area6['AVP'] = 'ウィルクスバリ/スクラントン';
area3['USA']['ILM'] = 'ウィルミントン';
area4['ILM'] = 'TC1_1';
area5['ILM'] = 'USA';

area6['ILM'] = new Object();
area6['ILM'] = 'ウィルミントン';
area3['USA']['PBI'] = 'ウェストパームビーチ';
area4['PBI'] = 'TC1_1';
area5['PBI'] = 'USA';

area6['PBI'] = new Object();
area6['PBI'] = 'ウェストパームビーチ';
area3['USA']['ELP'] = 'エルパソ';
area4['ELP'] = 'TC1_1';
area5['ELP'] = 'USA';

area6['ELP'] = new Object();
area6['ELP'] = 'エルパソ';
area3['USA']['ONT'] = 'オンタリオ';
area4['ONT'] = 'TC1_1';
area5['ONT'] = 'USA';

area6['ONT'] = new Object();
area6['ONT'] = 'オンタリオ';
area3['USA']['AZO'] = 'カラマズー';
area4['AZO'] = 'TC1_1';
area5['AZO'] = 'USA';

area6['AZO'] = new Object();
area6['AZO'] = 'カラマズー';
area3['USA']['GPT'] = 'ガルフポート/ビロクシ';
area4['GPT'] = 'TC1_1';
area5['GPT'] = 'USA';

area6['GPT'] = new Object();
area6['GPT'] = 'ガルフポート/ビロクシ';
area3['USA']['EYW'] = 'キーウェスト';
area4['EYW'] = 'TC1_1';
area5['EYW'] = 'USA';

area6['EYW'] = new Object();
area6['EYW'] = 'キーウェスト';
area3['USA']['CPR'] = 'キャスパー';
area4['CPR'] = 'TC1_1';
area5['CPR'] = 'USA';

area6['CPR'] = new Object();
area6['CPR'] = 'キャスパー';
area3['USA']['GFK'] = 'グランドフォークス';
area4['GFK'] = 'TC1_1';
area5['GFK'] = 'USA';

area6['GFK'] = new Object();
area6['GFK'] = 'グランドフォークス';
area3['USA']['GRR'] = 'グランドラピッズ';
area4['GRR'] = 'TC1_1';
area5['GRR'] = 'USA';

area6['GRR'] = new Object();
area6['GRR'] = 'グランドラピッズ';
area3['USA']['GSP'] = 'グリーンビル';
area4['GSP'] = 'TC1_1';
area5['GSP'] = 'USA';

area6['GSP'] = new Object();
area6['GSP'] = 'グリーンビル';
area3['USA']['CLE'] = 'クリーブランド';
area4['CLE'] = 'TC1_1';
area5['CLE'] = 'USA';

area6['CLE'] = new Object();
area6['CLE'] = 'クリーブランド';
area3['USA']['GSO'] = 'グリーンズボロ';
area4['GSO'] = 'TC1_1';
area5['GSO'] = 'USA';

area6['GSO'] = new Object();
area6['GSO'] = 'グリーンズボロ';
area3['USA']['GRB'] = 'グリーンベイ';
area4['GRB'] = 'TC1_1';
area5['GRB'] = 'USA';

area6['GRB'] = new Object();
area6['GRB'] = 'グリーンベイ';
area3['USA']['GTF'] = 'グレートフォールズ';
area4['GTF'] = 'TC1_1';
area5['GTF'] = 'USA';

area6['GTF'] = new Object();
area6['GTF'] = 'グレートフォールズ';
area3['USA']['KTN'] = 'ケチカン';
area4['KTN'] = 'TC1_1';
area5['KTN'] = 'USA';

area6['KTN'] = new Object();
area6['KTN'] = 'ケチカン';
area3['USA']['CRP'] = 'コーパスクリスティ';
area4['CRP'] = 'TC1_1';
area5['CRP'] = 'USA';

area6['CRP'] = new Object();
area6['CRP'] = 'コーパスクリスティ';
area3['USA']['CVG'] = 'コビントン/シンシナティ';
area4['CVG'] = 'TC1_1';
area5['CVG'] = 'USA';

area6['CVG'] = new Object();
area6['CVG'] = 'コビントン/シンシナティ';
area3['USA']['CMH'] = 'コロンバス';
area4['CMH'] = 'TC1_1';
area5['CMH'] = 'USA';

area6['CMH'] = new Object();
area6['CMH'] = 'コロンバス';
area3['USA']['MBS'] = 'サギノー';
area4['MBS'] = 'TC1_1';
area5['MBS'] = 'USA';

area6['MBS'] = new Object();
area6['MBS'] = 'サギノー';
area3['USA']['SMF'] = 'サクラメント';
area4['SMF'] = 'TC1_1';
area5['SMF'] = 'USA';

area6['SMF'] = new Object();
area6['SMF'] = 'サクラメント';
area3['USA']['SAV'] = 'サバンナ';
area4['SAV'] = 'TC1_1';
area5['SAV'] = 'USA';

area6['SAV'] = new Object();
area6['SAV'] = 'サバンナ';
area3['USA']['SRQ'] = 'サラソタ/ブラデントン';
area4['SRQ'] = 'TC1_1';
area5['SRQ'] = 'USA';

area6['SRQ'] = new Object();
area6['SRQ'] = 'サラソタ/ブラデントン';
area3['USA']['SAT'] = 'サンアントニオ';
area4['SAT'] = 'TC1_1';
area5['SAT'] = 'USA';

area6['SAT'] = new Object();
area6['SAT'] = 'サンアントニオ';
area3['USA']['SJC'] = 'サンノゼ';
area4['SJC'] = 'TC1_1';
area5['SJC'] = 'USA';

area6['SJC'] = new Object();
area6['SJC'] = 'サンノゼ';
area3['USA']['CLT'] = 'シャーロット';
area4['CLT'] = 'TC1_1';
area5['CLT'] = 'USA';

area6['CLT'] = new Object();
area6['CLT'] = 'シャーロット';
area3['USA']['JAN'] = 'ジャクソン';
area4['JAN'] = 'TC1_1';
area5['JAN'] = 'USA';

area6['JAN'] = new Object();
area6['JAN'] = 'ジャクソン';
area3['USA']['JAX'] = 'ジャクソンビル';
area4['JAX'] = 'TC1_1';
area5['JAX'] = 'USA';

area6['JAX'] = new Object();
area6['JAX'] = 'ジャクソンビル';
area3['USA']['JNU'] = 'ジュノー';
area4['JNU'] = 'TC1_1';
area5['JNU'] = 'USA';

area6['JNU'] = new Object();
area6['JNU'] = 'ジュノー';
area3['USA']['SNA'] = 'ジョン・ウェイン';
area4['SNA'] = 'TC1_1';
area5['SNA'] = 'USA';

area6['SNA'] = new Object();
area6['SNA'] = 'ジョン・ウェイン';
area3['USA']['CIU'] = 'スーセントマリー';
area4['CIU'] = 'TC1_1';
area5['CIU'] = 'USA';

area6['CIU'] = new Object();
area6['CIU'] = 'スーセントマリー';
area3['USA']['GEG'] = 'スポケーン';
area4['GEG'] = 'TC1_1';
area5['GEG'] = 'USA';

area6['GEG'] = new Object();
area6['GEG'] = 'スポケーン';
area3['USA']['STL'] = 'セントルイス';
area4['STL'] = 'TC1_1';
area5['STL'] = 'USA';

area6['STL'] = new Object();
area6['STL'] = 'セントルイス';
area3['USA']['SLC'] = 'ソルトレイクシティ';
area4['SLC'] = 'TC1_1';
area5['SLC'] = 'USA';

area6['SLC'] = new Object();
area6['SLC'] = 'ソルトレイクシティ';
area3['USA']['DLH'] = 'ダルース';
area4['DLH'] = 'TC1_1';
area5['DLH'] = 'USA';

area6['DLH'] = new Object();
area6['DLH'] = 'ダルース';
area3['USA']['DAL'] = 'ダラス・ラブフィールド';
area4['DAL'] = 'TC1_1';
area5['DAL'] = 'USA';

area6['DAL'] = new Object();
area6['DAL'] = 'ダラス・ラブフィールド';
area3['USA']['TUL'] = 'タルサ';
area4['TUL'] = 'TC1_1';
area5['TUL'] = 'USA';

area6['TUL'] = new Object();
area6['TUL'] = 'タルサ';
area3['USA']['TPA'] = 'タンパ';
area4['TPA'] = 'TC1_1';
area5['TPA'] = 'USA';

area6['TPA'] = new Object();
area6['TPA'] = 'タンパ';
area3['USA']['CHS'] = 'チャールストン';
area4['CHS'] = 'TC1_1';
area5['CHS'] = 'USA';

area6['CHS'] = new Object();
area6['CHS'] = 'チャールストン';
area3['USA']['TUS'] = 'ツーソン';
area4['TUS'] = 'TC1_1';
area5['TUS'] = 'USA';

area6['TUS'] = new Object();
area6['TUS'] = 'ツーソン';
area3['USA']['DAB'] = 'デイトナビーチ';
area4['DAB'] = 'TC1_1';
area5['DAB'] = 'USA';

area6['DAB'] = new Object();
area6['DAB'] = 'デイトナビーチ';
area3['USA']['DAY'] = 'デイトン';
area4['DAY'] = 'TC1_1';
area5['DAY'] = 'USA';

area6['DAY'] = new Object();
area6['DAY'] = 'デイトン';
area3['USA']['DSM'] = 'デモイン';
area4['DSM'] = 'TC1_1';
area5['DSM'] = 'USA';

area6['DSM'] = new Object();
area6['DSM'] = 'デモイン';
area3['USA']['DEN'] = 'デンバー';
area4['DEN'] = 'TC1_1';
area5['DEN'] = 'USA';

area6['DEN'] = new Object();
area6['DEN'] = 'デンバー';
area3['USA']['BNA'] = 'ナッシュビル';
area4['BNA'] = 'TC1_1';
area5['BNA'] = 'USA';

area6['BNA'] = new Object();
area6['BNA'] = 'ナッシュビル';
area3['USA']['EWR'] = 'ニューアーク';
area4['EWR'] = 'TC1_1';
area5['EWR'] = 'USA';

area6['EWR'] = new Object();
area6['EWR'] = 'ニューアーク';
area3['USA']['MSY'] = 'ニューオーリンズ';
area4['MSY'] = 'TC1_1';
area5['MSY'] = 'USA';

area6['MSY'] = new Object();
area6['MSY'] = 'ニューオーリンズ';
area3['USA']['SWF'] = 'ニューバーグ';
area4['SWF'] = 'TC1_1';
area5['SWF'] = 'USA';

area6['SWF'] = new Object();
area6['SWF'] = 'ニューバーグ';
area3['USA']['PHF'] = 'ニューポートニューズ';
area4['PHF'] = 'TC1_1';
area5['PHF'] = 'USA';

area6['PHF'] = new Object();
area6['PHF'] = 'ニューポートニューズ';
area3['USA']['ORF'] = 'ノーフォーク';
area4['ORF'] = 'TC1_1';
area5['ORF'] = 'USA';

area6['ORF'] = new Object();
area6['ORF'] = 'ノーフォーク';
area3['USA']['BDL'] = 'ハートフォード/ウィンザーロックス';
area4['BDL'] = 'TC1_1';
area5['BDL'] = 'USA';

area6['BDL'] = new Object();
area6['BDL'] = 'ハートフォード/ウィンザーロックス';
area3['USA']['BHM'] = 'バーミングハム';
area4['BHM'] = 'TC1_1';
area5['BHM'] = 'USA';

area6['BHM'] = new Object();
area6['BHM'] = 'バーミングハム';
area3['USA']['PSP'] = 'パームスプリングス';
area4['PSP'] = 'TC1_1';
area5['PSP'] = 'USA';

area6['PSP'] = new Object();
area6['PSP'] = 'パームスプリングス';
area3['USA']['HRL'] = 'ハーリンゲン';
area4['HRL'] = 'TC1_1';
area5['HRL'] = 'USA';

area6['HRL'] = new Object();
area6['HRL'] = 'ハーリンゲン';
area3['USA']['BTV'] = 'バーリントン';
area4['BTV'] = 'TC1_1';
area5['BTV'] = 'USA';

area6['BTV'] = new Object();
area6['BTV'] = 'バーリントン';
area3['USA']['BUF'] = 'バッファロー';
area4['BUF'] = 'TC1_1';
area5['BUF'] = 'USA';

area6['BUF'] = new Object();
area6['BUF'] = 'バッファロー';
area3['USA']['MDT'] = 'ハリスバーグ/ミドルタウン';
area4['MDT'] = 'TC1_1';
area5['MDT'] = 'USA';

area6['MDT'] = new Object();
area6['MDT'] = 'ハリスバーグ/ミドルタウン';
area3['USA']['HSV'] = 'ハンツビル';
area4['HSV'] = 'TC1_1';
area5['HSV'] = 'USA';

area6['HSV'] = new Object();
area6['HSV'] = 'ハンツビル';
area3['USA']['PIT'] = 'ピッツバーグ';
area4['PIT'] = 'TC1_1';
area5['PIT'] = 'USA';

area6['PIT'] = new Object();
area6['PIT'] = 'ピッツバーグ';
area3['USA']['HOU'] = 'ヒューストン（ウィリアム・Ｐ・ホビー）';
area4['HOU'] = 'TC1_1';
area5['HOU'] = 'USA';

area6['HOU'] = new Object();
area6['HOU'] = 'ヒューストン（ウィリアム・Ｐ・ホビー）';
area3['USA']['IAH'] = 'ヒューストン（ジョージ・ブッシュ）';
area4['IAH'] = 'TC1_1';
area5['IAH'] = 'USA';

area6['IAH'] = new Object();
area6['IAH'] = 'ヒューストン（ジョージ・ブッシュ）';
area3['USA']['BIL'] = 'ビリングス';
area4['BIL'] = 'TC1_1';
area5['BIL'] = 'USA';

area6['BIL'] = new Object();
area6['BIL'] = 'ビリングス';
area3['USA']['FAR'] = 'ファーゴ';
area4['FAR'] = 'TC1_1';
area5['FAR'] = 'USA';

area6['FAR'] = new Object();
area6['FAR'] = 'ファーゴ';
area3['USA']['FAI'] = 'フェアバンクス';
area4['FAI'] = 'TC1_1';
area5['FAI'] = 'USA';

area6['FAI'] = new Object();
area6['FAI'] = 'フェアバンクス';
area3['USA']['PHX'] = 'フェニックス';
area4['PHX'] = 'TC1_1';
area5['PHX'] = 'USA';

area6['PHX'] = new Object();
area6['PHX'] = 'フェニックス';
area3['USA']['FWA'] = 'フォートウェイン';
area4['FWA'] = 'TC1_1';
area5['FWA'] = 'USA';

area6['FWA'] = new Object();
area6['FWA'] = 'フォートウェイン';
area3['USA']['RSW'] = 'フォートマイヤーズ';
area4['RSW'] = 'TC1_1';
area5['RSW'] = 'USA';

area6['RSW'] = new Object();
area6['RSW'] = 'フォートマイヤーズ';
area3['USA']['FLL'] = 'フォートローダーデール';
area4['FLL'] = 'TC1_1';
area5['FLL'] = 'USA';

area6['FLL'] = new Object();
area6['FLL'] = 'フォートローダーデール';
area3['USA']['BRO'] = 'ブラウンズビル';
area4['BRO'] = 'TC1_1';
area5['BRO'] = 'USA';

area6['BRO'] = new Object();
area6['BRO'] = 'ブラウンズビル';
area3['USA']['FNT'] = 'フリント';
area4['FNT'] = 'TC1_1';
area5['FNT'] = 'USA';

area6['FNT'] = new Object();
area6['FNT'] = 'フリント';
area3['USA']['FAT'] = 'フレズノ';
area4['FAT'] = 'TC1_1';
area5['FAT'] = 'USA';

area6['FAT'] = new Object();
area6['FAT'] = 'フレズノ';
area3['USA']['BLI'] = 'ベリンガム';
area4['BLI'] = 'TC1_1';
area5['BLI'] = 'USA';

area6['BLI'] = new Object();
area6['BLI'] = 'ベリンガム';
area3['USA']['PDX'] = 'ポートランド';
area4['PDX'] = 'TC1_1';
area5['PDX'] = 'USA';

area6['PDX'] = new Object();
area6['PDX'] = 'ポートランド';
area3['USA']['BUR'] = 'ボブ・ホープ';
area4['BUR'] = 'TC1_1';
area5['BUR'] = 'USA';

area6['BUR'] = new Object();
area6['BUR'] = 'ボブ・ホープ';
area3['USA']['MQT'] = 'マーケット';
area4['MQT'] = 'TC1_1';
area5['MQT'] = 'USA';

area6['MQT'] = new Object();
area6['MQT'] = 'マーケット';
area3['USA']['MYR'] = 'マートルビーチ';
area4['MYR'] = 'TC1_1';
area5['MYR'] = 'USA';

area6['MYR'] = new Object();
area6['MYR'] = 'マートルビーチ';
area3['USA']['MOT'] = 'マイノット';
area4['MOT'] = 'TC1_1';
area5['MOT'] = 'USA';

area6['MOT'] = new Object();
area6['MOT'] = 'マイノット';
area3['USA']['MFE'] = 'マッカレン';
area4['MFE'] = 'TC1_1';
area5['MFE'] = 'USA';

area6['MFE'] = new Object();
area6['MFE'] = 'マッカレン';
area3['USA']['MSO'] = 'ミズーラ';
area4['MSO'] = 'TC1_1';
area5['MSO'] = 'USA';

area6['MSO'] = new Object();
area6['MSO'] = 'ミズーラ';
area3['USA']['MAF'] = 'ミッドランド';
area4['MAF'] = 'TC1_1';
area5['MAF'] = 'USA';

area6['MAF'] = new Object();
area6['MAF'] = 'ミッドランド';
area3['USA']['MSP'] = 'ミネアポリス';
area4['MSP'] = 'TC1_1';
area5['MSP'] = 'USA';

area6['MSP'] = new Object();
area6['MSP'] = 'ミネアポリス';
area3['USA']['MKE'] = 'ミルウォーキー';
area4['MKE'] = 'TC1_1';
area5['MKE'] = 'USA';

area6['MKE'] = new Object();
area6['MKE'] = 'ミルウォーキー';
area3['USA']['MFR'] = 'メドフォード';
area4['MFR'] = 'TC1_1';
area5['MFR'] = 'USA';

area6['MFR'] = new Object();
area6['MFR'] = 'メドフォード';
area3['USA']['MLB'] = 'メルボルン';
area4['MLB'] = 'TC1_1';
area5['MLB'] = 'USA';

area6['MLB'] = new Object();
area6['MLB'] = 'メルボルン';
area3['USA']['MEM'] = 'メンフィス';
area4['MEM'] = 'TC1_1';
area5['MEM'] = 'USA';

area6['MEM'] = new Object();
area6['MEM'] = 'メンフィス';
area3['USA']['YUM'] = 'ユマ';
area4['YUM'] = 'TC1_1';
area5['YUM'] = 'USA';

area6['YUM'] = new Object();
area6['YUM'] = 'ユマ';
area3['USA']['LBB'] = 'ラボック';
area4['LBB'] = 'TC1_1';
area5['LBB'] = 'USA';

area6['LBB'] = new Object();
area6['LBB'] = 'ラボック';
area3['USA']['LRD'] = 'ラレド';
area4['LRD'] = 'TC1_1';
area5['LRD'] = 'USA';

area6['LRD'] = new Object();
area6['LRD'] = 'ラレド';
area3['USA']['RIC'] = 'リッチモンド';
area4['RIC'] = 'TC1_1';
area5['RIC'] = 'USA';

area6['RIC'] = new Object();
area6['RIC'] = 'リッチモンド';
area3['USA']['LIT'] = 'リトルロック';
area4['LIT'] = 'TC1_1';
area5['LIT'] = 'USA';

area6['LIT'] = new Object();
area6['LIT'] = 'リトルロック';
area3['USA']['RNO'] = 'リノ';
area4['RNO'] = 'TC1_1';
area5['RNO'] = 'USA';

area6['RNO'] = new Object();
area6['RNO'] = 'リノ';
area3['USA']['SDF'] = 'ルイビル';
area4['SDF'] = 'TC1_1';
area5['SDF'] = 'USA';

area6['SDF'] = new Object();
area6['SDF'] = 'ルイビル';
area3['USA']['RDU'] = 'ローリー';
area4['RDU'] = 'TC1_1';
area5['RDU'] = 'USA';

area6['RDU'] = new Object();
area6['RDU'] = 'ローリー';
area3['USA']['ROC'] = 'ロチェスター(ニューヨーク州)';
area4['ROC'] = 'TC1_1';
area5['ROC'] = 'USA';

area6['ROC'] = new Object();
area6['ROC'] = 'ロチェスター(ニューヨーク州)';
area3['USA']['RST'] = 'ロチェスター(ミネソタ州)';
area4['RST'] = 'TC1_1';
area5['RST'] = 'USA';

area6['RST'] = new Object();
area6['RST'] = 'ロチェスター(ミネソタ州)';
area3['USA']['LGB'] = 'ロングビーチ';
area4['LGB'] = 'TC1_1';
area5['LGB'] = 'USA';

area6['LGB'] = new Object();
area6['LGB'] = 'ロングビーチ';
area3['USA']['JFK'] = 'ニューヨーク（ジョン・Ｆ・ケネディ）';
area4['JFK'] = 'TC1_1';
area5['JFK'] = 'USA';

area6['JFK'] = new Object();
area6['JFK'] = 'ニューヨーク（ジョン・Ｆ・ケネディ）';
area3['USA']['LGA'] = 'ニューヨーク（ラガーディア）';
area4['LGA'] = 'TC1_1';
area5['LGA'] = 'USA';

area6['LGA'] = new Object();
area6['LGA'] = 'ニューヨーク（ラガーディア）';
area3['USA']['MDW'] = 'シカゴ（ミッドウェイ）';
area4['MDW'] = 'TC1_1';
area5['MDW'] = 'USA';

area6['MDW'] = new Object();
area6['MDW'] = 'シカゴ（ミッドウェイ）';
area3['USA']['ORD'] = 'シカゴ（オヘア）';
area4['ORD'] = 'TC1_1';
area5['ORD'] = 'USA';

area6['ORD'] = new Object();
area6['ORD'] = 'シカゴ（オヘア）';
area3['USA']['IAD'] = 'ワシントンD.C.（ダレス）';
area4['IAD'] = 'TC1_1';
area5['IAD'] = 'USA';

area6['IAD'] = new Object();
area6['IAD'] = 'ワシントンD.C.（ダレス）';
area3['USA']['DCA'] = 'ワシントンD.C.（ナショナル）';
area4['DCA'] = 'TC1_1';
area5['DCA'] = 'USA';

area6['DCA'] = new Object();
area6['DCA'] = 'ワシントンD.C.（ナショナル）';
area3['USA']['AUS'] = 'オースティン';
area4['AUS'] = 'TC1_1';
area5['AUS'] = 'USA';

area6['AUS'] = new Object();
area6['AUS'] = 'オースティン';
area3['USA']['BWI'] = 'ボルチモア';
area4['BWI'] = 'TC1_1';
area5['BWI'] = 'USA';

area6['BWI'] = new Object();
area6['BWI'] = 'ボルチモア';
area3['USA']['PHL'] = 'フィラデルフィア';
area4['PHL'] = 'TC1_1';
area5['PHL'] = 'USA';

area6['PHL'] = new Object();
area6['PHL'] = 'フィラデルフィア';
area3['USA']['DTW'] = 'デトロイト（メトロポリタン国際空港）';
area4['DTW'] = 'TC1_1';
area5['DTW'] = 'USA';

area6['DTW'] = new Object();
area6['DTW'] = 'デトロイト（メトロポリタン国際空港）';
area3['USA']['MCO'] = 'オーランド';
area4['MCO'] = 'TC1_1';
area5['MCO'] = 'USA';

area6['MCO'] = new Object();
area6['MCO'] = 'オーランド';
area3['UZB'] = new Object();
area3['UZB']['TAS'] = '★タシケント';
area4['TAS'] = 'TC3_2';
area5['TAS'] = 'UZB';

area6['TAS'] = new Object();
area6['TAS'] = '★タシケント';
area3['UZB']['SKD'] = 'サマルカンド';
area4['SKD'] = 'TC3_2';
area5['SKD'] = 'UZB';

area6['SKD'] = new Object();
area6['SKD'] = 'サマルカンド';
area3['VEN'] = new Object();
area3['VEN']['CCS'] = 'カラカス';
area4['CCS'] = 'TC1_3';
area5['CCS'] = 'VEN';

area6['CCS'] = new Object();
area6['CCS'] = 'カラカス';
area3['VEN']['MAR'] = 'マラカイボ';
area4['MAR'] = 'TC1_3';
area5['MAR'] = 'VEN';

area6['MAR'] = new Object();
area6['MAR'] = 'マラカイボ';
area3['VNM'] = new Object();
area3['VNM']['SGN'] = '★ホーチミン';
area4['SGN'] = 'TC3_2';
area5['SGN'] = 'VNM';

area6['SGN'] = new Object();
area6['SGN'] = '★ホーチミン';
area3['VNM']['HAN'] = '★ハノイ';
area4['HAN'] = 'TC3_2';
area5['HAN'] = 'VNM';

area6['HAN'] = new Object();
area6['HAN'] = '★ハノイ';
area3['VNM']['DAD'] = 'ダナン';
area4['DAD'] = 'TC3_2';
area5['DAD'] = 'VNM';

area6['DAD'] = new Object();
area6['DAD'] = 'ダナン';
area3['VNM']['CXR'] = 'ニャチャン';
area4['CXR'] = 'TC3_2';
area5['CXR'] = 'VNM';

area6['CXR'] = new Object();
area6['CXR'] = 'ニャチャン';
area3['VNM']['HUI'] = 'フエ';
area4['HUI'] = 'TC3_2';
area5['HUI'] = 'VNM';

area6['HUI'] = new Object();
area6['HUI'] = 'フエ';
area3['VNM']['PQC'] = 'フーコック島';
area4['PQC'] = 'TC3_2';
area5['PQC'] = 'VNM';

area6['PQC'] = new Object();
area6['PQC'] = 'フーコック島';
area3['VNM']['HPH'] = 'ハイフォン';
area4['HPH'] = 'TC3_2';
area5['HPH'] = 'VNM';

area6['HPH'] = new Object();
area6['HPH'] = 'ハイフォン';
area3['VNM']['VII'] = 'ヴィン';
area4['VII'] = 'TC3_2';
area5['VII'] = 'VNM';

area6['VII'] = new Object();
area6['VII'] = 'ヴィン';
area3['VNM']['NHA'] = 'ニャチャン';
area4['NHA'] = 'TC3_2';
area5['NHA'] = 'VNM';

area6['NHA'] = new Object();
area6['NHA'] = 'ニャチャン';
area3['VNM']['DLI'] = 'ダラット';
area4['DLI'] = 'TC3_2';
area5['DLI'] = 'VNM';

area6['DLI'] = new Object();
area6['DLI'] = 'ダラット';
area3['VUT'] = new Object();
area3['VUT']['VLI'] = '★ポートピラ';
area4['VLI'] = 'TC3_3';
area5['VLI'] = 'VUT';

area6['VLI'] = new Object();
area6['VLI'] = '★ポートピラ';
area3['WSM'] = new Object();
area3['WSM']['APW'] = '★アビア';
area4['APW'] = 'TC3_3';
area5['APW'] = 'WSM';

area6['APW'] = new Object();
area6['APW'] = '★アビア';
area3['ZAF'] = new Object();
area3['ZAF']['CPT'] = '★ケープ・タウン';
area4['CPT'] = 'TC2_2';
area5['CPT'] = 'ZAF';

area6['CPT'] = new Object();
area6['CPT'] = '★ケープ・タウン';
area3['ZAF']['DUR'] = 'ダーバン';
area4['DUR'] = 'TC2_2';
area5['DUR'] = 'ZAF';

area6['DUR'] = new Object();
area6['DUR'] = 'ダーバン';
area3['ZAF']['JNB'] = '★ヨハネスブルグ';
area4['JNB'] = 'TC2_2';
area5['JNB'] = 'ZAF';

area6['JNB'] = new Object();
area6['JNB'] = '★ヨハネスブルグ';
area3['ZAF']['GRJ'] = 'ジョージ';
area4['GRJ'] = 'TC2_2';
area5['GRJ'] = 'ZAF';

area6['GRJ'] = new Object();
area6['GRJ'] = 'ジョージ';
area3['ZAF']['RCB'] = 'リチャーズベイ';
area4['RCB'] = 'TC2_2';
area5['RCB'] = 'ZAF';

area6['RCB'] = new Object();
area6['RCB'] = 'リチャーズベイ';
area3['ZAF']['UTN'] = 'アピントン';
area4['UTN'] = 'TC2_2';
area5['UTN'] = 'ZAF';

area6['UTN'] = new Object();
area6['UTN'] = 'アピントン';
area3['ZAF']['ELS'] = 'イーストロンドン';
area4['ELS'] = 'TC2_2';
area5['ELS'] = 'ZAF';

area6['ELS'] = new Object();
area6['ELS'] = 'イーストロンドン';
area3['ZAF']['KIM'] = 'キンバリー';
area4['KIM'] = 'TC2_2';
area5['KIM'] = 'ZAF';

area6['KIM'] = new Object();
area6['KIM'] = 'キンバリー';
area3['ZAF']['HDS'] = 'フートスプレイト';
area4['HDS'] = 'TC2_2';
area5['HDS'] = 'ZAF';

area6['HDS'] = new Object();
area6['HDS'] = 'フートスプレイト';
area3['ZAF']['PLZ'] = 'ポートエリザベス';
area4['PLZ'] = 'TC2_2';
area5['PLZ'] = 'ZAF';

area6['PLZ'] = new Object();
area6['PLZ'] = 'ポートエリザベス';
area3['ZIM'] = new Object();
area3['ZIM']['VFA'] = 'ヴィクトリアフォール';
area4['VFA'] = '';
area5['VFA'] = 'ZIM';

area6['VFA'] = new Object();
area6['VFA'] = 'ヴィクトリアフォール';
area3['ZMB'] = new Object();
area3['ZMB']['LUN'] = '★ルサカ';
area4['LUN'] = 'TC2_2';
area5['LUN'] = 'ZMB';

area6['LUN'] = new Object();
area6['LUN'] = '★ルサカ';
area3['ZWE'] = new Object();
area3['ZWE']['HRE'] = '★ハラレ';
area4['HRE'] = 'TC2_2';
area5['HRE'] = 'ZWE';

area6['HRE'] = new Object();
area6['HRE'] = '★ハラレ';
depairPort['TYO'] = new Object();
depairPort['TYO'] = '東京（羽田・成田）';
depairPort['HND'] = new Object();
depairPort['HND'] = '羽田';
depairPort['NRT'] = new Object();
depairPort['NRT'] = '成田';
depairPort['OSA'] = new Object();
depairPort['OSA'] = '大阪（関西・伊丹・神戸）';
depairPort['KIX'] = new Object();
depairPort['KIX'] = '大阪（関西）';
depairPort['ITM'] = new Object();
depairPort['ITM'] = '大阪（伊丹）';
depairPort['NGO'] = new Object();
depairPort['NGO'] = '名古屋（中部）';
depairPort['FUK'] = new Object();
depairPort['FUK'] = '福岡';
depairPort['CTS'] = new Object();
depairPort['CTS'] = '札幌（新千歳）';
depairPort['AKJ'] = new Object();
depairPort['AKJ'] = '旭川';
depairPort['MMB'] = new Object();
depairPort['MMB'] = '女満別';
depairPort['KUH'] = new Object();
depairPort['KUH'] = '釧路';
depairPort['OBO'] = new Object();
depairPort['OBO'] = '帯広';
depairPort['HKD'] = new Object();
depairPort['HKD'] = '函館';
depairPort['AOJ'] = new Object();
depairPort['AOJ'] = '青森';
depairPort['MSJ'] = new Object();
depairPort['MSJ'] = '三沢';
depairPort['AXT'] = new Object();
depairPort['AXT'] = '秋田';
depairPort['SYO'] = new Object();
depairPort['SYO'] = '庄内';
depairPort['SDJ'] = new Object();
depairPort['SDJ'] = '仙台';
depairPort['IBR'] = new Object();
depairPort['IBR'] = '茨城';
depairPort['FSZ'] = new Object();
depairPort['FSZ'] = '静岡';
depairPort['KIJ'] = new Object();
depairPort['KIJ'] = '新潟';
depairPort['TOY'] = new Object();
depairPort['TOY'] = '富山';
depairPort['KMQ'] = new Object();
depairPort['KMQ'] = '小松';
depairPort['UKB'] = new Object();
depairPort['UKB'] = '神戸';
depairPort['SHM'] = new Object();
depairPort['SHM'] = '南紀白浜';
depairPort['TTJ'] = new Object();
depairPort['TTJ'] = '鳥取';
depairPort['YGJ'] = new Object();
depairPort['YGJ'] = '米子';
depairPort['IZO'] = new Object();
depairPort['IZO'] = '出雲';
depairPort['OKJ'] = new Object();
depairPort['OKJ'] = '岡山';
depairPort['HIJ'] = new Object();
depairPort['HIJ'] = '広島';
depairPort['IWK'] = new Object();
depairPort['IWK'] = '岩国';
depairPort['UBJ'] = new Object();
depairPort['UBJ'] = '山口宇部';
depairPort['TAK'] = new Object();
depairPort['TAK'] = '高松';
depairPort['MYJ'] = new Object();
depairPort['MYJ'] = '松山';
depairPort['KCZ'] = new Object();
depairPort['KCZ'] = '高知';
depairPort['KKJ'] = new Object();
depairPort['KKJ'] = '北九州';
depairPort['HSG'] = new Object();
depairPort['HSG'] = '佐賀';
depairPort['KMJ'] = new Object();
depairPort['KMJ'] = '熊本';
depairPort['OIT'] = new Object();
depairPort['OIT'] = '大分';
depairPort['KMI'] = new Object();
depairPort['KMI'] = '宮崎';
depairPort['NGS'] = new Object();
depairPort['NGS'] = '長崎';
depairPort['KOJ'] = new Object();
depairPort['KOJ'] = '鹿児島';
depairPort['OKA'] = new Object();
depairPort['OKA'] = '沖縄（那覇）';
depairPort['MMY'] = new Object();
depairPort['MMY'] = '宮古';
depairPort['ISG'] = new Object();
depairPort['ISG'] = '石垣';
depairPort['HAC'] = new Object();
depairPort['HAC'] = '八丈島';
depairPort['TKS'] = new Object();
depairPort['TKS'] = '徳島';
depairPort['SHI'] = new Object();
depairPort['SHI'] = 'みやこ下地島';
depairPort['SPK'] = new Object();
depairPort['SPK'] = '札幌';
defAirLine['TC3_6'] = new Object();
defAirLine['TC3_6']['AA'] = 'アメリカン航空';
defAirLine['TC3_6']['AC'] = 'エア・カナダ';
defAirLine['TC3_6']['CI'] = 'チャイナエアライン';
defAirLine['TC3_6']['CO'] = 'コバルトエア';
defAirLine['TC3_6']['DL'] = 'デルタ航空';
defAirLine['TC3_6']['HA'] = 'ハワイアン航空';
defAirLine['TC3_6']['JL'] = '日本航空';
defAirLine['TC3_6']['KE'] = '大韓航空';
defAirLine['TC3_6']['NH'] = 'ANA(全日空)';
defAirLine['TC3_6']['OZ'] = 'アシアナ航空';
defAirLine['TC3_6']['UA'] = 'ユナイテッド航空';
defAirLine['TC1_2'] = new Object();
defAirLine['TC1_2']['AA'] = 'アメリカン航空';
defAirLine['TC1_2']['AC'] = 'エア・カナダ';
defAirLine['TC1_2']['AF'] = 'エールフランス';
defAirLine['TC1_2']['AM'] = 'アエロメヒコ航空';
defAirLine['TC1_2']['AZ'] = 'ITAエアウェイズ';
defAirLine['TC1_2']['CA'] = '中国国際航空';
defAirLine['TC1_2']['CI'] = 'チャイナエアライン';
defAirLine['TC1_2']['CO'] = 'コバルトエア';
defAirLine['TC1_2']['DL'] = 'デルタ航空';
defAirLine['TC1_2']['EK'] = 'エミレーツ航空';
defAirLine['TC1_2']['EY'] = 'エティハド航空';
defAirLine['TC1_2']['JJ'] = 'ラタム航空ブラジル';
defAirLine['TC1_2']['JL'] = '日本航空';
defAirLine['TC1_2']['KE'] = '大韓航空';
defAirLine['TC1_2']['KL'] = 'ＫＬＭオランダ航空';
defAirLine['TC1_2']['LX'] = 'スイスインターナショナルエアラインズ';
defAirLine['TC1_2']['MH'] = 'マレーシア航空 ';
defAirLine['TC1_2']['NH'] = 'ANA(全日空)';
defAirLine['TC1_2']['QF'] = 'カンタス航空';
defAirLine['TC1_2']['SQ'] = 'シンガポール航空';
defAirLine['TC1_2']['TK'] = 'ターキッシュエアラインズ';
defAirLine['TC1_2']['UA'] = 'ユナイテッド航空';
defAirLine['TC1_1'] = new Object();
defAirLine['TC1_1']['AA'] = 'アメリカン航空';
defAirLine['TC1_1']['AC'] = 'エア・カナダ';
defAirLine['TC1_1']['AF'] = 'エールフランス';
defAirLine['TC1_1']['AZ'] = 'ITAエアウェイズ';
defAirLine['TC1_1']['CA'] = '中国国際航空';
defAirLine['TC1_1']['CI'] = 'チャイナエアライン';
defAirLine['TC1_1']['CO'] = 'コバルトエア';
defAirLine['TC1_1']['CX'] = 'キャセイパシフィック航空';
defAirLine['TC1_1']['DL'] = 'デルタ航空';
defAirLine['TC1_1']['EK'] = 'エミレーツ航空';
defAirLine['TC1_1']['HA'] = 'ハワイアン航空';
defAirLine['TC1_1']['JL'] = '日本航空';
defAirLine['TC1_1']['KE'] = '大韓航空';
defAirLine['TC1_1']['KL'] = 'ＫＬＭオランダ航空';
defAirLine['TC1_1']['MU'] = '中国東方航空';
defAirLine['TC1_1']['NH'] = 'ANA(全日空)';
defAirLine['TC1_1']['OZ'] = 'アシアナ航空';
defAirLine['TC1_1']['SQ'] = 'シンガポール航空';
defAirLine['TC1_1']['UA'] = 'ユナイテッド航空';
defAirLine['TC2_3'] = new Object();
defAirLine['TC2_3']['AF'] = 'エールフランス';
defAirLine['TC2_3']['AI'] = 'エアーインディア';
defAirLine['TC2_3']['AY'] = 'フィンランド航空';
defAirLine['TC2_3']['AZ'] = 'ITAエアウェイズ';
defAirLine['TC2_3']['BA'] = 'ブリティッシュ・エアウェイズ';
defAirLine['TC2_3']['CA'] = '中国国際航空';
defAirLine['TC2_3']['CX'] = 'キャセイパシフィック航空';
defAirLine['TC2_3']['EK'] = 'エミレーツ航空';
defAirLine['TC2_3']['EY'] = 'エティハド航空';
defAirLine['TC2_3']['JL'] = '日本航空';
defAirLine['TC2_3']['KL'] = 'ＫＬＭオランダ航空';
defAirLine['TC2_3']['LH'] = 'ルフトハンザ航空';
defAirLine['TC2_3']['LX'] = 'スイスインターナショナルエアラインズ';
defAirLine['TC2_3']['MH'] = 'マレーシア航空 ';
defAirLine['TC2_3']['NH'] = 'ANA(全日空)';
defAirLine['TC2_3']['OS'] = 'オーストリア航空 ';
defAirLine['TC2_3']['OZ'] = 'アシアナ航空';
defAirLine['TC2_3']['QR'] = 'カタール航空';
defAirLine['TC2_3']['SK'] = 'スカンジナビア航空';
defAirLine['TC2_3']['SQ'] = 'シンガポール航空';
defAirLine['TC2_3']['SU'] = 'アエロフロートロシア航空';
defAirLine['TC2_3']['TG'] = 'タイ国際航空 ';
defAirLine['TC2_3']['TK'] = 'ターキッシュエアラインズ';
defAirLine['TC2_3']['VN'] = 'ベトナム航空 ';
defAirLine['TC2_3']['VS'] = 'ヴァージン・アトランティック航空';
defAirLine['TC2_2'] = new Object();
defAirLine['TC2_2']['AF'] = 'エールフランス';
defAirLine['TC2_2']['AI'] = 'エアーインディア';
defAirLine['TC2_2']['AY'] = 'フィンランド航空';
defAirLine['TC2_2']['AZ'] = 'ITAエアウェイズ';
defAirLine['TC2_2']['BA'] = 'ブリティッシュ・エアウェイズ';
defAirLine['TC2_2']['CA'] = '中国国際航空';
defAirLine['TC2_2']['CX'] = 'キャセイパシフィック航空';
defAirLine['TC2_2']['EK'] = 'エミレーツ航空';
defAirLine['TC2_2']['EY'] = 'エティハド航空';
defAirLine['TC2_2']['JL'] = '日本航空';
defAirLine['TC2_2']['KL'] = 'ＫＬＭオランダ航空';
defAirLine['TC2_2']['LH'] = 'ルフトハンザ航空';
defAirLine['TC2_2']['LX'] = 'スイスインターナショナルエアラインズ';
defAirLine['TC2_2']['MH'] = 'マレーシア航空 ';
defAirLine['TC2_2']['NH'] = 'ANA(全日空)';
defAirLine['TC2_2']['OS'] = 'オーストリア航空 ';
defAirLine['TC2_2']['OZ'] = 'アシアナ航空';
defAirLine['TC2_2']['QR'] = 'カタール航空';
defAirLine['TC2_2']['SK'] = 'スカンジナビア航空';
defAirLine['TC2_2']['SQ'] = 'シンガポール航空';
defAirLine['TC2_2']['SU'] = 'アエロフロートロシア航空';
defAirLine['TC2_2']['TG'] = 'タイ国際航空 ';
defAirLine['TC2_2']['TK'] = 'ターキッシュエアラインズ';
defAirLine['TC2_2']['VN'] = 'ベトナム航空 ';
defAirLine['TC2_2']['VS'] = 'ヴァージン・アトランティック航空';
defAirLine['TC2_4'] = new Object();
defAirLine['TC2_4']['AF'] = 'エールフランス';
defAirLine['TC2_4']['AZ'] = 'ITAエアウェイズ';
defAirLine['TC2_4']['BA'] = 'ブリティッシュ・エアウェイズ';
defAirLine['TC2_4']['CX'] = 'キャセイパシフィック航空';
defAirLine['TC2_4']['EK'] = 'エミレーツ航空';
defAirLine['TC2_4']['EY'] = 'エティハド航空';
defAirLine['TC2_4']['JL'] = '日本航空';
defAirLine['TC2_4']['KL'] = 'ＫＬＭオランダ航空';
defAirLine['TC2_4']['LH'] = 'ルフトハンザ航空';
defAirLine['TC2_4']['LX'] = 'スイスインターナショナルエアラインズ';
defAirLine['TC2_4']['MH'] = 'マレーシア航空 ';
defAirLine['TC2_4']['NH'] = 'ANA(全日空)';
defAirLine['TC2_4']['OS'] = 'オーストリア航空 ';
defAirLine['TC2_4']['OZ'] = 'アシアナ航空';
defAirLine['TC2_4']['QR'] = 'カタール航空';
defAirLine['TC2_4']['SQ'] = 'シンガポール航空';
defAirLine['TC2_4']['SU'] = 'アエロフロートロシア航空';
defAirLine['TC2_4']['TG'] = 'タイ国際航空 ';
defAirLine['TC2_4']['TK'] = 'ターキッシュエアラインズ';
defAirLine['TC2_5'] = new Object();
defAirLine['TC2_5']['AF'] = 'エールフランス';
defAirLine['TC2_5']['AZ'] = 'ITAエアウェイズ';
defAirLine['TC2_5']['BA'] = 'ブリティッシュ・エアウェイズ';
defAirLine['TC2_5']['CX'] = 'キャセイパシフィック航空';
defAirLine['TC2_5']['EK'] = 'エミレーツ航空';
defAirLine['TC2_5']['EY'] = 'エティハド航空';
defAirLine['TC2_5']['JL'] = '日本航空';
defAirLine['TC2_5']['KL'] = 'ＫＬＭオランダ航空';
defAirLine['TC2_5']['LH'] = 'ルフトハンザ航空';
defAirLine['TC2_5']['LX'] = 'スイスインターナショナルエアラインズ';
defAirLine['TC2_5']['MH'] = 'マレーシア航空 ';
defAirLine['TC2_5']['NH'] = 'ANA(全日空)';
defAirLine['TC2_5']['OS'] = 'オーストリア航空 ';
defAirLine['TC2_5']['OZ'] = 'アシアナ航空';
defAirLine['TC2_5']['SA'] = '南アフリカ航空';
defAirLine['TC2_5']['SQ'] = 'シンガポール航空';
defAirLine['TC2_5']['TG'] = 'タイ国際航空 ';
defAirLine['TC2_5']['TK'] = 'ターキッシュエアラインズ';
defAirLine['TC2_1'] = new Object();
defAirLine['TC2_1']['AF'] = 'エールフランス';
defAirLine['TC2_1']['AI'] = 'エアーインディア';
defAirLine['TC2_1']['AY'] = 'フィンランド航空';
defAirLine['TC2_1']['AZ'] = 'ITAエアウェイズ';
defAirLine['TC2_1']['BA'] = 'ブリティッシュ・エアウェイズ';
defAirLine['TC2_1']['CA'] = '中国国際航空';
defAirLine['TC2_1']['CX'] = 'キャセイパシフィック航空';
defAirLine['TC2_1']['EK'] = 'エミレーツ航空';
defAirLine['TC2_1']['EY'] = 'エティハド航空';
defAirLine['TC2_1']['JL'] = '日本航空';
defAirLine['TC2_1']['KL'] = 'ＫＬＭオランダ航空';
defAirLine['TC2_1']['LH'] = 'ルフトハンザ航空';
defAirLine['TC2_1']['LX'] = 'スイスインターナショナルエアラインズ';
defAirLine['TC2_1']['MH'] = 'マレーシア航空 ';
defAirLine['TC2_1']['MU'] = '中国東方航空';
defAirLine['TC2_1']['NH'] = 'ANA(全日空)';
defAirLine['TC2_1']['OS'] = 'オーストリア航空 ';
defAirLine['TC2_1']['OZ'] = 'アシアナ航空';
defAirLine['TC2_1']['QR'] = 'カタール航空';
defAirLine['TC2_1']['SK'] = 'スカンジナビア航空';
defAirLine['TC2_1']['SQ'] = 'シンガポール航空';
defAirLine['TC2_1']['SU'] = 'アエロフロートロシア航空';
defAirLine['TC2_1']['TG'] = 'タイ国際航空 ';
defAirLine['TC2_1']['TK'] = 'ターキッシュエアラインズ';
defAirLine['TC2_1']['VN'] = 'ベトナム航空 ';
defAirLine['TC2_1']['VS'] = 'ヴァージン・アトランティック航空';
defAirLine['TC3_1'] = new Object();
defAirLine['TC3_1']['AI'] = 'エアーインディア';
defAirLine['TC3_1']['BR'] = 'エバー航空';
defAirLine['TC3_1']['CA'] = '中国国際航空';
defAirLine['TC3_1']['CI'] = 'チャイナエアライン';
defAirLine['TC3_1']['CX'] = 'キャセイパシフィック航空';
defAirLine['TC3_1']['CZ'] = '中国南方航空';
defAirLine['TC3_1']['DL'] = 'デルタ航空';
defAirLine['TC3_1']['EY'] = 'エティハド航空';
defAirLine['TC3_1']['FM'] = '上海航空';
defAirLine['TC3_1']['HX'] = '香港航空';
defAirLine['TC3_1']['JL'] = '日本航空';
defAirLine['TC3_1']['KE'] = '大韓航空';
defAirLine['TC3_1']['LJ'] = 'ジンエアー';
defAirLine['TC3_1']['MU'] = '中国東方航空';
defAirLine['TC3_1']['NH'] = 'ANA(全日空)';
defAirLine['TC3_1']['OM'] = 'MIATモンゴル航空';
defAirLine['TC3_1']['OZ'] = 'アシアナ航空';
defAirLine['TC3_1']['SC'] = '山東航空';
defAirLine['TC3_1']['UA'] = 'ユナイテッド航空';
defAirLine['TC3_1']['UO'] = '香港エクスプレス(荷物20kg込み)';
defAirLine['TC3_1']['VN'] = 'ベトナム航空 ';
defAirLine['TC3_2'] = new Object();
defAirLine['TC3_2']['AI'] = 'エアーインディア';
defAirLine['TC3_2']['CA'] = '中国国際航空';
defAirLine['TC3_2']['CI'] = 'チャイナエアライン';
defAirLine['TC3_2']['CX'] = 'キャセイパシフィック航空';
defAirLine['TC3_2']['DL'] = 'デルタ航空';
defAirLine['TC3_2']['EK'] = 'エミレーツ航空';
defAirLine['TC3_2']['EY'] = 'エティハド航空';
defAirLine['TC3_2']['HX'] = '香港航空';
defAirLine['TC3_2']['JL'] = '日本航空';
defAirLine['TC3_2']['KE'] = '大韓航空';
defAirLine['TC3_2']['MH'] = 'マレーシア航空 ';
defAirLine['TC3_2']['MU'] = '中国東方航空';
defAirLine['TC3_2']['NH'] = 'ANA(全日空)';
defAirLine['TC3_2']['OZ'] = 'アシアナ航空';
defAirLine['TC3_2']['PR'] = 'フィリピン航空';
defAirLine['TC3_2']['SQ'] = 'シンガポール航空';
defAirLine['TC3_2']['SU'] = 'アエロフロートロシア航空';
defAirLine['TC3_2']['TG'] = 'タイ国際航空 ';
defAirLine['TC3_2']['UA'] = 'ユナイテッド航空';
defAirLine['TC3_2']['UO'] = '香港エクスプレス(荷物20kg込み)';
defAirLine['TC3_2']['VN'] = 'ベトナム航空 ';
defAirLine['TC3_3'] = new Object();
defAirLine['TC3_3']['AI'] = 'エアーインディア';
defAirLine['TC3_3']['CA'] = '中国国際航空';
defAirLine['TC3_3']['CX'] = 'キャセイパシフィック航空';
defAirLine['TC3_3']['EK'] = 'エミレーツ航空';
defAirLine['TC3_3']['EY'] = 'エティハド航空';
defAirLine['TC3_3']['HX'] = '香港航空';
defAirLine['TC3_3']['JL'] = '日本航空';
defAirLine['TC3_3']['KE'] = '大韓航空';
defAirLine['TC3_3']['MH'] = 'マレーシア航空 ';
defAirLine['TC3_3']['MU'] = '中国東方航空';
defAirLine['TC3_3']['NH'] = 'ANA(全日空)';
defAirLine['TC3_3']['OZ'] = 'アシアナ航空';
defAirLine['TC3_3']['SQ'] = 'シンガポール航空';
defAirLine['TC3_3']['SU'] = 'アエロフロートロシア航空';
defAirLine['TC3_3']['TG'] = 'タイ国際航空 ';
defAirLine['TC3_3']['TK'] = 'ターキッシュエアラインズ';
defAirLine['TC3_5'] = new Object();
defAirLine['TC3_5']['CA'] = '中国国際航空';
defAirLine['TC3_5']['CX'] = 'キャセイパシフィック航空';
defAirLine['TC3_5']['JL'] = '日本航空';
defAirLine['TC3_5']['KE'] = '大韓航空';
defAirLine['TC3_5']['MH'] = 'マレーシア航空 ';
defAirLine['TC3_5']['MU'] = '中国東方航空';
defAirLine['TC3_5']['NZ'] = 'ニュージーランド航空';
defAirLine['TC3_5']['OZ'] = 'アシアナ航空';
defAirLine['TC3_5']['PX'] = 'ニューギニア航空';
defAirLine['TC3_5']['QF'] = 'カンタス航空';
defAirLine['TC3_5']['SQ'] = 'シンガポール航空';
defAirLine['TC3_5']['TG'] = 'タイ国際航空 ';
defAirLine['TC3_5']['VN'] = 'ベトナム航空 ';
defAirLine['TC3_7'] = new Object();
defAirLine['TC3_7']['CX'] = 'キャセイパシフィック航空';
defAirLine['TC3_7']['JL'] = '日本航空';
defAirLine['TC3_7']['KE'] = '大韓航空';
defAirLine['TC3_7']['NZ'] = 'ニュージーランド航空';
defAirLine['TC3_7']['PX'] = 'ニューギニア航空';
defAirLine['TC3_7']['QF'] = 'カンタス航空';
defAirLine['TC3_7']['SB'] = 'エアカラン';
defAirLine['TC3_7']['TN'] = 'エア・タヒチ・ヌイ';
defAirLine['TC3_4'] = new Object();
defAirLine['TC3_4']['KE'] = '大韓航空';
defAirLine['TC3_4']['OZ'] = 'アシアナ航空';
defAirLine['TC3_4']['SU'] = 'アエロフロートロシア航空';
defAirLine['TC3_4']['TK'] = 'ターキッシュエアラインズ';
$(function() {

    var holidays = [];

    $("#dep_date1").datepicker({
      maxDate: '330d',
        numberOfMonths: [1,2],
        beforeShowDay: function(date) {

            for (var i = 0; i < holidays.length; i++) {
                var htime = Date.parse(holidays[i]);
                var holiday = new Date();
                holiday.setTime(htime);

                if (holiday.getYear() == date.getYear() &&
                    holiday.getMonth() == date.getMonth() &&
                    holiday.getDate() == date.getDate()) {
                    return [true, 'holiday'];
                }
            }
            if (date.getDay() == 0) {
                return [true, 'sunday'];
            }
            if (date.getDay() == 6) {
                return [true, 'saturday'];
            }
            return [true, ''];
        },
        onSelect: function(dateText, inst) {

			$("#date_val").val(dateText);
			if(Date.parse(document.getElementById("dep_date1").value) >= Date.parse(document.getElementById("dep_date2").value)){

				var dep_date1	= new Date(document.getElementById("dep_date1").value);
				var dep_date2	= new Date(dep_date1.getFullYear(),dep_date1.getMonth(),dep_date1.getDate() + 3);


				document.getElementById("dep_date2").value	= dep_date2.getFullYear() + "/" + (("0"+ (dep_date2.getMonth() + 1)).slice(-2)) + "/" + (("0"+ (dep_date2.getDate())).slice(-2));


			}
        }
    });
    $("#dep_date2").datepicker({
      maxDate: '330d',
        numberOfMonths: [1,2],
        beforeShowDay: function(date) {
            for (var i = 0; i < holidays.length; i++) {
                var htime = Date.parse(holidays[i]);
                var holiday = new Date();
                holiday.setTime(htime);

                if (holiday.getYear()  == date.getYear() &&
                    holiday.getMonth() == date.getMonth() &&
                    holiday.getDate()  == date.getDate()) {
                    return [true, 'holiday'];
                }
            }
            if (date.getDay() == 0) {
                return [true, 'sunday'];
            }
            if (date.getDay() == 6) {
                return [true, 'saturday'];
            }
            return [true, ''];
        },
        onSelect: function(dateText, inst) {
			$("#date_val").val(dateText);
			if(Date.parse(document.getElementById("dep_date1").value) >= Date.parse(document.getElementById("dep_date2").value)){

				var dep_date2	= new Date(document.getElementById("dep_date2").value);
				var dep_date1	= new Date(dep_date2.getFullYear(),dep_date2.getMonth(),dep_date2.getDate() - 3);

				document.getElementById("dep_date1").value	= dep_date1.getFullYear() + "/" + (("0"+ (dep_date1.getMonth() + 3)).slice(-2)) + "/" + (("0"+ (dep_date1.getDate())).slice(-2));


			}
        }
    });

});

var sales_start_limit = 8;